<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_showInvoiceReceipts">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{getLanguage["ACT"]["IREC"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton class="float-right" @click="bool_showInvoiceReceipts = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class="subHeaderHR"></div>
                                <div class="modal-main-content px-0 d-flex justify-content-center">
                                    <div style="width: 100%; overflow-x: auto !important;">
                                        <table class="custom-table custom-table-inPopUp afb-blue">
                                            <thead>
                                                <tr>
                                                    <th style="width:60px;">{{getLanguage["GL"]["NO"]}}</th>
                                                    <th style="width:60px;" v-if="bool_canEdit">{{getLanguage["LOGRPT"]["ACT"]}}</th>
                                                    <th style="width:calc(100% - 280px);">{{getLanguage["MTA"]["RURL"]}}</th>
                                                    <th style="width:calc(100% - 280px);">Currency</th>
                                                    <th style="width:calc(100% - 280px);">Paid Amount</th>
                                                    <th style="width:200px;">{{getLanguage["GL"]["CT"]}}</th>
                                                    <th style="width:200px;">{{getLanguage["GL"]["CB"]}}</th>
                                                    <th style="text-align: left; max-width: 200px;">{{getLanguage['MEM']['RMK']}}</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="receipts && receipts.length > 0">
                                                <tr v-for="(receipt, index) in receipts" :key="index">
                                                    <td>{{ index + 1 }}</td>
                                                    <td v-if="bool_canEdit">
                                                        <div class="custom_tooltip">
                                                            <i class="cil-trash" @click="deleteReceipt(receipt.I)"></i>
                                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <a :href="receipt.IURL" target="_blank" style="max-width: 200px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                            {{ receipt.IURL }}
                                                        </a>
                                                    </td>
                                                    <td>{{ getCurrencyLabel(receipt.CI.toString()) }}</td>
                                                    <td>{{ formatNumber(receipt.PA, 2) }}</td>
                                                    <td>{{ formatDateTime(receipt.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                    <td>{{ receipt.UB }}</td>
                                                    <td style="max-width: 200px;">{{ receipt.RMK }}</td>
                                                </tr>
                                            </tbody>
                                            <tbody v-else>
                                                <tr>
                                                    <td colspan="5" style="text-align: center;">{{ getLanguage["GL"]["NR"] }}</td>
                                                </tr>
                                            </tbody>
                                            <CButton color="outline-dark" size="sm"
                                                     @click="calculateAndInsertTotals">
                                                {{getLanguage["ACT"]["SD"]}}
                                            </CButton>
                                        </table>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_Preview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div>
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}} {{ str_yearmonth }} {{getLanguage["AD"]["IN"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="bool_Preview =!bool_Preview">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class="modal-main-content px-0">
                                    <div style="width: 99%; max-width: 21cm; min-height: 29.7cm; padding: .5cm; margin: 0.5cm 0; border: 1px #D3D3D3 solid; border-radius: 5px; background: white; box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); font-size: 12px;">
                                        <div class="image-container" style="margin-top:10px;">
                                            <img class="image-left" src="https://d2lcoivv20vty7.cloudfront.net/Content/media/poweredby/poweredbyAFBGG_black.png" alt="GG icon">
                                            <img class="image-right" src="https://d2lcoivv20vty7.cloudfront.net/Content/media/background/accounting_demo.png" alt="address">
                                        </div>

                                        <div class="invoice-container">
                                            <div class="left-section">
                                                <h6 class="font-weight-bold">{{getLanguage["ACT"]["IT"]}}</h6>
                                                <p class="recipient-name">{{obj_agentInfo.GN}}</p>
                                                <p><strong>P :</strong> <span>-</span></p>
                                                <p><strong>E :</strong> <span>-</span></p>
                                            </div>
                                            <div class="right-section">
                                                <h1 class="text-uppercase" style="letter-spacing:10px">{{getLanguage["ACT"]["INV"]}}</h1>
                                                <div class="invoice-details">
                                                    <p><strong>{{this.getLanguage["ACT"]["IN"]}}</strong> <span class="ml-2">{{obj_MaintainAccountingMain.IN}}</span></p>
                                                    <p><strong>{{this.getLanguage["HEA"]["AC"]}}</strong> <span class="ml-2">-</span></p>
                                                    <p><strong>{{this.getLanguage["ACT"]["ID"]}}</strong> <span class="ml-2">{{ getFormattedInvoiceDate() }}</span></p>
                                                </div>
                                            </div>
                                        </div>
                                        <table class="custom-table afb-blue">
                                            <thead>
                                                <tr style="background-color: #106c34 !important; color: white;">
                                                    <th style="background-color: #106c34 !important; color: white !important;">{{getLanguage["AFF"]["NO"]}}</th>
                                                    <th style="background-color: #106c34 !important; color: white !important;">{{getLanguage["ACT"]["IDES"]}}</th>
                                                    <th class="text-center" style="background-color: #106c34 !important; color: white !important;">{{getLanguage["ACT"]["QTY"]}}</th>
                                                    <th style="background-color: #106c34 !important; color: white !important;">{{getLanguage["ACT"]["CUR"]}}</th>
                                                    <th style="background-color: #106c34 !important; color: white !important; text-align: right;">{{getLanguage["ACT"]["UP"]}}</th>
                                                    <th style="background-color: #106c34 !important; color: white !important; text-align: right;">{{getLanguage["ACT"]["ER"]}}</th>
                                                    <th style="background-color: #106c34 !important; color: white !important; text-align:right;">{{getLanguage["MTA"]["FTA"]}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in obj_SavedMaintainInfo" :key="item.id" v-if="item.ISI === 1">
                                                    <td v-if="item.ISI === 1">
                                                        {{ getDisplayIndex(index) }}
                                                    </td>
                                                    <td>{{ item.IDT }}</td>
                                                    <td class="text-center">
                                                        <template>
                                                            {{ item.QT }}
                                                        </template>
                                                    </td>
                                                    <td>{{ item.ISOC }}</td>
                                                    <td class="tableCtnRight" :class="{'positive-number': item.AMT >= 0, 'negative-number': item.AMT < 0}">
                                                        <template>
                                                            {{ formatNumber(item.AMT, 2) }}
                                                        </template>
                                                    </td>
                                                    <td class="tableCtnRight">
                                                        <template v-if="item.ER === 1.0000 || item.ER === 1000.0000">
                                                            {{ formatNumber(item.ER, 2) }}
                                                        </template>
                                                        <template v-else>
                                                            {{ formatNumber(item.ER, 8).replace(/\.?0+$/, '') }}
                                                        </template>
                                                    </td>
                                                    <td :class="{'positive-number': item.ICTB === 0 || item.ER * item.QT * item.AMT >= 0, 'negative-number': item.ICTB !== 0 && item.ER * item.QT * item.AMT < 0, 'tableCtnRight': true}">
                                                        <span v-if="item.ICTB === 0">{{formatNumber(0,2) }}</span>
                                                        <span v-else>
                                                            {{ item.ER * item.QT * item.AMT < 0 ? '-' : '' }}{{ formatNumber(Math.abs(item.ER * item.QT * item.AMT), 2) }}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table class="invoice-table">
                                            <tr>
                                                <td class="w-50"></td>
                                                <td class="right-section">
                                                    <table class="details-table">
                                                        <tr v-for="(account, index) in sortedMaintainAccountingPreview">
                                                            <td class="details-label">
                                                                <strong>{{getLanguage["ACT"]["SUB"]}} ({{ getCurrencyLabel(account.CI.toString()) }}) :</strong>
                                                            </td>
                                                            <td class="details-value font-weight-bold">
                                                                <span :class="carryForwardxpaidAmount[account.CI.toString()] >= 0 ? 'positive-number' : 'negative-number'">
                                                                    {{ carryForwardxpaidAmount[account.CI.toString()] < 0 ? '-' : '' }}{{ formatNumber(Math.abs(carryForwardxpaidAmount[account.CI.toString()]), 2) }}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="details-label">
                                                                <strong>{{getLanguage["ACT"]["TR"]}} :</strong>
                                                            </td>
                                                            <td class="details-value font-weight-bold">
                                                                <strong>{{ formatNumber(0,2)}}%</strong>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="details-label">
                                                                <strong>{{getLanguage["FR"]["O"]}} :</strong>
                                                            </td>
                                                            <td class="details-value font-weight-bold">
                                                                <strong>{{ formatNumber(0,2) }}</strong>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>

                                        <table class="total-due-grand-total-table">
                                            <tr class="total-due-row" v-for="(account, index) in sortedMaintainAccountingPreview">
                                                <td class="total-due-cell w-50">
                                                    <strong class="total-due-label text-uppercase">{{getLanguage["ACT"]["TDUE"]}} ({{ getCurrencyLabel(account.CI.toString()) }})</strong>
                                                    <strong :class="carryForwardxpaidAmount[account.CI.toString()] >= 0 ? 'positive-number font-weight-bold mr-3' : 'negative-number font-weight-bold mr-3'">
                                                        {{ carryForwardxpaidAmount[account.CI.toString()] < 0 ? '-' : '' }}{{ formatNumber(Math.abs(carryForwardxpaidAmount[account.CI.toString()]), 2) }}
                                                    </strong>
                                                </td>
                                                <td class="grand-total-cell w-50">
                                                    <strong class="grand-total-label text-uppercase">{{getLanguage["ACT"]["GTOT"]}} ({{ getCurrencyLabel(account.CI.toString()) }})</strong>
                                                    <span :class="carryForwardxpaidAmount[account.CI.toString()] >= 0 ? 'positive-number font-weight-bold' : 'negative-number font-weight-bold'">
                                                        {{ carryForwardxpaidAmount[account.CI.toString()] < 0 ? '-' : '' }}{{ formatNumber(Math.abs(carryForwardxpaidAmount[account.CI.toString()]), 2) }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </table>

                                        <div class="payment-section">
                                            <div class="payment-header">
                                                <div class="payment-header-left">
                                                    <div class="payment-method">
                                                        <p>{{getLanguage["ACT"]["PMWA"]}}</p>
                                                        <span>-</span>
                                                    </div>
                                                </div>
                                                <div class="payment-header-right">
                                                    <div class="account-manager">
                                                        <p>{{getLanguage["ACT"]["AM"]}}</p>
                                                        <span>-</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="separator"></div>
                                        </div>
                                        <div class="payment-thanks mt-3">
                                            <p>{{getLanguage["ACT"]["TYFYB"]}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div style="text-align:center;margin-top:20px" v-if="obj_MaintainAccountingMain.RS == 2">
                                    <CButton color="outline-primary" size="sm" @click="confirmGenerateInvoice(3)">
                                        <span class='plusIcon cil-lock-locked'></span>
                                        {{getLanguage["ACT"]["GI"]}}
                                    </CButton>
                                </div>

                                <!--<div style="text-align:center;margin-top:20px" v-if="obj_MaintainAccountingMain.RS == 3">
                                    <CButton color="outline-primary" size="sm" @click="confirmGenerateInvoice(3)">
                                        <span class='plusIcon cil-lock-locked'></span>
                                        Adjust Invoice
                                    </CButton>
                                </div>-->

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isAgentSuspendV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 600px">
                        <CCard>
                            <CCardBody class="modal-body p-3" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{getLanguage['AG']['ASS']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="close3">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>

                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{getLanguage["AG"]["SSR"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_suspendreason"
                                                    :placeholder="getLanguage['AG']['SSR']"
                                                    v-model="obj_Suspend.reason"
                                                    :limit="1"
                                                    :limitText="count => `+${count}`" />
                                    </CCol>
                                </CRow>
                                <CRow v-if="obj_Suspend.reason==999">
                                    <CCol col="12">
                                        <CInput class="margint10" :placeholder="getLanguage['AG']['SSR']" size="sm" :value="obj_Suspend.reason2" @change="v => obj_Suspend.reason2 = v" :disabled="obj_Suspend.reason!=999" maxlength="300"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <span class="ErrMsg">{{ ValidationBlackListErrMsg('reason2') }}</span>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:10px">
                                    <CButton color="outline-info" size="sm" @click="saveSuspend()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_showNewSupport">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 650px">
                        <CCard>
                            <CCardBody class="modal-body p-3">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0" v-if="requestSupportType == 1">{{getLanguage["AG"]["C"]}} -  {{getLanguage["BTN"]["AR"]}}</h4>
                                        <h4 id="traffic" class="card-title mb-0" v-if="requestSupportType == 2">{{getLanguage["AG"]["L"]}} -  {{getLanguage["BTN"]["AR"]}}</h4>
                                        <h4 id="traffic" class="card-title mb-0" v-if="requestSupportType == 3">{{getLanguage["AG"]["GP"]}} -  {{getLanguage["BTN"]["AR"]}}</h4>
                                        <h4 id="traffic" class="card-title mb-0" v-if="requestSupportType == 4">{{getLanguage["MTA"]["PG"]}} -  {{getLanguage["BTN"]["AR"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_showNewSupport = !bool_showNewSupport">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="12">
                                            <label class="col-form-label-sm"> {{getLanguage['GL']['AGT']}}:</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroup"
                                                              :defaultExpandLevel="Infinity"
                                                              @input="selectEditAgentOptions"
                                                              :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                              v-model="obj_AGI.AGI" disabled />
                                        </CCol>
                                        <CCol col="12" v-if="requestSupportType == 1">
                                            <label class="col-form-label-sm">{{getLanguage["AG"]["C"]}}<span class="required" /> <span class="badge badge-success mx-2" style="background: #027202" v-if="obj_AGI.CI!=null && obj_AGI.CI.length > 0">{{obj_AGI.CI.length}}</span>:</label>
                                            <div class="card p-2 tempScrollbar" style="height: 250px; overflow: hidden scroll;">
                                                <div class="row">
                                                    <div class="col-md-4" v-for="cur in dd_currency_wall[0].children">
                                                        <div class="d-flex">
                                                            <input type="checkbox" class="inline custom-checkbox" v-model="obj_AGI.RCI" :value="cur.id" :disabled="obj_agentInfo.CurrencyIds.includes(cur.id)" />
                                                            <label class="col-form-label-sm font-weight-bold ml-2">{{cur.label}}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </CCol>
                                        <CCol col="12" v-if="requestSupportType == 2">
                                            <label class="col-form-label-sm">{{getLanguage["AG"]["L"]}} <span class="badge badge-success mx-2" style="background: #027202" v-if="obj_AGI.LI!=null&&obj_AGI.LI.length > 0">{{obj_AGI.LI.length}}</span>:</label>
                                            <div class="card p-2 tempScrollbar" style="height: 250px; overflow: hidden scroll;">
                                                <div class="row">
                                                    <div class="col-md-4" v-for="lang in dd_language_wall[0].children">
                                                        <div class="d-flex">
                                                            <input type="checkbox" class="inline custom-checkbox" v-model="obj_AGI.RLI" :value="lang.id" :disabled="obj_agentInfo.Language.includes(lang.id)" />
                                                            <label class="col-form-label-sm font-weight-bold ml-2">{{lang.label}}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </CCol>
                                        <CCol col="12" v-if="requestSupportType == 3">
                                            <label class="col-form-label-sm">
                                                {{getLanguage["AG"]["GP"]}}
                                                <div class="custom_tooltip">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="tooltiptext2" style="width: 120px; bottom: -5px; left: 20px;"><span class="mandatory_Field">**</span> = {{getLanguage["WLRPT"]["SA"]}} {{getLanguage["AFF"]["BN"]}}</span>
                                                </div>
                                                <span class="required" />
                                            </label>

                                            <div class="nav nav-tabs" id="nav-tab" role="tablist" style="font-size:11px">
                                                <button :class="(selectedGPCat == '0-'+item.id)? 'p-2 nav-link active' : 'p-2 nav-link'" @click="selectedGPCat = '0-'+item.id" v-for="(item, index) in dd_gameprovider_cat" :key="index">{{ renderCategoryName(item.label) }}</button>
                                            </div>
                                            <div class="card tab-content p-2 tempScrollbar" style="height: 300px; overflow: hidden scroll;">
                                                <div :class="item.id == selectedGPCat ? 'tab-pane fade active show': 'tab-pane fade'" :id="'gp0-'+catIdx" v-for="(item, catIdx) in dd_gameprovider">
                                                    <div class="row">
                                                        <div class="col-md-6" v-for="gp in item.children" v-if="constHouseBrand.includes(gp.id)">
                                                            <div class="d-flex">
                                                                <input type="checkbox" class="inline custom-checkbox" v-model="obj_AGI.RGPI" :value="gp.id" disabled />
                                                                <label class="col-form-label-sm font-weight-bold ml-2">{{gp.label}} </label><span class="mandatory_Field">**</span>
                                                                <label class="col-form-label-sm font-weight-bold ml-2" style='color: #3c4b64; font-size: smaller; font-weight: 600;'>{{ formatEstimatePT(gp.id, obj_agentInfo.DPT == null || obj_agentInfo.DPT == "" ? obj_agentInfo.MaxPT : obj_agentInfo.DPT) }} </label>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6" v-for="gp in item.children" v-if="!constHouseBrand.includes(gp.id)">
                                                            <div class="d-flex">
                                                                <input type="checkbox" class="inline custom-checkbox" v-model="obj_AGI.RGPI" :value="gp.id" :disabled="obj_agentInfo.GameProviderIds.includes(gp.id)" />
                                                                <label class="col-form-label-sm font-weight-bold ml-2">{{gp.label}} </label>
                                                                <label class="col-form-label-sm font-weight-bold ml-2" style='color: #3c4b64; font-size: smaller; font-weight: 600;'>{{ formatEstimatePT(gp.id, obj_agentInfo.DPT == null || obj_agentInfo.DPT == "" ? obj_agentInfo.MaxPT : obj_agentInfo.DPT) }} </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:10px" v-if="requestSupportType == 1">
                                    <CButton color="outline-info" size="sm" @click="saveNewSupportCurrency()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{getLanguage["BTN"]["SEND"]}}
                                    </CButton>
                                </div>
                                <div style="text-align:center;margin-top:10px" v-if="requestSupportType == 2">
                                    <CButton color="outline-info" size="sm" @click="saveNewSupportLanguage()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{getLanguage["BTN"]["SEND"]}}
                                    </CButton>
                                </div>
                                <div style="text-align:center;margin-top:10px" v-if="requestSupportType == 3 && checkModuleAccess('ASS', 'AGS', constAccessType.edit)">
                                    <CButton color="outline-info" size="sm" @click="saveNewSupportGP()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{getLanguage["BTN"]["SEND"]}}
                                    </CButton>
                                </div>
                                <div style="text-align:center;margin-top:10px" v-if="requestSupportType == 4">
                                    <CButton color="outline-info" size="sm" @click="saveNewSupportType()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{getLanguage["BTN"]["SEND"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_showDomainList">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 600px">
                        <CCard>
                            <CCardBody class="modal-body p-3" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{getLanguage['DM']['DML']}} <span class="badge badge-pill badge-danger ml-1"> {{arr_Domain.length}}</span></h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="bool_showDomainList = false">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="12">
                                            <div class="card" v-for="(data,index) in arr_Domain" v-if="obj_agentInfo.DI == data.I" style="position: sticky; top: 0; z-index: 1;">
                                                <div class="card-body" style="padding:.5rem;background:#edf8eb;border: solid 1px #28A745;border-radius: 0.25rem;">
                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <p class="font-weight-bold mb-0" style="font-size:12px;">
                                                                {{getLanguage["BN"]["DN"]}}

                                                                <span class="custom_tooltip" v-if="((isSENS == 1 && obj_agentInfo.AGI == curAGI) || isSENS == 0) && checkModuleAccess('ASS', 'AGS', constAccessType.edit)">
                                                                    <i class="cil-sync" @click="clearCache()"></i>
                                                                    <span class="tooltiptext" style=" bottom: -25%; left: 200%;">{{getLanguage["BTN"]["CCACHE"]}}</span>
                                                                </span>
                                                            </p>

                                                            <div v-if="data.RS==1" class="custom_tooltip">
                                                                <span class="maintenance">{{ data.DN }}</span>
                                                                <span class="tooltiptext">{{ getLanguage["DM"]["MT"] }}</span>
                                                            </div>
                                                            <div v-else>{{ data.DN }}</div>
                                                        </div>

                                                        <div class="col-md-9">
                                                            <p class="font-weight-bold mb-0" style="font-size:12px;">{{getLanguage["DM"]["ALTDM"]}}</p>

                                                            <span class="row" v-if="data.DomainAlternate != null && data.DomainAlternate.length != 0">
                                                                <span v-for="adn in data.DomainAlternate" class="col-md-4 grid-line">
                                                                    {{ adn.DN }}
                                                                    <i v-if="adn.UCF" class="cib-cloudflare"></i>
                                                                </span>
                                                            </span>
                                                            <span v-else>-</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="card pointer mt-2" v-for="(data,index) in arr_Domain" v-if="obj_agentInfo.DI != data.I" @click="checkModuleAccess('ASS', 'AGS', constAccessType.edit) ? (obj_agentInfo.DI = data.I,obj_agentInfo.RS = data.RS,obj_agentInfo.DN = data.DN,getLiveChatfromDomain()) : null">
                                                <div class="card-body " style="padding:.5rem;background:#ECECEC">
                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <p class="font-weight-bold mb-0" style="font-size:12px;">
                                                                {{getLanguage["BN"]["DN"]}}
                                                            </p>

                                                            <div v-if="data.RS==1" class="custom_tooltip">
                                                                <span class="maintenance">{{ data.DN }}</span>
                                                                <span class="tooltiptext">{{ getLanguage["DM"]["MT"] }}</span>
                                                            </div>
                                                            <div v-else>{{ data.DN }}</div>
                                                        </div>

                                                        <div class="col-md-9">
                                                            <p class="font-weight-bold mb-0" style="font-size:12px;">{{getLanguage["DM"]["ALTDM"]}}</p>

                                                            <span class="row" v-if="data.DomainAlternate != null && data.DomainAlternate.length != 0">
                                                                <span v-for="adn in data.DomainAlternate" class="col-md-4 grid-line">
                                                                    {{ adn.DN }}
                                                                    <i v-if="adn.UCF" class="cib-cloudflare"></i>
                                                                </span>
                                                            </span>
                                                            <span v-else>-</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isReceipt && obj_AGI.AGI && bool_showMaintainInfo">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{getLanguage["DCUZ"]["UREC"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{getLanguage["MTA"]["RURL"]}} :</label>
                                        <div style="display:block;">
                                            <input type="file" name="pic" accept="image/*" @change="onFileSelected" style="overflow: hidden;" ref="RURL" />
                                        </div>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="10" class="form-group">
                                        <label class="col-form-label-sm full-width">
                                            {{getLanguage["ACT"]["PAMT"]}}<span class="required" /> :</span>
                                        </label>
                                        <treeselect :multiple="false"
                                                    :options="dd_currencyDF"
                                                    :placeholder="getLanguage['DB']['USD']"
                                                    @input="CurrencyChange"
                                                    v-model="obj_pamt.CI"
                                                    class="inline inline40"
                                                    :clearable="false"
                                                    ref="CI" />

                                        <CInput :placeholder="getLanguage['ACT']['PAMT']"
                                                size="sm"
                                                class="inline inline60"
                                                :value="ThousandSeparator(obj_pamt.AMT, getThousandCurrency ? 3 : 2)"
                                                @change="v => obj_pamt.AMT = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"
                                                ref="PA"></CInput>

                                        <span class="ErrMsg"></span>
                                    </CCol>
                                </CRow>

                                <span class="ErrMsg">{{getLanguage["DCUZ"]["MAXFILE"]}}</span>
                                <CRow>
                                    <CCol col="10" class="form-group">
                                        <label class="col-form-label-sm">{{getLanguage["MEM"]["RMK"]}} :</label>
                                        <span class="WCMsg" v-if="this.obj_pamt.RMK != null">{{ this.obj_pamt.RMK.length }} / 250 </span>
                                        <span class="WCMsg" v-else> 0 / 250 </span>
                                        <textarea maxlength="250" vertical="" rows="5" class="form-control form-control-sm" :value="obj_pamt.RMK" @change="TextValueChange('RMK',$event)" v-shortkey.avoid />
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-success" size="sm" @click="SaveReceipt();">
                                        {{getLanguage['BTN']['SV']}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader'>
                        <h2 id="titleHeight">{{getLanguage["AG"]["AGENTSS"]}}</h2>
                    </div>
                </CCol>
            </CRow>

            <CRow>
                <div class="col-12 col-xl-3 pr-xl-0">
                    <div class="p-3 h-100 agentDetail-Bg">
                        <div class="agentDetail">ID : <span class="ml-1 font-weight-bold">{{ this.getUserInfo.DN }} ({{ this.getUserInfo.PC }})</span></div>
                        <div v-if="(getUserInfo.AT == 0)" class="agentDetail">
                            {{getLanguage["AG"]["GT"]}} :
                            <i class="fa fa-user-shield gg-ico gg-ico-ssa text-nowrap ml-1"></i>
                            <span class="ml-1 font-weight-bold">{{getLanguage["AG"]["SSA"]}}</span>
                        </div>
                        <div v-if="(getUserInfo.AT == 1)" class="agentDetail">
                            {{getLanguage["AG"]["GT"]}} :
                            <i class="fa fa-user-alt gg-ico gg-ico-sa text-nowrap ml-1"></i>
                            <span class="ml-1 font-weight-bold">{{ getLanguageOEMI(getUserInfo.OEMI,"AG","SM")}}</span>
                        </div>
                        <div v-if="(getUserInfo.AT == 2)" class="agentDetail">
                            {{getLanguage["AG"]["GT"]}} :
                            <i class="fa fa-user-friends gg-ico gg-ico-ma text-nowrap ml-1"></i>
                            <span class="ml-1 font-weight-bold">{{ getLanguageOEMI(getUserInfo.OEMI,"AG","MA")}}</span>
                        </div>
                        <div v-if="(getUserInfo.AT == 3)" class="agentDetail">
                            {{getLanguage["AG"]["GT"]}} :
                            <i class="fas fa-users gg-ico gg-ico-a text-nowrap ml-1"></i>
                            <span class="ml-1 font-weight-bold">{{ getLanguageOEMI(getUserInfo.OEMI,"AG","A")}}</span>
                        </div>
                        <div v-if="(getUserInfo.AT == 4 && getUserInfo.OEMI ==0)" class="agentDetail">
                            {{getLanguage["AG"]["GT"]}} :
                            <i class="fa-solid fa-house theme-subagent text-nowrap ml-1"></i>
                            <span class="ml-1 font-weight-bold">{{getLanguage["SUB"]["AG"]}}</span>
                        </div>
                        <div v-if="(getUserInfo.AT == 4 && getUserInfo.OEMI ==2 &&getUserInfo.SAL==1 )" class="agentDetail">
                            {{getLanguage["AG"]["GT"]}} :
                            <i class="fa-solid fa-house theme-subagent text-nowrap ml-1"></i>
                            <span class="ml-1 font-weight-bold">{{getLanguageOEMI(getUserInfo.OEMI,"SUB","AG")}}</span>
                        </div>
                        <div v-if="(getUserInfo.AT == 4 && getUserInfo.OEMI ==2 &&getUserInfo.SAL==2 )" class="agentDetail">
                            {{getLanguage["AG"]["GT"]}} :
                            <i class="fa-solid fa-house theme-subagent text-nowrap ml-1"></i>
                            <span class="ml-1 font-weight-bold">{{getLanguageOEMI(getUserInfo.OEMI,"SUB","AG2")}}</span>
                        </div>

                        <div class="agentDetail" v-if="(getUserInfo.AT != 0)">{{getLanguage["AG"]["PT"]}}(%) : <span v-for="(data, index) in obj_profile" class="ml-1 font-weight-bold">{{ data.DPT }}</span></div>
                        <div class="agentDetail">{{getLanguage["AG"]["TBAL"]}} :<span v-for="(data, index) in obj_profile" class="ml-1 font-weight-bold">{{ data.CS }}{{ formatNumber(data.TB, 2) }}</span></div>
                        <div class="agentDetail" v-if='this.getBalanceStatus == 1'>{{getLanguage["AG"]["CB"]}} : <span class="ml-1 font-weight-bold balance">{{ formatNumber(this.getSystemBalance, 2, this.getCurrencySymbol) }}</span></div>
                        <div class="agentDetail" v-if='this.getBalanceStatus == 2'>{{getLanguage["AG"]["CB"]}} : <span class="ml-1 font-weight-bold balance warningbalance">{{ formatNumber(this.getSystemBalance, 2, this.getCurrencySymbol) }}</span></div>
                        <div class="agentDetail" v-if='this.getBalanceStatus == 3'>{{getLanguage["AG"]["CB"]}} : <span class="ml-1 font-weight-bold balance balanceflash">{{ formatNumber(this.getSystemBalance, 2, this.getCurrencySymbol) }}</span></div>
                        <div class="agentDetail" v-if='this.getBalanceStatus == 4'>{{getLanguage["AG"]["CB"]}} : <span class="ml-1 font-weight-bold balance balanceflash">{{ formatNumber(this.getSystemBalance, 2, this.getCurrencySymbol) }}</span></div>

                        <!-- Total SM -->
                        <div class="agentDetail" v-if="(getUserInfo.AT <= 0)">
                            <div>
                                {{getLanguage["AG"]["TASM"]}} : <i class="fas fa-user-alt gg-ico gg-ico-sa ml-1" style="font-size: .875rem;"></i>
                                <span v-for="(data, index) in obj_profile" class="ml-1 font-weight-bold">{{ data.CSM }} </span>
                                <div class="custom_tooltip" v-if="data.CSMT != 0" v-for="(data, index) in obj_profile">
                                    <span class="font-weight-bold text-danger">({{ data.CSMT }})</span>
                                    <span class="tooltiptext" style="font-size:10px">{{getLanguage["GL"]["IAC"]}} : {{ data.CSMIA }} {{getLanguage["BTN"]["SS"]}} : {{ data.CSMIS }}</span>
                                </div>
                            </div>

                            <!--<span class="badge badge-pill badge-primary pointer float-right" @click="openSSA('add', 'sm')" v-if="(getUserInfo.AT == 0) && checkModuleAccess('CRB', 'AGS', 2)">-->
                            <span class="badge badge-pill badge-primary pointer float-right" @click="openSSA('add', 'sm')" v-if="getUserInfo.AT == 0 && checkModuleAccess('ASS', 'AGS', constAccessType.add)">
                                <i class="fa fa-plus mr-1 pointer" aria-hidden="true"></i>{{getLanguage["BTN"]["AD"]}}
                            </span>
                        </div>

                        <!-- Total MA -->
                        <div class="agentDetail" v-if="(getUserInfo.AT <= 1)">
                            <div>
                                {{getLanguage["AG"]["TAMA"]}} : <i class="fas fa-user-friends gg-ico gg-ico-ma ml-1" style="font-size: .875rem;"></i>
                                <span v-for="(data, index) in obj_profile" class="ml-1 font-weight-bold">{{ data.CMA }} </span>
                                <div class="custom_tooltip" v-if="data.CMAT != 0" v-for="(data, index) in obj_profile">
                                    <span class="font-weight-bold text-danger">({{ data.CMAT }})</span>
                                    <span class="tooltiptext" style="font-size:10px">{{getLanguage["GL"]["IAC"]}} : {{ data.CMAIA }} {{getLanguage["BTN"]["SS"]}} : {{ data.CMAIS }}</span>
                                </div>
                            </div>

                            <!--<span class="badge badge-pill badge-primary pointer float-right" @click="openSSA('add', 'ma')" v-if="(getUserInfo.AT <= 1) && checkModuleAccess('CRB', 'AGS', 2)">-->
                            <span class="badge badge-pill badge-primary pointer float-right" @click="openSSA('add', 'ma')" v-if="getUserInfo.AT <= 1 && checkModuleAccess('ASS', 'AGS', constAccessType.add)">
                                <i class="fa fa-plus mr-1 pointer" aria-hidden="true"></i>{{getLanguage["BTN"]["AD"]}}
                            </span>
                        </div>

                        <!-- Total Agent -->
                        <div class="agentDetail" v-if="(getUserInfo.AT <= 2)">
                            <div>
                                {{getLanguage["AG"]["TAA"]}} : <i class="fas fa-users gg-ico gg-ico-a ml-1" style="font-size: .875rem;"></i>
                                <span v-for="(data, index) in obj_profile" class="ml-1 font-weight-bold">{{ data.CA }} </span>
                                <div class="custom_tooltip" v-if="data.CAT != 0" v-for="(data, index) in obj_profile">
                                    <span class="font-weight-bold text-danger">({{ data.CAT }})</span>
                                    <span class="tooltiptext" style="font-size:10px">{{getLanguage["GL"]["IAC"]}} : {{ data.CAIA }} {{getLanguage["BTN"]["SS"]}} : {{ data.CAIS }}</span>
                                </div>
                            </div>

                            <!--<span class="badge badge-pill badge-primary pointer float-right" @click="openSSA('add', 'a')" v-if="(getUserInfo.AT == 0 || getUserInfo.AT == 2 ) && checkModuleAccess('CRB', 'AGS', 2)">-->
                            <span class="badge badge-pill badge-primary pointer float-right" @click="openSSA('add', 'a')" v-if="(getUserInfo.AT == 0 || getUserInfo.AT == 2 ) && checkModuleAccess('ASS', 'AGS', constAccessType.add)">
                                <i class="fa fa-plus mr-1 pointer" aria-hidden="true"></i>{{getLanguage["BTN"]["AD"]}}
                            </span>
                        </div>

                        <!-- Total SubAgent -->
                        <div class="agentDetail" v-if="(getUserInfo.AT <= 3  && checkModuleAccess('SUB', 'AGS', 1) && checkModuleAccess('CSUB', 'AGS', 2))">
                            {{getLanguage["AG"]["TASA"]}} : <i class="fas fa-users theme-subagent text-nowrap ml-1" style="font-size: .875rem;"></i>
                            <span v-for="(data, index) in obj_profile" class="ml-1 font-weight-bold">{{ data.CSUB }} </span>
                        </div>

                        <!-- FTS -->
                        <div class="agentDetail" v-if="bool_HasAgentMainteneneceAccess">
                            {{getLanguage["AD"]["FTS"]}}
                            <span class="badge badge-pill badge-primary pointer float-right" @click="viewFirstTimeSetup" v-if="(getUserInfo.AT == 0 && !bool_showFTSInfo)"><i class="fa fa-eye mr-1 pointer" aria-hidden="true"></i>{{getLanguage["BTN"]["V"]}}</span>
                            <span class="badge badge-pill badge-primary pointer float-right" @click="bool_showFTSInfo = false" v-if="(getUserInfo.AT == 0 && bool_showFTSInfo)"><i class="fa fa-eye-slash mr-1 pointer" aria-hidden="true"></i>{{getLanguage["BTN"]["HD"]}}</span>
                        </div>

                        <!-- Prepare Invoice -->
                        <div class="agentDetail" v-if="bool_HasAgentMainteneneceAccess && getUserInfo.AT == 0">
                            {{getLanguage["AD"]["SIN"]}}
                            <span class="badge badge-pill badge-primary pointer float-right" @click="viewMaintenanceFee" v-if="(getUserInfo.AT == 0 && !bool_showMaintainInfo)"><i class="fa fa-eye mr-1 pointer" aria-hidden="true"></i>{{getLanguage["BTN"]["V"]}}</span>
                            <span class="badge badge-pill badge-primary pointer float-right" @click="bool_showMaintainInfo = false" v-if="(getUserInfo.AT == 0 && bool_showMaintainInfo)"><i class="fa fa-eye-slash mr-1 pointer" aria-hidden="true"></i>{{getLanguage["BTN"]["HD"]}}</span>
                        </div>

                        <!-- Preview Invoice -->
                        <div class="agentDetail" v-if="bool_HasAgentMainteneneceAccess">
                            {{getLanguage["GL"]["P"]}} {{getLanguage["AD"]["IN"]}}
                            <span class="badge badge-pill badge-primary pointer float-right" @click="viewInvoiceHistory" v-if="(!bool_showInvoiceInfo)"><i class="fa fa-eye mr-1 pointer" aria-hidden="true"></i>{{getLanguage["BTN"]["V"]}}</span>
                            <span class="badge badge-pill badge-primary pointer float-right" @click="bool_showInvoiceInfo = false" v-if="(bool_showInvoiceInfo)"><i class="fa fa-eye-slash mr-1 pointer" aria-hidden="true"></i>{{getLanguage["BTN"]["HD"]}}</span>
                        </div>

                        <!-- Currency Table -->
                        <!--<div class="agentDetail" v-if="bool_HasAgentMainteneneceAccess">
                            {{getLanguage["ACM"]["CTFA"]}}
                            <span class="badge badge-pill badge-primary pointer float-right" @click="viewCurrencyTable" v-if="(!bool_showCurrencyTable)"><i class="fa fa-eye mr-1 pointer" aria-hidden="true"></i>{{getLanguage["BTN"]["V"]}}</span>
                            <span class="badge badge-pill badge-primary pointer float-right" @click="bool_showCurrencyTable = false" v-if="(bool_showCurrencyTable)"><i class="fa fa-eye-slash mr-1 pointer" aria-hidden="true"></i>{{getLanguage["BTN"]["HD"]}}</span>
                        </div>-->
                    </div>
                </div>
                <div class="col-12 col-xl-9 pt-2 pt-xl-0">
                    <div class="p-3 h-100" style=" background: #ececec; border-radius: 10px;font-size:12px;">
                        <CRow>
                            <div class='col-12 col-md-5'>
                                <span class='searchLabel'>{{getLanguage['GL']['AGT']}}</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroup"
                                                  :defaultExpandLevel="Infinity"
                                                  @input="selectEditAgentOptions"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="obj_AGI.AGI" />
                            </div>
                            <!--<div class="col-12 col-md-3" v-if="bool_showAgentInfo">
                                <span class='searchLabel'>{{getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_reportcurrency"
                                            @input="selectCurrencyOptions"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="obj_AGI.CI" />
                            </div>-->
                            <div class='col-12 col-md-7' v-if="obj_AGI.AGI">
                                <div class="d-flex align-items-end h-100">
                                    <div class="my-1 mr-2" v-if="(this.getUserInfo.AT == 0 || obj_agentInfo.AGI == curAGI) && (bool_showSMMAInfo || bool_showAgentInfo)">
                                        {{getLanguage["AG"]["IPM"]}} <i class="fa-solid fa-lock"></i> :
                                        <label class="switch">
                                            <input type="checkbox" v-model="obj_agentInfo.IP" @change="updatePrivacySetting(obj_agentInfo.AGI, obj_agentInfo.IP)" true-value="1" false-value="0" :disabled="!checkModuleAccess('ASS', 'AGS', constAccessType.edit)">
                                            <span class="slider round STYLE_unlock" :style="disabledPointer()"></span>
                                        </label>
                                        <div class="custom_tooltip ml-2">
                                            <i class="fa fa-question-circle"></i>
                                            <span class="tooltiptext" style="background-color: black; color: white; text-align: left; bottom: 0px; left: 25px; z-index: 100; width: 175px; font-size: 11px;">
                                                {{getLanguage["AG"]["RUPD"]}}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="my-1 mr-2" v-if="this.getUserInfo.AT == 0 && obj_agentInfo.IPO == 1 && bool_showMaintainInfo">
                                        {{getLanguage["AG"]["EPTS"]}} : <span class="font-weight-bold">{{ formatDateTime(obj_agentInfo.EPTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                    </div>
                                    <div class="my-1 mr-2" v-if="this.getUserInfo.AT == 0 && bool_showMaintainInfo">
                                        {{getLanguage["AG"]["PAYM"]}} :
                                        <label class="switch">
                                            <input type="checkbox" v-model="obj_agentInfo.IPO" @change="updateIsPaymentOutstanding(obj_agentInfo.AGI, obj_agentInfo.IPO)" true-value="0" false-value="1" :disabled="obj_agentInfo.IPO == 0">
                                            <span class="slider round darkGreenRound"></span>
                                        </label>
                                    </div>
                                    <div class="my-1 mr-2" v-if="this.getUserInfo.AT == 0 && bool_showMaintainInfo">
                                        {{getLanguage["AG"]["GOLIVE"]}} :
                                        <label class="switch">
                                            <input type="checkbox" v-model="obj_agentInfo.IPL" @change="updateIsPendingLaunch(obj_agentInfo.AGI, obj_agentInfo.IPL)" true-value="0" false-value="1" :disabled="obj_agentInfo.IPO == 1 || obj_agentInfo.IPL == 0">
                                            <span class="slider round darkGreenRound"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class='col-12 col-md-12'>
                                <span class="" style="font-size:10px" v-if="obj_PrevAGI.length >= 1">
                                    [{{getLanguage["FR"]["PR"]}} :
                                    <template v-for="(agent, index) in obj_PrevAGI">
                                        <template v-if="index < obj_PrevAGI.length - 1">
                                            <a href="#" @click="obj_AGI.AGI = agent.id">{{agent.label}}</a> ,
                                        </template>
                                        <template v-else>
                                            <a href="#" @click="obj_AGI.AGI = agent.id">{{agent.label}}</a>
                                        </template>
                                    </template>
                                    ]
                                </span>
                            </div>
                        </CRow>

                        <div class="row mt-2" v-if="(bool_showSMMAInfo || bool_showAgentInfo) && this.getUserInfo.AT != 4">
                            <div :class="{'col-md-6': obj_agentInfo.PTPTB,'col-md-12': !obj_agentInfo.PTPTB}">
                                <div style=" background: #fff; padding: 10px; border: 1px solid #ddd; border-radius: 5px; height: calc(100% - 10px);">
                                    <div class="row">
                                        <div :class="bool_showTopUp && obj_Balance.BT!=99 ? 'col-md-11 pr-md-0' : 'col-md-11 pr-md-0'">
                                            <div v-if="obj_agentInfo.TOTPC > 0">
                                                {{getLanguage["AG"]["TOTP"]}} : <span class="font-weight-bold">{{ obj_agentInfo.TOTPC }} </span>{{getLanguage["AG"]["OTPT"]}}
                                            </div>
                                            <div>
                                                {{getLanguage["AG"]["TBAL"]}} : <span class="font-weight-bold">{{ formatNumber(obj_agentInfo.TB, 2, obj_agentInfo.ISOC) }}</span>

                                                <div class="custom_tooltip" :style="disabledPointer()" v-if="obj_agentInfo.AT > 0 && obj_agentInfo.IPSS == 0 && getUserInfo.AT < obj_agentInfo.AT">
                                                    <div v-if="obj_agentInfo.ISS">
                                                        <i class="cil-action-undo" @click="!checkModuleAccess('ASS', 'AGS', constAccessType.edit) ? null : unSuspendAgent(obj_agentInfo)"></i>
                                                        <span class="tooltiptext" style="font-size:10px">{{getLanguage["BTN"]["USS"]}}</span>
                                                    </div>
                                                    <div v-else>
                                                        <i class="cil-ban" @click="!checkModuleAccess('ASS', 'AGS', constAccessType.edit) ? null : suspendAgent(obj_agentInfo)"></i>
                                                        <span class="tooltiptext" style="font-size:10px">{{getLanguage["BTN"]["SS"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="custom_tooltip">
                                                    <i class="cil-cash" @click='balanceHistoryList(obj_agentInfo.AGI, obj_agentInfo.AT,1)'></i>
                                                    <span class="tooltiptext" style="font-size:10px">{{getLanguage["BTN"]["HTR"]}}</span>
                                                </div>
                                            </div>

                                            <div>
                                                {{getLanguage["AG"]["CB"]}} : <span class="font-weight-bold">{{ formatNumber(obj_agentInfo.CB, 2, obj_agentInfo.ISOC) }}</span>
                                                <span class="badge badge-pill badge-primary pointer" style="background: rgb(111, 107, 214);" @click="bool_showTopUp = true" v-if="!bool_showTopUp && obj_agentInfo.CB > 0 && obj_agentInfo.AT > getUserInfo.AT"><i aria-hidden="true" class="fa fa-plus mr-1 pointer"></i> {{getLanguage["AG"]["TUDSB"]}} {{getLanguage["BAL"]["B"]}}</span>
                                                <span class="badge badge-pill badge-primary pointer" style="background: rgb(111, 107, 214);" @click="bool_showTopUp = false" v-if="bool_showTopUp && obj_agentInfo.CB > 0 && obj_agentInfo.AT > getUserInfo.AT"><i aria-hidden="true" class="fa fa-times mr-1 pointer"></i> {{getLanguage["BETRPT"]["SC"]}} {{getLanguage["AG"]["TUDSB"]}}</span>
                                            </div>

                                            <div class="" v-if="bool_showTopUp && obj_Balance.BT!=99">
                                                <div class="d-flex">
                                                    <label class="col-form-label-sm full-width">
                                                        {{getLanguage["AG"]["TUDSB"]}} {{getLanguage["BAL"]["B"]}} ({{ obj_agentInfo.CS }})<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                                        <span class="label-tooltip" style="padding-right:1%;">{{ getLanguage['AG']['SBAB']}} : {{ obj_agentInfo.CS }} {{ formatNumber(this.AvailableBalanceAmount(), 2) }}</span>
                                                    </label>
                                                    <CButton :style="disabledPointer()" color="outline-info" size="sm" @click="!checkModuleAccess('ASS', 'AGS', constAccessType.edit) ? null : updateBalance()" class="float-right d-flex align-items-center">
                                                        <span class='plusIcon cil-plus'></span>
                                                        {{ getLanguage['AG']['ADJ']}}
                                                    </CButton>
                                                </div>

                                                <CInput :placeholder="getLanguage['AG']['BTUA']"
                                                        size="sm"
                                                        :value="ThousandSeparator(obj_Balance.BU, getThousandCurrency ? 3 : 2)"
                                                        @change="v => obj_Balance.BU = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                                <span class="ErrMsg">{{ ValidationSystemBalanceErrMsg('BU', 'BTUA') }}</span>
                                            </div>
                                            <apexchart type="bar" height="110" width="350" :options="chartOptions" :series="series" class="col-md-11 apexchart1"></apexchart>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--PToP Part-->
                            <div class="col-md-6" v-if="this.obj_agentInfo.PTPTB !== 0">
                                <div style=" background: #fff; padding: 10px; border: 1px solid #ddd; border-radius: 5px; height: calc(100% - 10px);">
                                    <div class="row">
                                        <div :class="bool_showTopUp2 && obj_Balance.BT!=99 ? 'col-md-11 pr-md-0' : 'col-md-11 pr-md-0'">
                                            <div v-if="obj_agentInfo.TOTPC > 0">
                                                {{getLanguage["AG"]["TOTP"]}} : <span class="font-weight-bold">{{ obj_agentInfo.TOTPC }} </span>{{getLanguage["AG"]["OTPT"]}}
                                            </div>
                                            <div>
                                                {{getLanguage["AG"]["PTPTB"]}} : <span class="font-weight-bold">{{ formatNumber(obj_agentInfo.PTPTB, 2, obj_agentInfo.ISOC) }}</span>

                                                <div class="custom_tooltip" :style="disabledPointer()" v-if="obj_agentInfo.AT > 0 && obj_agentInfo.IPSS == 0 && getUserInfo.AT < obj_agentInfo.AT">
                                                    <div v-if="obj_agentInfo.ISS">
                                                        <i class="cil-action-undo" @click="!checkModuleAccess('ASS', 'AGS', constAccessType.edit) ? null : unSuspendAgent(obj_agentInfo)"></i>
                                                        <span class="tooltiptext" style="font-size:10px">{{getLanguage["BTN"]["USS"]}}</span>
                                                    </div>
                                                    <div v-else>
                                                        <i class="cil-ban" @click="!checkModuleAccess('ASS', 'AGS', constAccessType.edit) ? null : suspendAgent(obj_agentInfo)"></i>
                                                        <span class="tooltiptext" style="font-size:10px">{{getLanguage["BTN"]["SS"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="custom_tooltip">
                                                    <i class="cil-cash" @click='balanceHistoryList(obj_agentInfo.AGI, obj_agentInfo.AT,2)'></i>
                                                    <span class="tooltiptext" style="font-size:10px">{{getLanguage["BTN"]["HTR"]}}</span>
                                                </div>
                                            </div>

                                            <div>
                                                {{getLanguage["AG"]["CP2P"]}} : <span class="font-weight-bold">{{ formatNumber(obj_agentInfo.CPTPB, 2, obj_agentInfo.ISOC) }}</span>
                                                <span class="badge badge-pill badge-primary pointer" style="background: rgb(111, 107, 214);" @click="bool_showTopUp2 = true; obj_Balance.PTPBU = 0; str_invalidPToPAmountMsg ='';" v-if="!bool_showTopUp2 && obj_agentInfo.AT > getUserInfo.AT"><i aria-hidden="true" class="fa fa-plus mr-1 pointer"></i> {{getLanguage["AG"]["TUDSB"]}} {{getLanguage["BAL"]["B"]}}</span>
                                                <span class="badge badge-pill badge-primary pointer" style="background: rgb(111, 107, 214);" @click="bool_showTopUp2 = false; obj_Balance.PTPBU = 0; str_invalidPToPAmountMsg ='';" v-if="bool_showTopUp2 && obj_agentInfo.AT > getUserInfo.AT"><i aria-hidden="true" class="fa fa-times mr-1 pointer"></i> {{getLanguage["BETRPT"]["SC"]}} {{getLanguage["AG"]["TUDSB"]}}</span>
                                            </div>

                                            <div class="" v-if="bool_showTopUp2 && obj_Balance.BT!=99">
                                                <div class="d-flex">
                                                    <label class="col-form-label-sm full-width">
                                                        {{getLanguage["AG"]["TUDSB"]}} {{getLanguage["BAL"]["B"]}} ({{ obj_agentInfo.CS }})<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                                        <span class="label-tooltip" style="padding-right:1%;">{{ getLanguage['AG']['P2PAB']}} : {{ obj_agentInfo.CS }} {{ formatNumber(this.AvailablePToPBalanceAmount(), 2) }}</span>
                                                    </label>
                                                    <CButton :style="disabledPointer()" color="outline-info" size="sm" @click="!checkModuleAccess('ASS', 'AGS', constAccessType.edit) ? null : updatePToPBalance()" class="float-right d-flex align-items-center">
                                                        <span class='plusIcon cil-plus'></span>
                                                        {{ getLanguage['AG']['ADJ']}}
                                                    </CButton>
                                                </div>

                                                <CInput :placeholder="getLanguage['AG']['BTUA']"
                                                        size="sm"
                                                        :value="ThousandSeparator(obj_Balance.PTPBU, getThousandCurrency ? 3 : 2)"
                                                        @change="v => obj_Balance.PTPBU = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                                <span class="ErrMsg">{{ ValidationPToPBalanceErrMsg('PTPBU', 'BTUA') }}</span>
                                            </div>

                                            <apexchart type="bar" height="110" width="350" :options="chartOptions" :series="series2" class="col-md-11 apexchart1"></apexchart> <!--PToP Chart-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Agent Hierarchy -->
                        <div class="row" :style="(bool_showSMMAInfo) ? ' margin-top: -10px;':' margin-top: 0;'" v-if="bool_showSMMAInfo">
                            <div class="col-md-12 mt-2">
                                <div style=" background: #fff; padding: 10px; border: 1px solid #ddd; border-radius: 5px;font-size:14px">
                                    <header class="table-header p-0">
                                        <strong>{{getLanguageOEMI(this.getUserInfo.OEMI,"AHRPT",'AHRPT')}}</strong>
                                    </header>
                                    <div class="agent-hierarchy">
                                        <v-treeview v-model="treeData"
                                                    :treeTypes="treeTypes"
                                                    @selected="selected"
                                                    :openAll="openAll" :openNode="openNode" @contextmenu.prevent>
                                            <template v-slot:prepand="{item}">
                                                <span v-if="item.isnew" class="badge badge-danger">{{getLanguage["GAME"]["NEW"]}}</span>
                                                <span v-if="!((item.type == 'MA' && obj_agentInfo.AT == '2') || (item.type == 'SA' && obj_agentInfo.AT == '1') || (item.type == 'DN'))" style="z-index: 2;position:relative" @click="openAgentInfo(item)" ><i class="fas fa-arrow-circle-right text-danger"></i></span>
                                            </template>
                                        </v-treeview>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Checklist (SM) -->
                        <div class="row" v-if="bool_showSMInfo && !bool_showMaintainInfo && !bool_showInvoiceInfo && !bool_showFTSInfo && !bool_showCurrencyTable">
                            <div class="col-md-12 mt-2">
                                <div class="h-100" style=" background: #fff; padding: 10px; border: 1px solid #ddd; border-radius: 5px;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3 class="font-weight-bold mb-0" style="font-size: 14px;">{{getLanguage['AG']['CL']}}</h3>
                                            <!--Checklist-->
                                            <table class='custom-table w-100 domaincheckList mt-2'>
                                                <tbody>
                                                    <!--Domain Setting-->
                                                    <tr v-if="obj_agentInfo.DSET == 1">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" fill="#28a745"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">1. {{getLanguage["AG"]["SM"]}} {{ getLanguage["HFS"]["BD"] }}</td>
                                                        <td>
                                                            <div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b; width: auto; display: flex; gap: 5px; justify-content: flex-end;" @click="openSSA('edit','ds')">
                                                                <i class="fa-solid fa-pen-to-square"></i>
                                                                <span v-if="this.getUserInfo.AT !== 0">{{getLanguage["BTN"]["V"]}}</span>
                                                                <span v-else>{{getLanguage["BTN"]["ED"]}}</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="obj_agentInfo.DSET == 0">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z" fill="#e55353"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">1. {{getLanguage["AG"]["SM"]}} {{ getLanguage["HFS"]["BD"] }}</td>
                                                        <td><div class="pointer" style="color: #1b1b1b; width: auto; display: flex; gap: 5px; justify-content: flex-end;" @click="openSSA('edit','dss')"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</div></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Checklist (MA) -->
                        <div class="row" v-if="bool_showMAInfo && !bool_showMaintainInfo && !bool_showInvoiceInfo && !bool_showFTSInfo && !bool_showCurrencyTable">
                            <div class="col-md-12 mt-2">
                                <div class="h-100" style=" background: #fff; padding: 10px; border: 1px solid #ddd; border-radius: 5px;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3 class="font-weight-bold mb-0" style="font-size: 14px;">{{getLanguage['AG']['CL']}}</h3>
                                            <!--Checklist-->
                                            <table class='custom-table w-100 domaincheckList mt-2'>
                                                <tbody>
                                                    <!--Domain Setting-->
                                                    <tr v-if="obj_agentInfo.DSET == 1">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" fill="#28a745"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">1. {{getLanguage["AG"]["MA"]}} {{ getLanguage["HFS"]["BD"] }}</td>
                                                        <td>
                                                            <div class="pointer" style="color: #1b1b1b; width: auto; display: flex; gap: 5px; justify-content: flex-end;" @click="openSSA('edit','ds')">
                                                                <i class="fa-solid fa-pen-to-square"></i>
                                                                <span v-if="this.getUserInfo.AT !== 0">{{getLanguage["BTN"]["V"]}}</span>
                                                                <span v-else>{{getLanguage["BTN"]["ED"]}}</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="obj_agentInfo.DSET == 0">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z" fill="#e55353"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">1. {{getLanguage["AG"]["MA"]}} {{ getLanguage["HFS"]["BD"] }}</td>
                                                        <td><div class="pointer" style="color: #1b1b1b; width: auto; display: flex; gap: 5px; justify-content: flex-end;" @click="openSSA('edit','dss')"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</div></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" :style="(bool_showSMMAInfo || bool_showAgentInfo) && this.getUserInfo.AT != 3 ? ' margin-top: -10px;':' margin-top: 0;'" v-if="bool_showAgentInfo">
                            <div class="col-md-3 pr-md-0  mt-2" v-if="obj_agentInfo.CurrencyIds">
                                <div class="tempScrollbar" style=" background: #fff; padding: 10px; border: 1px solid #ddd; border-radius: 5px; height: 180px; overflow: hidden scroll;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <p class="mb-2 font-weight-bold">
                                                {{getLanguage["AG"]["C"]}}
                                                <small v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" style="width: 25px; height: 25px;float: right;">
                                                    <span @click="openSSA('edit', 'dss')" class="text-dark pointer">
                                                        <span class="member-list-same custom_tooltip " style="margin-top: -5px;">
                                                            <i class="cil-color-border"></i> <span class="tooltiptext" style="bottom: 0%;left: -35px;font-size:10px">{{getLanguage["BTN"]["ED"]}}</span>
                                                        </span>
                                                    </span>
                                                </small>
                                            </p>
                                        </div>
                                        <div class="col-md-12" style="height:calc(100% - 26px)" v-if="obj_agentInfo.CurrencyIds.length >= 1">
                                            <div class="row  align-items-center mx-0">
                                                <div style="position:relative;width:55px;" v-for="cur in dd_currency_wall[0].children" v-if="obj_agentInfo.CurrencyIds.includes(cur.id)">
                                                    <span>{{ cur.label }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12" v-if="obj_agentInfo.CurrencyIds.length < 1">
                                            <div class="text-center">
                                                {{getLanguage["GL"]["NR"]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 pr-md-0  mt-2" v-if="obj_agentInfo.Language">
                                <div class="tempScrollbar" style=" background: #fff; padding: 10px; border: 1px solid #ddd; border-radius: 5px; height: 180px; overflow: hidden scroll;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <p class="mb-2 font-weight-bold">
                                                {{getLanguage["AG"]["L"]}}
                                                <small v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" style="width: 20px; height: 20px;float: right;">
                                                    <span @click="openSSA('edit', 'dss')" class="text-dark pointer">
                                                        <span class="member-list-same custom_tooltip " style="margin-top: -5px;">
                                                            <i class="cil-color-border"></i> <span class="tooltiptext" style="bottom: 0%;left: -35px;font-size:10px">{{getLanguage["BTN"]["ED"]}}</span>
                                                        </span>
                                                    </span>
                                                </small>
                                            </p>
                                        </div>

                                        <div class="col-md-12" style="height:calc(100% - 26px)" v-if="obj_agentInfo.Language.length >= 1">
                                            <div class="row  align-items-center mx-0">
                                                <div style="position: relative; width: 85px;display: flex; justify-content: start; align-items: center;" v-for="lang in dd_language_wall[0].children" v-if="obj_agentInfo.Language.includes(lang.id)">
                                                    <span class="flagClass mx-1" :class="mapLanguageFlag(lang.id)"></span>
                                                    <span class="text-uppercase ml-1">({{ lang.id }})</span>
                                                    <i class="fa-solid fa-globe text-info ml-1" v-if="obj_agentInfo.DL == lang.id"></i>
                                                    <i class="fa-solid fa-globe ml-1 pointer" v-if="obj_agentInfo.DL != lang.id && obj_agentInfo.DomainSettingsLang.includes(lang.id) && obj_agentInfo.AGI==getUserInfo.AGI" @click="checkModuleAccess('ASS', 'AGS', constAccessType.edit) ? updateDefaultLang(lang.id) : null"></i>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12" v-if="obj_agentInfo.Language.length < 1">
                                            <div class="text-center">
                                                {{getLanguage["GL"]["NR"]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 pr-md-0 mt-2" v-if="obj_agentInfo.GCI">
                                <div class="tempScrollbar" style=" background: #fff; padding: 10px; border: 1px solid #ddd; border-radius: 5px; height: 180px; overflow: hidden scroll;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <p class="mb-2 font-weight-bold">
                                                {{getLanguage["AG"]["GP"]}}
                                                <small v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" style="width: 20px; height: 20px;float: right;">
                                                    <span @click="openSSA('edit', 'dss')" class="text-dark pointer">
                                                        <span class="member-list-same custom_tooltip " style="margin-top: -5px;">
                                                            <i class="cil-color-border"></i> <span class="tooltiptext" style="bottom: 0%;left: -35px;font-size:10px">{{getLanguage["BTN"]["ED"]}}</span>
                                                        </span>
                                                    </span>
                                                </small>
                                            </p>
                                        </div>

                                        <div class="col-md-12" style="height:calc(100% - 26px)">
                                            <div class="row align-items-center mx-0">
                                                <div style="position: relative; width: 60px; text-align: center; font-size: 9px" v-for="cat in dd_gameprovider_cat" v-if="obj_agentInfo.GameCategoryIds.includes(cat.id)">
                                                    <div class="position-relative m-auto" style="width:40px">
                                                        <img class="img-fluid p-1 pointer" style="max-width:24px" :src="getProviderCatUrl(cat.label)" @click="addNewSupportType(3, cat.id)">
                                                        <div style="position:absolute;top:0;right:0">
                                                            <span class="badge badge-pill badge-success ml-1" v-if="cat.label == 'SPORTSBOOK'">{{obj_agentInfo.GCSBC}}</span>
                                                            <span class="badge badge-pill badge-success ml-1" v-if="cat.label == 'LIVE CASINO'">{{obj_agentInfo.GCLCC}}</span>
                                                            <span class="badge badge-pill badge-success ml-1" v-if="cat.label == 'SLOTS'">{{obj_agentInfo.GCSC}}</span>
                                                            <span class="badge badge-pill badge-success ml-1" v-if="cat.label == 'POKER'">{{obj_agentInfo.GCPC}}</span>
                                                            <span class="badge badge-pill badge-success ml-1" v-if="cat.label == 'LOTTERY'">{{obj_agentInfo.GCLC}}</span>
                                                            <span class="badge badge-pill badge-success ml-1" v-if="cat.label == 'FISHING'">{{obj_agentInfo.GCFC}}</span>
                                                            <span class="badge badge-pill badge-success ml-1" v-if="cat.label == 'E CASINO'">{{obj_agentInfo.GCECC}}</span>
                                                            <span class="badge badge-pill badge-success ml-1" v-if="cat.label == 'GAMES'">{{obj_agentInfo.GCGC}}</span>
                                                            <span class="badge badge-pill badge-success ml-1" v-if="cat.label == 'RACING'">{{obj_agentInfo.GCRC}}</span>
                                                        </div>
                                                    </div>
                                                    {{ renderCategoryName(cat.label) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3  mt-2" v-if="obj_agentInfo.CPG >= 1">
                                <div class="tempScrollbar" style=" background: #fff; padding: 10px; border: 1px solid #ddd; border-radius: 5px; height: 180px; overflow: hidden scroll;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <p class="mb-2 font-weight-bold">
                                                {{getLanguage["MTA"]["PG"]}}
                                                <small v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" style="width: 20px; height: 20px;float: right;">
                                                    <span @click="openSSA('edit', 'dss')" class="text-dark pointer">
                                                        <span class="member-list-same custom_tooltip " style="margin-top: -5px;">
                                                            <i class="cil-color-border"></i> <span class="tooltiptext" style="bottom: 0%;left: -35px;font-size:10px">{{getLanguage["BTN"]["ED"]}}</span>
                                                        </span>
                                                    </span>
                                                </small>
                                            </p>
                                        </div>

                                        <div class="col-md-12" style="height:calc(100% - 26px)">
                                            <div class="row align-items-center mx-0">
                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.H2PU && obj_agentInfo.H2PCC && obj_agentInfo.H2PMC && obj_agentInfo.H2PSC">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/h2p.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.OOPTHMN && obj_agentInfo.OOPTHAS && obj_agentInfo.OOPTHSK || obj_agentInfo.OOPVIMN && obj_agentInfo.OOPVIAS && obj_agentInfo.OOPVISK || obj_agentInfo.OOPIDMN && obj_agentInfo.OOPIDAS && obj_agentInfo.OOPIDSK">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/oopay.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.EZPUSDMN && obj_agentInfo.EZPUSDAS || obj_agentInfo.EZPIDRMN && obj_agentInfo.EZPIDRAS || obj_agentInfo.EZPMYRMN && obj_agentInfo.EZPMYRAS || obj_agentInfo.EZPTHBMN && obj_agentInfo.EZPTHBAS || obj_agentInfo.EZPVNDMN && obj_agentInfo.EZPVNDAS">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/ezpay.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.TUPVNDMN && obj_agentInfo.TUPVNDAS || obj_agentInfo.TUPMYRMN && obj_agentInfo.TUPMYRAS">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/truepay.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.XFTHN && obj_agentInfo.XFTHK || obj_agentInfo.XFVIN && obj_agentInfo.XFVIK || obj_agentInfo.XFMYRN && obj_agentInfo.XFMYRK || obj_agentInfo.XFUSDTN && obj_agentInfo.XFUSDTK || obj_agentInfo.XFIDRN && obj_agentInfo.XFIDRK">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/xfuoo.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.SPMN && obj_agentInfo.SPAK">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/starpay.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.SUMYRCN && obj_agentInfo.SUMYRMN && obj_agentInfo.SUMYRAK || obj_agentInfo.SUTHBCN && obj_agentInfo.SUTHBMN && obj_agentInfo.SUTHBAK || obj_agentInfo.SUSGDCN && obj_agentInfo.SUSGDMN && obj_agentInfo.SUSGDAK || obj_agentInfo.SUIDRCN && obj_agentInfo.SUIDRMN && obj_agentInfo.SUIDRAK">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/surepay.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.CPSV1 && obj_agentInfo.CPSV2 && obj_agentInfo.CPAPIU">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/cpay.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.FUPSV1 && obj_agentInfo.FUPSV2 && obj_agentInfo.FUPAPIU">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/fupay.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.TMSV1 && obj_agentInfo.TMSV2 && obj_agentInfo.TMAPIU">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/tmoney.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.LPSV1 && obj_agentInfo.LPSV2 && obj_agentInfo.LPAPIU">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/luckypay.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.BCPSV1 && obj_agentInfo.BCPSV2 && obj_agentInfo.BCPAPIU">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/bcpay.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.U2PIDRSV1 && obj_agentInfo.U2PIDRSV2">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/u2pay.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.SPSV1 && obj_agentInfo.SPSV2 || obj_agentInfo.SPIDRSV1 && obj_agentInfo.SPIDRSV2">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/smartpay.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.FPGSV1 && obj_agentInfo.FPGSV2">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/fpg.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.PGASV1 && obj_agentInfo.PGASV2">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/mpay.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.hasAD3P">
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/ad3p.webp">
                                                </div>

                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.PPSV1 && obj_agentInfo.PPSV2">
                                                    <!--POMPAY-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/pompay.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.DNSV1 && obj_agentInfo.DNSV2">
                                                    <!--DOITNOW-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/doitnow.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.AGPSV1 && obj_agentInfo.AGPSV2">
                                                    <!--Agogopay-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/agp.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.P918SV1 && obj_agentInfo.P918SV2 && obj_agentInfo.P918SV3 && obj_agentInfo.P918SV4">
                                                    <!--918Pay-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/p918.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.UPSV1 && obj_agentInfo.UPSV2">
                                                    <!--UniversePay-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/universepay.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.OPTHBSV1 && obj_agentInfo.OPTHBSV2 || obj_agentInfo.OPIDRSV1 && obj_agentInfo.OPIDRSV2 || obj_agentInfo.OPVNDSV1 && obj_agentInfo.OPVNDSV2">
                                                    <!--Okayspay-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/okayspay.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.MPMYRSV1 && obj_agentInfo.MPMYRSV2">
                                                    <!--Megaspay-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/megaspay.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="obj_agentInfo.VIPSV1 && obj_agentInfo.VIPSV2 && obj_agentInfo.VIPSV3">
                                                    <!--VIP-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/vip.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.AFPSV1 && obj_agentInfo.AFPSV2) || (obj_agentInfo.AFPSV3 && obj_agentInfo.AFPSV4)">
                                                    <!--AlfaPay-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/alfapay.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.ONEPSV1 && obj_agentInfo.ONEPSV2)">
                                                    <!--OnePay-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/onepay.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.BLEUPSV1 && obj_agentInfo.BLEUPSV2)">
                                                    <!--BleuPay-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/bleupay.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.E88PSV1 && obj_agentInfo.E88PSV2)">
                                                    <!--Easy8Pay-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/easy88pay.webp">
                                                </div>
                                                <!--<div style="position:relative;width:55px;" v-if="(obj_agentInfo.PPYPSV1 && obj_agentInfo.PPYPSV2)">-->
                                                <!--PapayaPay-->
                                                <!--<img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/papayapay.webp">
    </div>-->
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.ECPSV1 && obj_agentInfo.ECPSV2 && obj_agentInfo.ECPSV3)">
                                                    <!--ECPay-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/ecpay.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.ZPAYTHBSV1 && obj_agentInfo.ZPAYTHBSV2) || (obj_agentInfo.ZPAYINRSV1 && obj_agentInfo.ZPAYINRSV2) ||
                                                                                                 (obj_agentInfo.ZPAYBRLSV1 && obj_agentInfo.ZPAYBRLSV2) || (obj_agentInfo.ZPAYVNDSV1 && obj_agentInfo.ZPAYVNDSV2) ||
                                                                                                 (obj_agentInfo.ZPAYMYRSV1 && obj_agentInfo.ZPAYMYRSV2)">
                                                    <!--ZPay-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/zpay.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.UPAYSV1)">
                                                    <!--UPay-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/upay.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.PAYPROUSDSV1 && obj_agentInfo.PAYPROUSDSV2 && obj_agentInfo.PAYPROUSDSV3 && obj_agentInfo.PAYPROUSDSV4) ||
                                                                                                 (obj_agentInfo.PAYPROMYRSV1 && obj_agentInfo.PAYPROMYRSV2 && obj_agentInfo.PAYPROMYRSV3 && obj_agentInfo.PAYPROMYRSV4) ||
                                                                                                 (obj_agentInfo.PAYPROTHBSV1 && obj_agentInfo.PAYPROTHBSV2 && obj_agentInfo.PAYPROTHBSV3 && obj_agentInfo.PAYPROTHBSV4) ||
                                                                                                 (obj_agentInfo.PAYPROIDRSV1 && obj_agentInfo.PAYPROIDRSV2 && obj_agentInfo.PAYPROIDRSV3 && obj_agentInfo.PAYPROIDRSV4) ||
                                                                                                 (obj_agentInfo.PAYPROVNDSV1 && obj_agentInfo.PAYPROVNDSV2 && obj_agentInfo.PAYPROVNDSV3 && obj_agentInfo.PAYPROVNDSV4) ||
                                                                                                 (obj_agentInfo.PAYPROHKDSV1 && obj_agentInfo.PAYPROHKDSV2 && obj_agentInfo.PAYPROHKDSV3 && obj_agentInfo.PAYPROHKDSV4) ||
                                                                                                 (obj_agentInfo.PAYPROBDTSV1 && obj_agentInfo.PAYPROBDTSV2 && obj_agentInfo.PAYPROBDTSV3 && obj_agentInfo.PAYPROBDTSV4) ||
                                                                                                 (obj_agentInfo.PAYPROBRLSV1 && obj_agentInfo.PAYPROBRLSV2 && obj_agentInfo.PAYPROBRLSV3 && obj_agentInfo.PAYPROBRLSV4) ||
                                                                                                 (obj_agentInfo.PAYPROPHPSV1 && obj_agentInfo.PAYPROPHPSV2 && obj_agentInfo.PAYPROPHPSV3 && obj_agentInfo.PAYPROPHPSV4)">
                                                    <!--PayPro-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/paypro.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.DGPCNYSV1 && obj_agentInfo.DGPCNYSV2)">
                                                    <!--DGPayCNY-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/dgpay.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.S7PVNDSV1 && obj_agentInfo.S7PVNDSV2) ||
                                                                                                 (obj_agentInfo.S7PVNDSV3 && obj_agentInfo.S7PVNDSV4) ||
                                                                                                 (obj_agentInfo.S7PVNDSV5 && obj_agentInfo.S7PVNDSV6) ||
                                                                                                 (obj_agentInfo.S7PVNDSV7 && obj_agentInfo.S7PVNDSV8) ||
                                                                                                 (obj_agentInfo.S7PVNDSV9 && obj_agentInfo.S7PVNDSV10)">
                                                    <!--SUPER7VND-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/super7.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.PLSV1 && obj_agentInfo.PLSV2)">
                                                    <!--PayLite-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/paylite.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.HUIJUCAISV1 && obj_agentInfo.HUIJUCAISV2)">
                                                    <!--HUIJUCAI-PKR-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/huijucai.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.BestPaySV1 && obj_agentInfo.BestPaySV2)">
                                                    <!--BestPay-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/bestpay.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.CLPSV1 && obj_agentInfo.CLPSV2 && obj_agentInfo.CLPSV3 && obj_agentInfo.CLPSV4 && obj_agentInfo.CLPSV5)">
                                                    <!--CLOUDPAY-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/cloudpay.webp">
                                                </div>
                                                <div style="position:relative;width:55px;" v-if="(obj_agentInfo.LNWPAYUSDSV1) || (obj_agentInfo.LNWPAYHKDSV1)">
                                                    <!--LNWPAY-->
                                                    <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/lnwpay.webp">
                                                </div>
                                                <!--<div style="position:relative;width:55px;" v-if="(obj_agentInfo.PNGSV1 && obj_agentInfo.PNGSV2 && obj_agentInfo.PNGSV3 && obj_agentInfo.PNGSV4)">-->
                                                <!--PayNGo-->
                                                <!--<img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/payngo.webp">
    </div>-->
                                                <!--<div style="position:relative;width:55px;" v-if="obj_agentInfo.U2PIDRGMN && obj_agentInfo.U2PIDRGAS && obj_agentInfo.U2PIDRGK && obj_agentInfo.U2PIDRDMN && obj_agentInfo.U2PIDRDAS && obj_agentInfo.U2PIDRDK && obj_agentInfo.U2PIDROMN && obj_agentInfo.U2PIDROAS && obj_agentInfo.U2PIDROK">
        <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/u2pay.webp">
    </div>-->
                                                <!--<div style="position:relative;width:55px;" v-if="obj_agentInfo.LPTHBCC && obj_agentInfo.LPTHBPK">
        <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/luckypay.webp">
    </div>-->
                                                <!--<div style="position:relative;width:55px;" v-if="obj_agentInfo.BCPDA && obj_agentInfo.BCPDK && obj_agentInfo.BCPWA && obj_agentInfo.BCPWK">
        <img class="img-fluid p-1" style="filter: drop-shadow(3px 3px 5px #222);max-width:40px" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/bcpay.webp">
    </div>-->
                                            </div>
                                        </div>
                                        <div class="col-md-12" v-if="obj_agentInfo.CPG < 1">
                                            <div class="text-center" v-if="!obj_agentInfo.H2PU && !obj_agentInfo.H2PCC && !obj_agentInfo.H2PMC && !obj_agentInfo.H2PSC &&
                                                                                !obj_agentInfo.EZPUSDMN && !obj_agentInfo.EZPUSDAS || !obj_agentInfo.EZPIDRMN && !obj_agentInfo.EZPIDRAS || !obj_agentInfo.EZPMYRMN && !obj_agentInfo.EZPMYRAS || !obj_agentInfo.EZPTHBMN && !obj_agentInfo.EZPTHBAS || !obj_agentInfo.EZPVNDMN && !obj_agentInfo.EZPVNDAS &&
                                                                                !obj_agentInfo.OOPTHMN && !obj_agentInfo.OOPTHAS && !obj_agentInfo.OOPTHSK && !obj_agentInfo.OOPVIMN && !obj_agentInfo.OOPVIAS && !obj_agentInfo.OOPVISK && !obj_agentInfo.OOPIDMN && !obj_agentInfo.OOPIDAS && !obj_agentInfo.OOPIDSK &&
                                                                                !obj_agentInfo.TUPVNDMN && !obj_agentInfo.TUPVNDAS && !obj_agentInfo.TUPMYRMN && !obj_agentInfo.TUPMYRAS &&
                                                                                !obj_agentInfo.XFTHN && !obj_agentInfo.XFTHK && !obj_agentInfo.XFVIN && !obj_agentInfo.XFVIK && !obj_agentInfo.XFMYRN && !obj_agentInfo.XFMYRK && !obj_agentInfo.XFUSDTN && !obj_agentInfo.XFUSDTK && !obj_agentInfo.XFIDRN && !obj_agentInfo.XFIDRK &&
                                                                                !obj_agentInfo.SPMN && !obj_agentInfo.SPAK &&
                                                                                !obj_agentInfo.SUMYRCN && !obj_agentInfo.SUMYRMN && !obj_agentInfo.SUMYRAK && !obj_agentInfo.SUTHBCN && !obj_agentInfo.SUTHBMN && !obj_agentInfo.SUTHBAK && !obj_agentInfo.SUSGDCN && !obj_agentInfo.SUSGDMN && !obj_agentInfo.SUSGDAK && !obj_agentInfo.SUIDRCN && !obj_agentInfo.SUIDRMN && !obj_agentInfo.SUIDRAK &&
                                                                                !obj_agentInfo.CPSV1 && !obj_agentInfo.CPSV2 && !obj_agentInfo.CPAPIU &&
                                                                                !obj_agentInfo.FUPSV1 && !obj_agentInfo.FUPSV2 && !obj_agentInfo.FUPAPIU &&
                                                                                !obj_agentInfo.TMSV1 && !obj_agentInfo.TMSV2 && !obj_agentInfo.TMAPIU &&
                                                                                !obj_agentInfo.LPSV1 && !obj_agentInfo.LPSV2 && !obj_agentInfo.LPAPIU &&
                                                                                !obj_agentInfo.BCPSV1 && !obj_agentInfo.BCPSV2 && !obj_agentInfo.BCPAPIU &&
                                                                                !obj_agentInfo.U2PIDRSV1 && !obj_agentInfo.U2PIDRSV2 &&
                                                                                !obj_agentInfo.SPSV1 && !obj_agentInfo.SPSV2 && !obj_agentInfo.SPIDRSV1 && !obj_agentInfo.SPIDRSV2 &&
                                                                                !obj_agentInfo.hasAD3P &&
                                                                                !obj_agentInfo.FPGSV1 && !obj_agentInfo.FPGSV2 &&
                                                                                !obj_agentInfo.PGASV1 && !obj_agentInfo.PGASV2 &&
                                                                                !obj_agentInfo.PPSV1 && !obj_agentInfo.PPSV2 &&
                                                                                !obj_agentInfo.DNSV1 && !obj_agentInfo.DNSV2 &&
                                                                                !obj_agentInfo.AGPSV1 && !obj_agentInfo.AGPSV2 &&
                                                                                !obj_agentInfo.P918SV1 && !obj_agentInfo.P918SV2 &&
                                                                                !obj_agentInfo.P918SV3 && !obj_agentInfo.P918SV4 &&
                                                                                !obj_agentInfo.UPSV1 && !obj_agentInfo.UPSV2 &&
                                                                                !obj_agentInfo.U2PIDRGMN && !obj_agentInfo.U2PIDRGAS && !obj_agentInfo.U2PIDRGK && !obj_agentInfo.U2PIDRDMN && !obj_agentInfo.U2PIDRDAS && !obj_agentInfo.U2PIDRDK && !obj_agentInfo.U2PIDROMN && !obj_agentInfo.U2PIDROAS && !obj_agentInfo.U2PIDROK &&
                                                                                !obj_agentInfo.LPTHBCC && !obj_agentInfo.LPTHBPK &&
                                                                                !obj_agentInfo.BCPDA && !obj_agentInfo.BCPDK && !obj_agentInfo.BCPWA && !obj_agentInfo.BCPWK &&
                                                                                !obj_agentInfo.OPTHBSV1 && !obj_agentInfo.OPTHBSV2 && !obj_agentInfo.OPIDRSV1 && !obj_agentInfo.OPIDRSV2 && !obj_agentInfo.OPVNDSV1 && !obj_agentInfo.OPVNDSV2 &&
                                                                                !obj_agentInfo.MPMYRSV1 && !obj_agentInfo.MPMYRSV2 &&
                                                                                !obj_agentInfo.VIPSV1 && !obj_agentInfo.VIPSV2 && !obj_agentInfo.VIPSV3 &&
                                                                                ((!obj_agentInfo.AFPSV1 && !obj_agentInfo.AFPSV2) || (!obj_agentInfo.AFPSV3 && !obj_agentInfo.AFPSV4)) &&
                                                                                !obj_agentInfo.ONEPSV1 && !obj_agentInfo.ONEPSV2 &&
                                                                                !obj_agentInfo.BLEUPSV1 && !obj_agentInfo.BLEUPSV2 &&
                                                                                !obj_agentInfo.E88PSV1 && !obj_agentInfo.E88PSV2 &&
                                                                                !obj_agentInfo.PPYPSV1 && !obj_agentInfo.PPYPSV2 &&
                                                                                !obj_agentInfo.ECPSV1 && !obj_agentInfo.ECPSV2 && !obj_agentInfo.ECPSV3 &&
                                                                                ((!obj_agentInfo.ZPAYTHBSV1 && !obj_agentInfo.ZPAYTHBSV2) || (!obj_agentInfo.ZPAYINRSV1 && !obj_agentInfo.ZPAYINRSV2) || (!obj_agentInfo.ZPAYBRLSV1 && !obj_agentInfo.ZPAYBRLSV2) || (!obj_agentInfo.ZPAYVNDSV1 && !obj_agentInfo.ZPAYVNDSV2) || (!obj_agentInfo.ZPAYMYRSV1 && !obj_agentInfo.ZPAYMYRSV2)) &&
                                                                                !obj_agentInfo.UPAYSV1 && !obj_agentInfo.UPAYSV2 &&
                                                                                (
                                                                                (!obj_agentInfo.PAYPROUSDSV1 && !obj_agentInfo.PAYPROUSDSV2 && !obj_agentInfo.PAYPROUSDSV3 && !obj_agentInfo.PAYPROUSDSV4) ||
                                                                                (!obj_agentInfo.PAYPROMYRSV1 && !obj_agentInfo.PAYPROMYRSV2 && !obj_agentInfo.PAYPROMYRSV3 && !obj_agentInfo.PAYPROMYRSV4) ||
                                                                                (!obj_agentInfo.PAYPROTHBSV1 && !obj_agentInfo.PAYPROTHBSV2 && !obj_agentInfo.PAYPROTHBSV3 && !obj_agentInfo.PAYPROTHBSV4) ||
                                                                                (!obj_agentInfo.PAYPROIDRSV1 && !obj_agentInfo.PAYPROIDRSV2 && !obj_agentInfo.PAYPROIDRSV3 && !obj_agentInfo.PAYPROIDRSV4) ||
                                                                                (!obj_agentInfo.PAYPROVNDSV1 && !obj_agentInfo.PAYPROVNDSV2 && !obj_agentInfo.PAYPROVNDSV3 && !obj_agentInfo.PAYPROVNDSV4) ||
                                                                                (!obj_agentInfo.PAYPROHKDSV1 && !obj_agentInfo.PAYPROHKDSV2 && !obj_agentInfo.PAYPROHKDSV3 && !obj_agentInfo.PAYPROHKDSV4) ||
                                                                                (!obj_agentInfo.PAYPROBDTSV1 && !obj_agentInfo.PAYPROBDTSV2 && !obj_agentInfo.PAYPROBDTSV3 && !obj_agentInfo.PAYPROBDTSV4) ||
                                                                                (!obj_agentInfo.PAYPROBRLSV1 && !obj_agentInfo.PAYPROBRLSV2 && !obj_agentInfo.PAYPROBRLSV3 && !obj_agentInfo.PAYPROBRLSV4) ||
                                                                                (!obj_agentInfo.PAYPROPHPSV1 && !obj_agentInfo.PAYPROPHPSV2 && !obj_agentInfo.PAYPROPHPSV3 && !obj_agentInfo.PAYPROPHPSV4)
                                                                                ) &&
                                                                                !obj_agentInfo.DGPCNYSV1 && !obj_agentInfo.DGPCNYSV2 &&
                                                                                ((!obj_agentInfo.S7PVNDSV1 && !obj_agentInfo.S7PVNDSV2) || (!obj_agentInfo.S7PVNDSV3 && !obj_agentInfo.S7PVNDSV4) || (!obj_agentInfo.S7PVNDSV5 && !obj_agentInfo.S7PVNDSV6) || (!obj_agentInfo.S7PVNDSV7 && !obj_agentInfo.S7PVNDSV8) || (!obj_agentInfo.S7PVNDSV9 && !obj_agentInfo.S7PVNDSV10))
                                                                                && !obj_agentInfo.PNGSV1 && !obj_agentInfo.PNGSV2 && !obj_agentInfo.PNGSV3 && !obj_agentInfo.PNGSV4
                                                                                && !obj_agentInfo.PLSV1 && !obj_agentInfo.PLSV2 && !obj_agentInfo.HUIJUCAISV1 && !obj_agentInfo.HUIJUCAISV2 && !obj_agentInfo.BestPaySV1 && !obj_agentInfo.BestPaySV2
                                                                                && !obj_agentInfo.CLPSV1 && !obj_agentInfo.CLPSV2 && !obj_agentInfo.CLPSV3 && !obj_agentInfo.CLPSV4 && !obj_agentInfo.CLPSV5
                                                                                && ((!obj_agentInfo.LNWPAYUSDSV1) || (!obj_agentInfo.LNWPAYHKDSV1)) ">
                                                {{getLanguage["GL"]["NR"]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="bool_showAgentInfo">
                            <div class="col-md-12 mt-2">
                                <div class="" style=" background: #fff; padding: 10px; border: 1px solid #ddd; border-radius: 5px; height: 100%" v-if="(bool_showSMMAInfo || bool_showAgentInfo) && arr_Domain.length > 0">
                                    <div class="row justify-content-end mb-2" v-if="obj_agentInfo.RS && obj_agentInfo.DN">
                                        <div class="col-md-6">
                                            <div class="font-weight-bold text-right">
                                                {{getLanguage["DM"]["MT"]}} <i class="fa-sharp fa-solid fa-screwdriver-wrench"></i> :
                                                <label class="switch domainMaintain">
                                                    <input type="checkbox" v-model="obj_agentInfo.RS" @change="updateDomainStatusSetting(obj_agentInfo.DI, obj_agentInfo.RS)" true-value="1" false-value="2" :disabled="!checkModuleAccess('ASS', 'AGS', constAccessType.edit)" >
                                                    <span class="slider round STYLE_unlock" :style="disabledPointer()"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card" v-for="(data,index) in arr_Domain" :key="data.I" v-if="obj_agentInfo.DI == data.I">
                                        <div class="card-body " style="padding: .5rem; background: #edf8eb; border: solid 1px #28A745; border-radius: 0.25rem; ">
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <p class="font-weight-bold mb-0" style="font-size:12px;">
                                                        {{getLanguage["BN"]["DN"]}}

                                                        <span class="custom_tooltip" v-if="((isSENS == 1 && obj_agentInfo.AGI == curAGI) || isSENS == 0) && checkModuleAccess('ASS', 'AGS', constAccessType.edit)">
                                                            <i class="cil-sync" @click="clearCache()"></i>
                                                            <span class="tooltiptext">{{getLanguage["BTN"]["CCACHE"]}}</span>
                                                        </span>
                                                    </p>

                                                    <div v-if="data.RS==1" class="custom_tooltip">
                                                        <span class="maintenance">{{ data.DN }}</span>
                                                        <span class="tooltiptext">{{ getLanguage["DM"]["MT"] }}</span>
                                                    </div>
                                                    <div v-else>{{ data.DN }}</div>
                                                </div>

                                                <div class="col-md-9">
                                                    <p class="font-weight-bold mb-0" style="font-size:12px;">{{getLanguage["DM"]["ALTDM"]}}</p>

                                                    <span class="row" v-if="data.DomainAlternate != null && data.DomainAlternate.length != 0">
                                                        <span v-for="adn in data.DomainAlternate" class="col-md-4 grid-line">
                                                            {{ adn.DN }}
                                                            <i v-if="adn.UCF" class="cib-cloudflare"></i>
                                                        </span>
                                                    </span>
                                                    <span v-else>-</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button v-if="arr_Domain.length>1" class="btn btn-block font-weight-bold p-0 mt-2" style="font-size:12px;" @click="bool_showDomainList = true">{{getLanguage["DB"]["SM"]}} {{getLanguage["DM"]["D"]}}<i class="fa-fw fas fa-angle-down"></i></button>
                                </div>
                            </div>

                            <div class="col-md-12 mt-2">
                                <div class="h-100" style=" background: #fff; padding: 10px; border: 1px solid #ddd; border-radius: 5px;">
                                    <div class="row">
                                        <div :class="(getUserInfo.AT == 0 || getUserInfo.AT == 3)  ? 'col-md-6' : 'col-md-12'">
                                            <h3 class="font-weight-bold mb-0" style="font-size: 12px;">{{getLanguage['AG']['CL']}}</h3>

                                            <!--<div class="d-flex align-items-center justify-content-center">
                                                <div id="circleProgress6" class="progressbar-js-circle mx-3" style="width:50px;position:relative;">
                                                    <svg viewBox="0 0 100 100" style="display: block; width: 100%;">
                                                        <path d="M 50,50 m 0,-48 a 48,48 0 1 1 0,96 a 48,48 0 1 1 0,-96" stroke="#eee" stroke-width="5" fill-opacity="0"></path>
                                                        <path d="M 50,50 m 0,-48 a 48,48 0 1 1 0,96 a 48,48 0 1 1 0,-96" :stroke="progressBarColor()" stroke-width="5" fill-opacity="0" :style="'stroke-dasharray: '+ (318 * (checkListProgress / 100))+', 301.635; stroke-dashoffset: 15.0818;' "></path>
                                                    </svg>
                                                    <div class="progressbar-text" :style="'color: '+progressBarColor()">
                                                        {{checkListProgress}}%<br />
                                                    </div>
                                                </div>
                                            </div>-->
                                            <!--Checklist-->
                                            <table class='custom-table w-100 domaincheckList mt-2'>
                                                <tbody>
                                                    <!--Domain Setting-->
                                                    <tr v-if="obj_agentInfo.DSET == 1">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" fill="#28a745"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">1. {{getLanguage["AG"]["A"]}} {{ getLanguage["HFS"]["BD"] }}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit','ds')"><i class="fa-solid fa-pen-to-square"></i> {{getLanguage["BTN"]["ED"]}}</div></td>
                                                    </tr>
                                                    <tr v-if="obj_agentInfo.DSET == 0">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z" fill="#e55353"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">1. {{getLanguage["AG"]["A"]}} {{ getLanguage["HFS"]["BD"] }}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit','dss')"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</div></td>
                                                    </tr>
                                                    <!--Language & Currency & Game Setting-->
                                                    <tr v-if="obj_agentInfo.DSS == 1">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" fill="#28a745"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">2. {{getLanguage["AG"]["DSS"]}}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'dss')"><i class="fa-solid fa-pen-to-square"></i> {{getLanguage["BTN"]["ED"]}}</div></td>
                                                    </tr>
                                                    <tr v-if="obj_agentInfo.DSS == 0">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z" fill="#e55353"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">2. {{getLanguage["AG"]["DSS"]}}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'dss')"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</div></td>
                                                    </tr>
                                                    <!--Domain & Member Site Setting-->
                                                    <tr v-if="(getUserInfo.AT == 0 || getUserInfo.AT >= 2) && obj_agentInfo.TMP == 1">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" fill="#28a745"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">3. {{getLanguage["DM"]["D"]}} & {{getLanguage["ACU"]["MSS"]}} </td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'dmss')"><i class="fa-solid fa-pen-to-square"></i> {{getLanguage["BTN"]["ED"]}}</div></td>
                                                    </tr>
                                                    <tr v-if="(getUserInfo.AT == 0 || getUserInfo.AT >= 2) && obj_agentInfo.TMP == 0">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z" fill="#e55353"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">3. {{getLanguage["DM"]["D"]}} & {{getLanguage["ACU"]["MSS"]}} </td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'dmss')"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</div></td>
                                                    </tr>
                                                    <!--Website Config Setting-->
                                                    <tr v-if="(getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_agentInfo.ACS == 1">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" fill="#28a745"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">4. {{getLanguage["ACU"]["ACF"]}} {{getLanguage["ACU"]["ST"]}}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'acs')"><i class="fa-solid fa-pen-to-square"></i> {{getLanguage["BTN"]["ED"]}}</div></td>
                                                    </tr>
                                                    <tr v-if="(getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_agentInfo.ACS == 0">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z" fill="#e55353"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">4. {{getLanguage["ACU"]["ACF"]}} {{getLanguage["ACU"]["ST"]}}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'acs')"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</div></td>
                                                    </tr>
                                                    <!--LiveChat Setting-->
                                                    <tr v-if="(getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_agentInfo.LC == 1">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" fill="#28a745"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">5. {{getLanguage["AG"]["LCS"]}}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'lcs')"><i class="fa-solid fa-pen-to-square"></i> {{getLanguage["BTN"]["ED"]}}</div></td>
                                                    </tr>
                                                    <tr v-if="(getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_agentInfo.LC == 0">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z" fill="#e55353"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">5. {{getLanguage["AG"]["LCS"]}}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'lcs')"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</div></td>
                                                    </tr>
                                                    <!--Bank Account Setting-->
                                                    <tr v-if="(getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_agentInfo.MDB == 1">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" fill="#28a745"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">6. {{getLanguage["AG"]["PGBS"]}}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'bs')"><i class="fa-solid fa-pen-to-square"></i> {{getLanguage["BTN"]["ED"]}}</div></td>
                                                    </tr>
                                                    <tr v-if="(getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_agentInfo.MDB == 0">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z" fill="#e55353"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">6. {{getLanguage["AG"]["PGBS"]}}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'bs')"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</div></td>
                                                    </tr>
                                                    <!--Customize Registration-->
                                                    <tr v-if="(getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_agentInfo.CR == 1">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" fill="#28a745"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">7. {{getLanguage["SMB"]["RCUZ"]}}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'cr')"><i class="fa-solid fa-pen-to-square"></i> {{getLanguage["BTN"]["ED"]}}</div></td>
                                                    </tr>
                                                    <tr v-if="(getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_agentInfo.CR == 0">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z" fill="#e55353"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">7. {{getLanguage["SMB"]["RCUZ"]}}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'cr')"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</div></td>
                                                    </tr>
                                                    <!--Customize Deposit-->
                                                    <tr v-if="(getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_agentInfo.CD == 1">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" fill="#28a745"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">8. {{getLanguage["SMB"]["DCUZ"]}}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'cd')"><i class="fa-solid fa-pen-to-square"></i> {{getLanguage["BTN"]["ED"]}}</div></td>
                                                    </tr>
                                                    <tr v-if="(getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_agentInfo.CD == 0">
                                                        <td style="width:30px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square-fill" viewBox="0 0 16 16"> <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z" fill="#e55353"></path> </svg></td>
                                                        <td style="width: calc(100% - 180px);">8. {{getLanguage["SMB"]["DCUZ"]}}</td>
                                                        <td><div v-if="checkModuleAccess('ASS', 'AGS', constAccessType.edit)" class="pointer" style="color: #1b1b1b;width:auto; display:flex; gap:5px;" @click="openSSA('edit', 'cd')"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</div></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div :class="(getUserInfo.AT == 0 || getUserInfo.AT == 3)  ? 'col-md-6' : 'd-none'">
                                            <h3 class="font-weight-bold mb-2" style="font-size: 12px;">{{getLanguage['AG']['AS']}}</h3>

                                            <div class="row">
                                                <!--<div class="col-md-12 my-1">
                                                    <label class="col-form-label-sm inline inline70 py-0">
                                                        {{getLanguage["DLSS"]["DLSS"]}}
                                                        <span v-if="obj_agentInfo.DLSS == 0"> - <span class="font-weight-bold text-red">{{getLanguage['GS']['OFF']}} </span></span>
                                                        <span v-if="obj_agentInfo.DLSS == 1"> - <span class="font-weight-bold text-green">{{getLanguage['GS']['ON']}} </span></span>
                                                    </label>
                                                    <div class="inline inline30" v-if="obj_agentInfo.DLSS == 0 && checkModuleAccess('ASS', 'AGS', constAccessType.edit)">
                                                        <router-link :to="{ path:'/P/DLSS', query:{ agi: obj_AGI.AGI }}" style="color: #1b1b1b;float:right"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</router-link>
                                                    </div>
                                                    <div class=" inline inline30" v-if="obj_agentInfo.DLSS == 1 && checkModuleAccess('ASS', 'AGS', constAccessType.edit)">
                                                        <router-link :to="{ path:'/P/DLSS', query:{ agi: obj_AGI.AGI, ci: obj_agentInfo.DLSSCI }}" style="color: #1b1b1b;float:right"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["ED"]}}</router-link>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 my-1">
                                                    <label class="col-form-label-sm inline inline70 py-0">
                                                        {{getLanguage["DLSP"]["ADLSP"]}}
                                                        <span v-if="obj_agentInfo.DLSP == 0"> - <span class="font-weight-bold text-red">{{getLanguage['GL']['IAC']}} </span></span>
                                                        <span v-if="obj_agentInfo.DLSP == 2"> - <span class="font-weight-bold text-green">{{getLanguage['GL']['AC']}} </span></span>
                                                    </label>
                                                    <div class="inline inline30" v-if="obj_agentInfo.DLSP == 0 && checkModuleAccess('ASS', 'AGS', constAccessType.edit)">
                                                        <router-link :to="{ path:'/P/DLSP', query:{ agi: obj_AGI.AGI }}" style="color: #1b1b1b;float:right"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</router-link>
                                                    </div>
                                                    <div class=" inline inline30" v-if="obj_agentInfo.DLSP == 2 && checkModuleAccess('ASS', 'AGS', constAccessType.edit)">
                                                        <router-link :to="{ path:'/P/DLSP', query:{ agi: obj_AGI.AGI }}" style="color: #1b1b1b;float:right"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["ED"]}}</router-link>
                                                    </div>
                                                </div>-->

                                                <div class="col-md-12 my-1">
                                                    <label class="col-form-label-sm inline inline70 py-0">
                                                        {{getLanguage["SMB"]["AFFS"]}}
                                                        <span v-if="obj_agentInfo.AS == 0"> - <span class="font-weight-bold text-red">{{getLanguage['MEM']['DAC']}} </span></span>
                                                        <span v-if="obj_agentInfo.AS == 2"> - <span class="font-weight-bold text-green">{{getLanguage['AFF']['ACT']}} </span></span>
                                                    </label>
                                                    <div class="inline inline30" v-if="obj_agentInfo.AS == 0 && checkModuleAccess('ASS', 'AGS', constAccessType.edit)">
                                                        <router-link :to="{ path:'/AFF/AFFS', query:{ agi: obj_AGI.AGI }}" style="color: #1b1b1b;float:right"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</router-link>
                                                    </div>
                                                    <div class=" inline inline30" v-if="obj_agentInfo.AS == 2 && checkModuleAccess('ASS', 'AGS', constAccessType.edit)">
                                                        <router-link :to="{ path:'/AFF/AFFS', query:{ agi: obj_AGI.AGI }}" style="color: #1b1b1b;float:right"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["ED"]}}</router-link>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 my-1">
                                                    <label class="col-form-label-sm inline inline70 py-0">
                                                        {{getLanguage["SMB"]["GS"]}} ({{getLanguage["GC"]["0"]}})
                                                        <span v-if="obj_agentInfo.GS == 0"> - <span class="font-weight-bold text-red">{{getLanguage['GS']['NS']}} </span></span>
                                                        <span v-if="obj_agentInfo.GS == 1"> - <span class="font-weight-bold text-green">{{getLanguage['GS']['S']}} </span></span>
                                                    </label>
                                                    <div class="inline inline30" v-if="obj_agentInfo.GS == 0 && checkModuleAccess('ASS', 'AGS', constAccessType.edit)">
                                                        <router-link :to="{ path:'/GS/GSDU', query:{ agi: obj_AGI.AGI }}" style="color: #1b1b1b;float:right"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["AD"]}}</router-link>
                                                    </div>
                                                    <div class=" inline inline30" v-if="obj_agentInfo.GS == 1 && checkModuleAccess('ASS', 'AGS', constAccessType.edit)">
                                                        <router-link :to="{ path:'/GS/GSDU', query:{ agi: obj_AGI.AGI }}" style="color: #1b1b1b;float:right"><i class="fa fa-plus-square"></i> {{getLanguage["BTN"]["ED"]}}</router-link>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="bool_showInvoiceInfo">
                            <div class="col-md-12 mt-2">
                                <div class="" style=" background: #fff; padding: 10px; border: 1px solid #ddd; border-radius: 5px;">
                                    <div class="text-left d-flex align-items-center" style="margin-bottom:20px;">
                                        <div class='searchCol' style="margin-right: 10px;">
                                            <vue-monthly-picker v-model="YearMonthByA"
                                                                :clearOption="false"
                                                                dateFormat="YYYY-MMM"
                                                                selectedBackgroundColor="blue"
                                                                @selected="ChangeToMonthByAgent">
                                            </vue-monthly-picker>
                                        </div>

                                        <CButton color="outline-dark" size="sm"
                                                 v-if="obj_MaintainAccountingMainByA!= null && obj_MaintainAccountingMainByA.RS >= 3"
                                                 @click="generatePDF">
                                            <span class='plusIcon cil-plus'></span>
                                            {{getLanguage['FR']['VPDF']}}
                                        </CButton>
                                    </div>
                                    <h4 id="traffic" class="card-title mb-0">{{getLanguage["GL"]["P"]}}  {{ str_yearmonthByA }} {{getLanguage["AD"]["IN"]}}</h4>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div margin="auto" v-if="obj_MaintainAccountingMainByA != null && obj_MaintainAccountingMainByA.RS >= 3">
                                                <div style="border: 1px #D3D3D3 solid; border-radius: 5px; background: white; box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);">
                                                    <div style="width: 21cm; min-height: 29.7cm; padding: .5cm; margin-top: .5cm; font-size: 12px;">
                                                        <div class="" ref="capture">
                                                            <div class="image-container" style="margin-top:10px;">
                                                                <img class="image-left" src="@/assets/images/poweredbyAFBGG_black.png" crossorigin="anonymous" alt="GG icon">
                                                                <img class="image-right" src="@/assets/images/accounting_demo.png" crossorigin="anonymous" alt="address">
                                                            </div>

                                                            <div class="invoice-container">
                                                                <div class="left-section">
                                                                    <h6 class="font-weight-bold">{{getLanguage['ACT']['IT']}}</h6>
                                                                    <p class="recipient-name">{{obj_agentInfo.GN}}</p>
                                                                    <p><strong>P :</strong> <span>-</span></p>
                                                                    <p><strong>E :</strong> <span>-</span></p>
                                                                </div>
                                                                <div class="right-section">
                                                                    <h1 class="text-uppercase" style="letter-spacing:10px">{{getLanguage['ACT']['INV']}}</h1>
                                                                    <div class="invoice-details">
                                                                        <p><strong>{{getLanguage['ACT']['IN']}} </strong> <span class="ml-2">{{obj_MaintainAccountingMainByA.IN}}</span></p>
                                                                        <p><strong>{{getLanguage['HEA']['AC']}}</strong> <span class="ml-2">-</span></p>
                                                                        <p><strong>{{getLanguage['ACT']['ID']}}</strong> <span class="ml-2">{{ formatDateTime(obj_MaintainAccountingMainByA.ID, 'YYYY-MM-DDTHH:mm:ss', 'DD MMM YYYY') }}</span></p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <table class="custom-table afb-blue">
                                                                <thead>
                                                                    <tr style="background-color: #106c34 !important; color: white;">
                                                                        <th style="background-color: #106c34 !important; color: white !important;">{{getLanguage['GL']['NO']}}</th>
                                                                        <th style="background-color: #106c34 !important; color: white !important;">{{getLanguage['ACT']['IDES']}}</th>
                                                                        <th style="background-color: #106c34 !important; color: white !important;">{{getLanguage['ACT']['QTY']}}</th>
                                                                        <th style="background-color: #106c34 !important; color: white !important;">{{getLanguage['ACT']['CUR']}}</th>
                                                                        <th style="background-color: #106c34 !important; color: white !important; text-align: right;">{{getLanguage['ACT']['UP']}}</th>
                                                                        <th style="background-color: #106c34 !important; color: white !important; text-align: right;">{{getLanguage['ACT']['ER']}}</th>
                                                                        <th style="background-color: #106c34 !important; color: white !important; text-align: right;">{{getLanguage['MEM']['A']}}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item, index) in obj_SavedMaintainInfoByA" :key="item.id" v-if="item.ISI === 1">
                                                                        <td v-if="item.ISI === 1">
                                                                            {{ getDisplayIndexByA(index) }}
                                                                        </td>
                                                                        <td>{{ item.IDT }}</td>
                                                                        <td class="text-center">
                                                                            <template>
                                                                                {{ item.QT }}
                                                                            </template>
                                                                        </td>
                                                                        <td>{{ item.ISOC }}</td>
                                                                        <td class="tableCtnRight" :class="{'positive-number': item.AMT >= 0, 'negative-number': item.AMT < 0}">
                                                                            <template>
                                                                                {{ formatNumber(item.AMT, 2) }}
                                                                            </template>
                                                                        </td>
                                                                        <td class="tableCtnRight">
                                                                            <template v-if="item.ER === 1.0000 || item.ER === 1000.0000">
                                                                                {{ formatNumber(item.ER, 2) }}
                                                                            </template>
                                                                            <template v-else>
                                                                                {{ formatNumber(item.ER, 8).replace(/\.?0+$/, '') }}
                                                                            </template>
                                                                        </td>
                                                                        <td :class="{'positive-number': item.ICTB === 0 || item.ER * item.QT * item.AMT >= 0, 'negative-number': item.ICTB !== 0 && item.ER * item.QT * item.AMT < 0, 'tableCtnRight': true}">
                                                                            <span v-if="item.ICTB === 0">{{formatNumber(0,2) }}</span>
                                                                            <span v-else>
                                                                                {{ item.ER * item.QT * item.AMT < 0 ? '-' : '' }}{{ formatNumber(Math.abs(item.ER * item.QT * item.AMT), 2) }}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <table class="invoice-table">
                                                                <tr>
                                                                    <td class="w-50"></td>
                                                                    <td class="right-section">
                                                                        <table class="details-table">
                                                                            <tr v-for="(item, index) in obj_MaintainAccountingByA">
                                                                                <td class="details-label">
                                                                                    <strong>{{getLanguage['ACT']['SUB']}} ({{ getCurrencyLabel(item.CI.toString()) }})</strong>
                                                                                </td>
                                                                                <td class="details-value font-weight-bold">
                                                                                    <span :class="item.TA >= 0 ? 'positive-number' : 'negative-number'">
                                                                                        {{formatNumber(item.TA, 2)}}
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="details-label">
                                                                                    <strong>{{getLanguage['ACT']['TR']}}</strong>
                                                                                </td>
                                                                                <td class="details-value font-weight-bold">
                                                                                    <strong>{{ formatNumber(0,2)}}%</strong>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="details-label">
                                                                                    <strong>{{getLanguage['FR']['O']}}</strong>
                                                                                </td>
                                                                                <td class="details-value font-weight-bold">
                                                                                    <strong>{{ formatNumber(0,2) }}</strong>
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </table>

                                                            <table class="total-due-grand-total-table">
                                                                <tr class="total-due-row" v-for="(item, index) in obj_MaintainAccountingByA">
                                                                    <td class="total-due-cell w-50">
                                                                        <strong class="total-due-label text-uppercase">{{getLanguage['ACT']['TDUE']}} ({{ getCurrencyLabel(item.CI.toString()) }})</strong>
                                                                        <strong :class="item.TA >= 0 ? 'positive-number font-weight-bold mr-3' : 'negative-number font-weight-bold mr-3'">
                                                                            {{ formatNumber(item.TA, 2) }}
                                                                        </strong>
                                                                    </td>
                                                                    <td class="grand-total-cell w-50">
                                                                        <strong class="grand-total-label text-uppercase">{{getLanguage['ACT']['GTOT']}} ({{ getCurrencyLabel(item.CI.toString()) }})</strong>
                                                                        <span :class="item.TA >= 0 ? 'positive-number font-weight-bold' : 'negative-number font-weight-bold'">
                                                                            {{ formatNumber(item.TA, 2) }}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            </table>

                                                            <div class="payment-section">
                                                                <div class="payment-header">
                                                                    <div class="payment-header-left">
                                                                        <div class="payment-method">
                                                                            <p>{{getLanguage['ACT']['PMWA']}}</p>
                                                                            <span>-</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="payment-header-right">
                                                                        <div class="account-manager">
                                                                            <p>{{getLanguage['ACT']['AM']}}</p>
                                                                            <span>-</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="separator"></div>

                                                                <div class="payment-thanks mt-3">
                                                                    <p>{{getLanguage['ACT']['TYFYB']}}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <p>{{getLanguage['ACT']['NSO']}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--First Time Setup-->
                        <div class="row" v-if="bool_showFTSInfo">
                            <div class="col-md-12 mt-2">
                                <CCard>
                                    <CCardBody class="modal-body p-3">
                                        <CRow>
                                            <CCol col="10">
                                                <h4 id="traffic" class="card-title mb-0">{{getLanguage['ACT']['AMD']}}:</h4>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="12">
                                                <h6 class="card-title section-title2"><span>1</span> {{getLanguage['ACT']['OTS']}}</h6>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['AG']['SECD']}}<span class="required" /> :</span>
                                                </label>
                                                <treeselect :multiple="false"
                                                            :options="dd_currencyDF"
                                                            :placeholder="getLanguage['AG']['C']"
                                                            @input="CurrencyChange"
                                                            v-model="obj_SMAMaintainInfo.CLACI"
                                                            class="inline inline40"
                                                            :clearable="false"
                                                            ref="CI"
                                                            :disabled="true" />

                                                <CInput :placeholder="getLanguage['AG']['SECD']"
                                                        size="sm"
                                                        class="inline inline60"
                                                        :value="ThousandSeparator(obj_SMAMaintainInfo.SDA, getThousandCurrency ? 3 : 2)"
                                                        @change="v => obj_SMAMaintainInfo.SDA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"
                                                        ref="SDA"
                                                        :disabled="obj_SMAMaintainInfo.GLS == 1"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>


                                            <CCol col="2" class="form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['ACT']['M']}}<span class="required" /> :</span>
                                                </label>

                                                <CInput size="sm"
                                                        type="number"
                                                        v-model.number="obj_SMAMaintainInfo.SDM"
                                                        :min="0"
                                                        :disabled="obj_SMAMaintainInfo.GLS == 1" />
                                            </CCol>
                                            <CCol col="2" class="form-group">

                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['ACT']['ER']}} :</span>
                                                </label>

                                                <CInput :placeholder="getLanguage['ACT']['ER']"
                                                        size="sm"
                                                        :value="ThousandSeparator(obj_SMAMaintainInfo.ER, )"
                                                        @change="v => obj_SMAMaintainInfo.ER = RemoveThousandSeparator(v, 4)"
                                                        ref="ER"
                                                        :disabled="true"></CInput>
                                            </CCol>

                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['ACT']['CL']}}<span class="required" /> :</span>
                                                </label>


                                                <CInput :placeholder="getLanguage['ACT']['CL']"
                                                        size="sm"
                                                        :value="ThousandSeparator(obj_SMAMaintainInfo.CLA, getThousandCurrency ? 3 : 2)"
                                                        @change="v => obj_SMAMaintainInfo.CLA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"
                                                        ref="CLA"
                                                        :disabled="true"></CInput>
                                            </CCol>



                                        </CRow>

                                        <CRow>
                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['AG']['OTSF']}}<span class="required" /> :</span>
                                                </label>

                                                <CInput :placeholder="getLanguage['AG']['OTSF']"
                                                        size="sm"
                                                        :value="ThousandSeparator(obj_SMAMaintainInfo.OTSA, getThousandCurrency ? 3 : 2)"
                                                        @change="v => obj_SMAMaintainInfo.OTSA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"
                                                        ref="OTSA"
                                                        :disabled="obj_SMAMaintainInfo.GLS == 1"></CInput>
                                                <span class="ErrMsg"></span>

                                            </CCol>

                                        </CRow>



                                        <CRow v-if="obj_agentInfo.AT != 2">
                                            <CCol col="12">
                                                <h6 class="card-title section-title2"><span>2</span> {{getLanguage['ACT']['MFAT']}}</h6>
                                            </CCol>
                                        </CRow>

                                        <CRow>
                                            <CCol col="4" class="form-group" v-if="(obj_agentInfo.AT == 1) ">
                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['ACT']['SMMF']}}<span /> :</span>
                                                </label>
                                                <CInput :placeholder="getLanguage['ACT']['SMMF']"
                                                        size="sm"
                                                        :value="ThousandSeparator(obj_SMAMaintainInfo.SMMF, getThousandCurrency ? 3 : 2)"
                                                        @change="v => obj_SMAMaintainInfo.SMMF = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"
                                                        ref="SMMF"
                                                        :disabled="!bool_HasAgentMainteneneceAccess && obj_agentInfo.AT == 1"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                            <CCol col="4" class="form-group" v-if="(obj_agentInfo.AT == 3) ">
                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['ACT']['AMF']}}<span /> :</span>
                                                </label>

                                                <CInput :placeholder="getLanguage['ACT']['AMF']"
                                                        size="sm"
                                                        :value="ThousandSeparator(obj_SMAMaintainInfo.AMF, getThousandCurrency ? 3 : 2)"
                                                        @change="v => obj_SMAMaintainInfo.AMF = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"
                                                        ref="AMF"
                                                        :disabled="!bool_HasAgentMainteneneceAccess && obj_agentInfo.AT == 1"></CInput>
                                            </CCol>
                                        </CRow>

                                        <CRow>
                                            <CCol col="4" class="form-group" v-if="obj_agentInfo.AT == 3">
                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['ACT']['AMFT']}}<span class="required" /> :</span>
                                                </label>

                                                <CInput :placeholder="getLanguage['ACT']['AMFT']"
                                                        size="sm"
                                                        :value="ThousandSeparator(obj_SMAMaintainInfo.MT, getThousandCurrency ? 3 : 2)"
                                                        @change="v => obj_SMAMaintainInfo.MT = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"
                                                        ref="AMF"></CInput>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{ getLanguage["WLRPT"]["SA"] }} :
                                                </label>
                                                <label class="switch">
                                                    <input type="checkbox"
                                                           v-model="isHouseChecked"
                                                           true-value="true"
                                                           false-value="false">
                                                    <span class="slider round darkGreenRound"></span>
                                                </label>
                                            </CCol>
                                        </CRow>

                                        <CRow>
                                            <CCol col="12">
                                                <h6 class="card-title section-title2">
                                                    <span>{{ obj_SMAMaintainInfo.AT === 2 ? '2' : '3' }}</span>
                                                    {{ getLanguage['ACT']['SMFD'] }}
                                                </h6>
                                            </CCol>
                                        </CRow>

                                        <CRow>
                                            <CCol col="4" class="form-group">

                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['ACT']['ACD']}}<span> :</span>
                                                </label>
                                                <div>
                                                    <div v-if="isValidDate(obj_SMAMaintainInfo.ACTS)">
                                                        <CInput size="sm"
                                                                :value="obj_SMAMaintainInfo.ACTS | moment('DD MMM YYYY HH:mm:ss')"
                                                                :disabled="true" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm"
                                                                :disabled="true"
                                                                style="margin-left:10px;" />
                                                    </div>
                                                </div>
                                            </CCol>

                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{ getLanguage["ACT"]["DT"] }}<span class="required" /> :</span>
                                                </label>
                                                <treeselect :multiple="false"
                                                            :options="dd_durationSelection"
                                                            :placeholder="getLanguage['ACT']['DT']"
                                                            :max-height="200"
                                                            v-model="obj_SMAMaintainInfo.DT"
                                                            ref="DT"
                                                            :disabled="(obj_SMAMaintainInfo.DT && obj_SMAMaintainInfo.I > 0) || obj_agentInfo.AT == 1 || obj_agentInfo.AT == 2" />

                                            </CCol>

                                            <CCol col="4" class="form-group" v-if="obj_SMAMaintainInfo.DT == 10">
                                                <label class="col-form-label-sm full-width">
                                                    {{ getLanguage["DB"]["MT"] }}<span class="required" /> :</span>
                                                </label>
                                                <CInput size="sm"
                                                        type="number"
                                                        v-model.number="obj_SMAMaintainInfo.OM"
                                                        :min="0" />

                                            </CCol>

                                            <CCol col="4" class="form-group"
                                                  v-if="(obj_SMAMaintainInfo.DT !== 10 && obj_SMAMaintainInfo.DT != null && isValidDate(obj_SMAMaintainInfo.SD)) ||
                                                        (obj_SMAMaintainInfo.DT === 10 && isValidDate(obj_SMAMaintainInfo.SD) && obj_SMAMaintainInfo.OM != null && obj_SMAMaintainInfo.OM !== 0)">
                                                <label class="col-form-label-sm full-width">
                                                    {{ getLanguage["ACT"]["CMFD"] }}<span> :</span>
                                                </label>

                                                <date-range-picker :show-dropdowns="true"
                                                                   opens="center"
                                                                   :single-date-picker="true"
                                                                   :auto-apply="true"
                                                                   v-model="obj_SMAMaintainInfo.COTSD"
                                                                   :disabled="true">

                                                    <div slot="input" slot-scope="picker">
                                                        <div v-if="isValidDate(obj_SMAMaintainInfo.COTSD)">
                                                            <CInput size="sm"
                                                                    :value="obj_SMAMaintainInfo.COTSD | moment('DD MMM YYYY HH:mm:ss')"
                                                                    @change="DateTimeChange('COTSD', $event)"
                                                                    :disabled="true" />
                                                        </div>
                                                        <div v-else>
                                                            <CInput size="sm"
                                                                    @change="DateTimeChange('COTSD', $event)"
                                                                    :disabled="true"
                                                                    style="margin-left:10px;" />
                                                        </div>
                                                    </div>
                                                </date-range-picker>
                                            </CCol>
                                        </CRow>

                                        <CRow>
                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{ getLanguage["AG"]["GOLIVE"] }} :
                                                </label>
                                                <label class="switch">
                                                    <input type="checkbox"
                                                           v-model="obj_SMAMaintainInfo.GLS"
                                                           @change="updateStartDate"
                                                           true-value="1"
                                                           false-value="0"
                                                           :disabled="obj_SMAMaintainInfo.GLS == 1">
                                                    <span class="slider round darkGreenRound"></span>
                                                </label>
                                            </CCol>

                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{ getLanguage["ACM"]["GLD"] }} :
                                                </label>
                                                <div>
                                                    <CInput size="sm"
                                                            :value="obj_SMAMaintainInfo.SD ? $moment(obj_SMAMaintainInfo.SD).format('DD MMM YYYY HH:mm:ss') : ''"
                                                            :disabled="true" />
                                                </div>
                                            </CCol>
                                        </CRow>

                                        <CRow>
                                            <CCol col="12">
                                                <h6 class="card-title section-title2"><span>4</span> {{getLanguage['ACM']['DET']}}</h6>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="4" class="form-group" >
                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['ACM']['WON']}}<span /> :</span>
                                                </label>
                                                <CInput :placeholder="getLanguage['ACM']['WON']"
                                                        size="sm">
                                                </CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>

                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['ACM']['MN']}}<span /> :</span>
                                                </label>
                                                <CInput :placeholder="getLanguage['ACM']['MN']"
                                                        size="sm">
                                                </CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>

                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['ACM']['TLG']}}<span /> :</span>
                                                </label>
                                                <CInput :placeholder="getLanguage['ACM']['TLG']"
                                                        size="sm">
                                                </CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>

                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['ACM']['FPIC']}}<span /> :</span>
                                                </label>
                                                <CInput :placeholder="getLanguage['ACM']['FPIC']"
                                                        size="sm">
                                                </CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>

                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['ACM']['FCON']}}<span /> :</span>
                                                </label>
                                                <CInput :placeholder="getLanguage['ACM']['FCON']"
                                                        size="sm">
                                                </CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>

                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{getLanguage['ACM']['INTR']}}<span /> :</span>
                                                </label>
                                                <CInput :placeholder="getLanguage['ACM']['INTR']"
                                                        size="sm">
                                                </CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                        </CRow>
                                        <CButton v-if="getUserInfo.AT == 0"
                                                 @click="SaveFirstTimeSetup()"
                                                 color="outline-info"
                                                 size="sm"
                                                 style="margin-top:15px;">
                                            <span class='plusIcon cil-plus'></span>
                                            {{ getLanguage["BTN"]["SV"] }}
                                        </CButton>

                                        <CButton v-if="getUserInfo.AT == 0"
                                                 @click="CancelSaveFirstTime()"
                                                 color="outline-info"
                                                 size="sm"
                                                 style="margin-top:15px;">

                                            {{ getLanguage["BETRPT"]["SC"] }}
                                        </CButton>

                                    </CCardBody>
                                </CCard>
                            </div>

                        </div>

                        <!--Agent Default Currency-->
                        <div class="row" v-if="bool_showMaintainInfo">
                            <div class="col-md-12 mt-2">
                                <div class="" style=" background: #fff; padding: 10px; border: 1px solid #ddd; border-radius: 5px;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div v-if="obj_AGI.AGI && bool_showMaintainInfo" class="mx-0">
                                                <div class="d-flex justify-content-between w-100">
                                                    <div class="text-left d-flex" style="gap: 2rem">
                                                        <div style="margin-bottom: 10px; margin-right: 10px;">
                                                            <div class='searchLabel' style="color: #000; font-size: 12px;">{{getLanguage["ACT"]["ADC"]}} :</div>
                                                            <div class="font-weight-bold " style="color: #000; font-size: 11px">{{obj_agentInfo.ISOC}}</div>
                                                        </div>

                                                        <div style="margin-bottom: 10px; margin-right: 10px;">
                                                            <div class='searchLabel' style="color: #000; font-size: 12px;">
                                                                <div class='searchLabel' style="color: #000; font-size: 12px;">{{getLanguage["ACT"]["TCL"]}} :</div>
                                                                <div class="font-weight-bold " style="color: #000; font-size: 11px">{{formatNumber(obj_agentInfo.TB,2)}}</div>
                                                            </div>
                                                        </div>

                                                        <div style="margin-bottom: 10px; margin-right: 10px;">
                                                            <div class='searchLabel' style="color: #000; font-size: 12px;">
                                                                <div class='searchLabel' style="color: #000; font-size: 12px;">{{getLanguage["ACT"]["DPT"]}} :</div>
                                                                <div class="font-weight-bold " style="color: #000; font-size: 11px">
                                                                    {{ obj_agentInfo.DPT !== null && obj_agentInfo.DPT !== undefined ? Number(obj_agentInfo.DPT).toFixed(2) : '0.00' }}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div style="margin-bottom: 10px; margin-right: 10px;">
                                                            <div v-if="obj_MaintainAccountingMain != null && obj_MaintainAccountingMain.RS == 4">
                                                                <div class='searchLabel' style="color: #000; font-size: 12px;">
                                                                    <div class='searchLabel' style="color: #000; font-size: 12px;">{{getLanguage["ACT"]["SOD"]}} :</div>
                                                                    <div class="font-weight-bold " style="color: #000; font-size: 11px">
                                                                        {{formatDateTime(obj_MaintainAccountingMain.SOD, 'YYYY-MM-DD HH:mm:ss', 'DD MMM YYYY HH:mm:ss')}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div style="margin-bottom: 10px; margin-right: 10px;">
                                                            <div v-if="obj_MaintainAccountingMain != null && obj_MaintainAccountingMain.RS == 4">
                                                                <div class='searchLabel' style="color: #000; font-size: 12px;">{{getLanguage["ACT"]["SOB"]}} :</div>
                                                                <div class="font-weight-bold " style="color: #000; font-size: 11px">
                                                                    {{obj_MaintainAccountingMain.UB}}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <!--Programme Month-->
                                            <div class="d-flex justify-content-between w-100 col-md-12" style="margin-bottom:15px;">
                                                <div class="text-left d-flex align-items-center row" style="gap:18px">
                                                    <div>
                                                        <div class="d-flex flex-wrap align-items-end" style="gap:10px">
                                                            <div>
                                                                <span class='searchLabel'>{{getLanguage["AFF"]["PD"]}} :</span>
                                                                <vue-monthly-picker v-model="YearMonth"
                                                                                    :clearOption="false"
                                                                                    dateFormat="YYYY-MMM"
                                                                                    selectedBackgroundColor="blue"
                                                                                    @selected="ChangeToMonth">
                                                                </vue-monthly-picker>
                                                            </div>
                                                            <button @click="UploadReceipt(data)" class="btn btn-sm btn-dark" v-if="obj_AGI.AGI && bool_showMaintainInfo">{{getLanguage["DCUZ"]["UREC"]}}</button>
                                                            <CButton color="outline-dark" size="sm" v-if="obj_MaintainAccountingMain != null" @click="toggleInvoiceReceiptsVisibility">{{getLanguage["BTN"]["VRECEIPT"]}} </CButton>
                                                            <div>
                                                                <span class='searchLabel' v-if="obj_MaintainAccountingMain != null && obj_MaintainAccountingMain.RS != 4 && (!bool_isMTNEdit && obj_SavedMaintainInfo.every(item => !item.isEditing && !item.IsEdit))">{{getLanguage["ACT"]["LSTS"]}} {{formatDateTime(obj_MaintainAccountingMain.STS, 'YYYY-MM-DD', 'DD MMM YYYY')}}</span>
                                                                <div class="d-flex" style="gap: 10px">
                                                                    <CButton color="outline-dark" size="sm"
                                                                             v-if="obj_MaintainAccountingMain != null && obj_MaintainAccountingMain.RS != 4 && (!bool_isMTNEdit && obj_SavedMaintainInfo.every(item => !item.isEditing && !item.IsEdit))"
                                                                             @click="updateItemData()">
                                                                        {{getLanguage["ACT"]["SD"]}}
                                                                    </CButton>
                                                                    <CButton color="outline-dark" size="sm"
                                                                             @click="showPreview()"
                                                                             v-if="obj_MaintainAccountingMain != null && (!bool_isMTNEdit && obj_SavedMaintainInfo.every(item => !item.isEditing && !item.IsEdit)) || obj_MaintainAccountingMain.RS >= 3">
                                                                        {{getLanguage["GL"]["P"]}} {{getLanguage["AD"]["IN"]}}
                                                                    </CButton>
                                                                    <CButton v-if="obj_MaintainAccountingMain != null && obj_MaintainAccountingMain.RS != 4 && (!bool_isMTNEdit && obj_SavedMaintainInfo.every(item => !item.isEditing && !item.IsEdit))"
                                                                             color="outline-dark" size="sm"
                                                                             @click="confirmGenerateInvoice(4)">
                                                                        {{getLanguage["ACT"]["SO"]}}
                                                                    </CButton>
                                                                </div>
                                                            </div>
                                                            <div v-if="obj_MaintainAccountingMain != null && obj_MaintainAccountingMain.RS != 4">
                                                                <treeselect :multiple="false"
                                                                            :options="dd_currencyDF"
                                                                            :placeholder="getLanguage['AG']['C']"
                                                                            v-model="selectedCurrencyForBilling"
                                                                            class="inline inline40"
                                                                            :clearable="false"
                                                                            @input="updateAllCurrencies"
                                                                            openDirection="below"
                                                                            style="width: 200px;">
                                                                </treeselect>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                            <div style="overflow-x:auto;">
                                                <table class='statement-table custom-table afb-blue' style=" width: 100%;">
                                                    <thead>
                                                        <tr>
                                                            <th class="one-line">{{getLanguage["GL"]["NO"]}}</th>
                                                            <th class="one-line" v-if=" bool_canEdit">{{getLanguage["LOGRPT"]["ACT"]}}</th>
                                                            <th class="one-line" style="text-align:center;"><input type="checkbox" v-model="allSelected" :disabled="!bool_canEdit"></th>
                                                            <th class="one-line">{{getLanguage["ACT"]["IDES"]}}</th>
                                                            <th class="one-line text-center">{{getLanguage["ACT"]["QTY"]}}</th>
                                                            <th class="one-line">{{getLanguage["ACT"]["CUR"]}}</th>
                                                            <th class="one-line text-right">{{getLanguage["ACT"]["ER"]}}</th>
                                                            <th class="one-line">{{getLanguage["ACT"]["SDT"]}}</th>
                                                            <th class="one-line">{{getLanguage["ACT"]["AMT"]}}</th>
                                                            <th class="one-line">{{getLanguage["ACT"]["DAMT"]}}</th>
                                                            <th class="one-line">{{getLanguage["ACT"]["CAMT"]}}</th>
                                                            <th class="one-line">{{getLanguage["ACT"]["C"]}}</th>
                                                            <th class="one-line">Under</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-if="bool_canEdit" style="background-color: #ffffff;">
                                                            <td colspan="100%">
                                                                <a href="#" @click="addnewMaintainInfo">{{getLanguage['MAPP']['ANA']}}</a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <draggable v-model="obj_SavedMaintainInfo" tag="tbody" :disabled="obj_MaintainAccountingMain.RS === 4">
                                                        <tr v-for="(data,index) in obj_SavedMaintainInfo" :key="index" style="cursor: move">
                                                            <td>{{index + 1}}</td>
                                                            <td v-if="bool_canEdit">
                                                                <span id="actionBtnCol" v-if="bool_canEdit">
                                                                    <div class="custom_tooltip" v-if="(data.IETB == 1 || data.ISCC == 1) && !data.isEditing ">
                                                                        <i class="cil-color-border" @click="editDataIndex(data.I)"></i>
                                                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                                                    </div>
                                                                    <div class="custom_tooltip" v-if="data.IETB == 1 && data.IETBD == 1">
                                                                        <i class="cil-trash" @click="removeData(data, index)"></i>
                                                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                                    </div>
                                                                </span>
                                                            </td>
                                                            <td style="text-align:center;"><input type="checkbox" :true-value="1" :false-value="0" v-model="data.ISI" @change="handleCheckboxChange(index)" :disabled="!bool_canEdit"></td>
                                                            <td>
                                                                <template v-if="data.isEditing">
                                                                    <textarea v-shortkey.avoid vertical=""
                                                                              rows="1"
                                                                              v-model="data.IDT"
                                                                              class="form-control form-control-sm"
                                                                              :disabled="data.IETBD === 0 && (data.IT !== 0 && (data.IT < 13 || data.IT > 26))"
                                                                              style="width:250px;" />
                                                                    <span class="ErrMsg">{{validateSavedMaintainInfo('IDT','IDES', index)}}</span>
                                                                </template>
                                                                <template v-else>
                                                                    {{ data.IDT }}
                                                                </template>
                                                            </td>
                                                            <td class="text-center">
                                                                <template v-if="data.isEditing">
                                                                    <textarea v-shortkey.avoid vertical="" rows="1"
                                                                              v-model="data.QT"
                                                                              style="text-align:center;"
                                                                              class="form-control form-control-sm"
                                                                              :disabled="data.IETBD === 0">
                                                                    </textarea>
                                                                    <span class="ErrMsg">{{validateSavedMaintainInfo('QT', 'QUANT', index)}}</span>
                                                                </template>
                                                                <template v-else>
                                                                    {{ data.QT }}
                                                                </template>
                                                            </td>
                                                            <td>
                                                                <template v-if="data.isEditing">
                                                                    <treeselect :multiple="false"
                                                                                :options="dd_currencyDF"
                                                                                :placeholder="getLanguage['AG']['C']"
                                                                                @input="CurrencyChangeIndex($event, data)"
                                                                                v-model="data.CI"
                                                                                class="inline inline40"
                                                                                :clearable="false"
                                                                                ref="CI"
                                                                                openDirection="below"
                                                                                style="width: 70px;"
                                                                                :disabled="data.ISCC === 0 || (data.IT !== 0 && data.IT !== 9 && (data.IT < 13 || data.IT > 26))" />
                                                                    <span class="ErrMsg"></span>
                                                                </template>
                                                                <template v-else>
                                                                    {{ data.ISOC}}
                                                                </template>
                                                            </td>
                                                            <td v-if="data.isEditing">
                                                                <CInput size="sm"
                                                                        class="inline inline60 text-right"
                                                                        ref="ER"
                                                                        :value="ThousandSeparatorWithNegative(data.ER, 8)"
                                                                        @change="v => data.ER = RemoveThousandSeparatorWithNegative(v, 8)"
                                                                        :append-to-body="true"
                                                                        style="width: 70px;"></CInput>
                                                                <span class="ErrMsg">{{validateSavedMaintainInfo('ER', 'ER', index)}}</span>
                                                            </td>
                                                            <td v-else class="text-right">
                                                                {{ formatNumber(data.ER, 8) }}
                                                            </td>
                                                            <td v-if="data.isEditing">
                                                                <div class="input-group wide-input" style="display: flex; align-items: center;">
                                                                    <date-range-picker :show-dropdowns="true"
                                                                                       opens="center"
                                                                                       @update="(dt) => DateRangePickerUpdateEvent(dt, data)"
                                                                                       :single-date-picker="true"
                                                                                       :auto-apply="true"
                                                                                       v-model="data.SD"
                                                                                       :disabled="data.IETBD === 0">
                                                                        <div slot="input" slot-scope="picker">
                                                                            <div v-if="isValidDate(data.SD)">
                                                                                <CInput size="sm"
                                                                                        :value="data.SD | moment('DD MMM YYYY HH:mm:ss')"
                                                                                        @change="DateTimeChangeIndex('SD', $event, data)"
                                                                                        :disabled="data.IETBD === 0" />
                                                                            </div>
                                                                            <div v-else>
                                                                                <CInput size="sm"
                                                                                        @change="DateTimeChangeIndex('SD', $event, data)"
                                                                                        :disabled="data.IETBD === 0" />
                                                                            </div>
                                                                        </div>
                                                                    </date-range-picker>
                                                                    <CButton class="dr-clear"
                                                                             size="sm"
                                                                             @click="clearDateFilterIndex(data)"
                                                                             style="margin-left: 10px;"
                                                                             :disabled="data.IETBD === 0">
                                                                        <CIcon name="cilX" size="sm"></CIcon>
                                                                    </CButton>
                                                                </div>
                                                                <span class="ErrMsg text-right">{{validateSavedMaintainInfo('SD', 'SD', index)}}</span>
                                                            </td>
                                                            <td v-else>
                                                                <span v-if="isValidDate(data.SD)">
                                                                    {{ formatDateTime(data.SD, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                                                </span>
                                                                <span v-else></span>
                                                            </td>

                                                            <td class="text-right">
                                                                <template v-if="data.isEditing">
                                                                    <CInput size="sm"
                                                                            class="inline inline60 input-right-align"
                                                                            :value="ThousandSeparatorWithNegative(data.AMT, 2)"
                                                                            @change="v => data.AMT = RemoveThousandSeparatorWithNegative(v, 2)"
                                                                            ref="AMT"
                                                                            :disabled="data.IETBD === 0 && data.IETB === 0"
                                                                            style="width: 100px;">
                                                                    </CInput>
                                                                    <span class="ErrMsg">{{validateSavedMaintainInfo('AMT','AMT',index)}}</span>
                                                                </template>
                                                                <template v-else>
                                                                    <span :class="{'positive-number': data.AMT >= 0, 'negative-number': data.AMT < 0}">
                                                                        {{ formatNumber(data.AMT, 2) }}
                                                                    </span>
                                                                </template>
                                                            </td>
                                                            <td class="positive-number text-right" v-if="data.ER * data.QT * data.AMT >= 0">
                                                                {{ formatNumber(data.ER * data.QT * data.AMT, 2) }}
                                                            </td>
                                                            <td v-else></td>
                                                            <td class="negative-number text-right" v-if="data.ER * data.QT * data.AMT < 0">
                                                                -{{ formatNumber(data.ER * data.QT * data.AMT * -1, 2) }}
                                                            </td>
                                                            <td v-else></td>
                                                            <td style="text-align:center;" v-if="data.ISI != 0">
                                                                <input type="checkbox" :true-value="1" :false-value="0" v-model="data.ICTB" @change="handleCheckboxChange(index)" :disabled="!bool_canEdit">
                                                            </td>
                                                            <td v-else></td>
                                                            <td>
                                                                <template v-if="data.isEditing">
                                                                    <treeselect :multiple="false"
                                                                                :options="dd_currencyDF"
                                                                                :placeholder="getLanguage['AG']['C']"
                                                                                v-model="data.ACID"
                                                                                class="inline inline40"
                                                                                :clearable="false"
                                                                                @input="UnderCurrencyChangeIndex($event, data)"
                                                                                ref="ACID"
                                                                                openDirection="below"
                                                                                style="width: 70px;"/>
                                                                    <span class="ErrMsg"></span>
                                                                </template>
                                                                <template v-else>
                                                                    {{ getCurrencyLabel(data.ACID.toString())}}
                                                                </template>
                                                            </td>
                                                        </tr>
                                                    </draggable>
                                                    <tbody>

                                                        <template v-for="(groupData, ACID) in groupedDataByACID">

                                                            <tr :key="`total-${ACID}`" @click="toggleVisibility(ACID)" style="cursor: pointer;">
                                                                <td :colspan="!bool_canEdit ? 9 : 10" style="text-align: right; background-color: #d0fccc;">
                                                                    <strong>{{getLanguage['DCSR']['T']}} ({{ getCurrencyLabel(ACID) }}):</strong>
                                                                </td>
                                                                <td style="text-align:right; background-color: #d0fccc;">
                                                                    <span class="positive-number" v-if="totalsByACID[ACID] && totalsByACID[ACID].totalPositiveAmount > 0">
                                                                        {{ formatNumber(totalsByACID[ACID].totalPositiveAmount, 2) }}
                                                                    </span>
                                                                    <span class="positive-number" v-else>
                                                                        {{ formatNumber(0, 2) }}
                                                                    </span>
                                                                </td>
                                                                <td style="text-align:right; background-color: #d0fccc;">
                                                                    <span class="negative-number" v-if="totalsByACID[ACID] && totalsByACID[ACID].totalNegativeAmount > 0">
                                                                        -{{ formatNumber(totalsByACID[ACID].totalNegativeAmount, 2) }}
                                                                    </span>
                                                                    <span class="negative-number" v-else>
                                                                        {{ formatNumber(0, 2) }}
                                                                    </span>
                                                                </td>
                                                                <td colspan="100%" style="background-color: #d0fccc;"></td>
                                                            </tr>


                                                            <tr v-if="visibleSections[ACID]" :key="`subtotal-${ACID}`">
                                                                <td :colspan="!bool_canEdit ? 9 : 10" style="text-align:right;">
                                                                    <strong>{{getLanguage["ACT"]["SUB"]}} - {{getLanguage["ACT"]["F"]}} ({{ getCurrencyLabel(ACID) }}):</strong>
                                                                </td>
                                                                <td style="text-align:right;">
                                                                    <span :class="subtotalsByACID[ACID] >= 0 ? 'positive-number' : 'negative-number'">
                                                                        {{ subtotalsByACID[ACID] < 0 ? '-' : '' }}{{ formatNumber(Math.abs(subtotalsByACID[ACID]), 2) }}
                                                                    </span>
                                                                </td>
                                                                <td colspan="100%"></td>
                                                            </tr>

                                                            <tr v-if="visibleSections[ACID]" :key="`collectable-${ACID}`">
                                                                <td :colspan="!bool_canEdit ? 9 : 10" style="text-align:right;">
                                                                    <strong>{{getLanguage["ACT"]["SUB"]}} - {{getLanguage["ACT"]["NC"]}} ({{ getCurrencyLabel(ACID) }}):</strong>
                                                                </td>
                                                                <td style="text-align:right;">
                                                                    <span :class="uncheckedICTBTotalByACID[ACID] >= 0 ? 'positive-number' : 'negative-number'">
                                                                        {{ uncheckedICTBTotalByACID[ACID] < 0 ? '-' : '' }}{{ formatNumber(Math.abs(uncheckedICTBTotalByACID[ACID]), 2) }}
                                                                    </span>
                                                                </td>
                                                                <td colspan="100%"></td>
                                                            </tr>

                                                            <tr v-for="(account, index) in sortedMaintainAccounting"
                                                                v-if="visibleSections[ACID] && account.CI.toString() === ACID"
                                                                :key="`paid-${account.CI}-${index}`">
                                                                <td :colspan="!bool_canEdit ? 8 : 9" style="text-align:right;">
                                                                    <strong>{{getLanguage["ACT"]["PAMT"]}} ({{ getCurrencyLabel(account.CI.toString()) }}): </strong>
                                                                </td>
                                                                <td style="text-align:right;">
                                                                    <CInput size="sm"
                                                                            class="inline inline60 input-right-align"
                                                                            :value="ThousandSeparatorWithNegative(account.PA, 2)"
                                                                            @change="handlePAChange($event, account)"
                                                                            style="width: 100px;"
                                                                            ref="PA"
                                                                            :disabled="true">
                                                                    </CInput>
                                                                </td>
                                                                <td colspan="100%"></td>
                                                            </tr>

                                                            <tr v-for="(account, index) in sortedMaintainAccounting"
                                                                v-if="visibleSections[ACID] && account.CI.toString() === ACID"
                                                                :key="`carryforward-${account.CI}-${index}`">
                                                                <td :colspan="!bool_canEdit ? 9 : 10" style="text-align:right;">
                                                                    <strong>{{getLanguage["ACT"]["CR"]}} ({{ getCurrencyLabel(account.CI.toString()) }}): </strong>
                                                                </td>
                                                                <td style="text-align:right;">
                                                                    <span :class="carryForwardByACID[account.CI.toString()] >= 0 ? 'positive-number' : 'negative-number'">
                                                                        {{ carryForwardByACID[account.CI.toString()] < 0 ? '-' : '' }}{{ formatNumber(Math.abs(carryForwardByACID[account.CI.toString()]), 2) }}
                                                                    </span>
                                                                </td>
                                                                <td colspan="100%"></td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                                <CButton v-if="((obj_SavedMaintainInfo && obj_SavedMaintainInfo.some(item => item.IsEdit || item.isEditing)) || bool_isMTNEdit)"
                                                         @click="saveMaintenanceIsSelected()"
                                                         color="outline-info"
                                                         size="sm"
                                                         style="margin-top:15px;">
                                                    <span class='plusIcon cil-plus'></span>
                                                    {{ getLanguage["BTN"]["SV"] }}
                                                </CButton>

                                                <CButton v-if="((obj_SavedMaintainInfo && obj_SavedMaintainInfo.some(item => item.IsEdit || item.isEditing)) || bool_isMTNEdit)"
                                                         @click="cancelSaveMaintenanceFeeData()"
                                                         color="outline-info"
                                                         size="sm"
                                                         style="margin-top:15px;">
                                                    {{ getLanguage["BETRPT"]["SC"] }}
                                                </CButton>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CRow>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import Loading from 'vue-loading-overlay';
    import genericHelper from "@/modules/GenericHelper.js";
    import VTreeview from "@/views/CustomTreeView/CustomTreeview";
    import moment from "moment";
    import html2canvas from 'html2canvas';
    import JsPDF from 'jspdf';
    import DateRangePicker from 'vue2-daterange-picker';
    import VueMonthlyPicker from 'vue-monthly-picker';
    import VueApexCharts from 'vue-apexcharts'
    import { mapGetters, mapActions } from 'vuex'
    import { required, sameAs, requiredIf, alphaNum, minLength, maxLength, between, decimal, email, minValue, integer } from 'vuelidate/lib/validators';
    import { constAccessType, loadingFullScreen, constHouseBrand, constSuspendReasonBL } from '@/modules/Constant.js'
    import $ from 'jquery'
    import _ from 'lodash'
    import Vue from 'vue'
    import { toRaw } from 'vue';
    import draggable from 'vuedraggable';
    //import Vue from 'vue'
    //Vue.use(require('vue-shortkey'))

    function DateValidation(value, vm) {
        return value && moment(vm.SD, 'YYYY-MM-DDTHH:mm:ss', true).isValid();
    }
    function MinValidation(value, vm) {
        return vm.ER > 0;
    }

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            VTreeview,
            VueMonthlyPicker,
            DateRangePicker,
            html2canvas,
            JsPDF,
            draggable
        },
        data() {
            return {
                selectedCurrencyForBilling: null,
                bool_isAMV: false,
                bool_afterAdd: false,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showTopUp: false,
                bool_showTopUp2: false,
                bool_showNewSupport: false,
                visibleSections: {},
                bool_addMaintainInfo: false,
                bool_addNewMaintainInfo: false,
                bool_OnOff: false,
                bool_canEdit: false,
                bool_Preview: false,
                bool_showInvoiceReceipts: false,
                receipts: [],
                requestSupportType: "",
                bool_isMTNEdit: false,
                ModuleAccessAltDomain_edit: false,
                bool_showAgentInfo: false,
                bool_showSMMAInfo: false,
                bool_showSMInfo: false,
                bool_showFTSInfo: false,
                bool_showMAInfo: false,
                bool_isAddFirstTimeInfo: true,
                bool_showMaintainInfo: false,
                bool_savedMaintainInfoCV: false,
                bool_showDomainList: false,
                bool_showInvoiceInfo: false,
                bool_showCurrencyTable: false,
                formattedTodayDate: '',
                obj_ad: null,
                defaultCurrencyConvertRate: 1,
                selectedFile: null,
                depositCustomLabel: '',
                defaultLabel: 'Deposit Receipt',
                depositMaxFile: '',
                receiptMandatoryList: '',
                ddAgentList: null,
                selectedAgentType: -1,
                bool_isReceipt: false,
                YearMonth: null,
                YearMonthByA: null,
                YearMonthForCSharp: null,
                YearMonthForCSharpByA: null,
                str_yearmonthByA: "",
                str_yearmonth: "",
                openAll: true,
                obj_profile: [],
                obj_agentInfo: [],
                objDomainAlternate: [],
                obj_MaintainAccounting: [],
                bool_HasAgentMainteneneceAccess: false,
                obj_MaintainAccountingMain: [],
                obj_pamt: {
                    CI: 8,
                    AMT: 0,
                    RMK: "",
                },
                obj_AGI: {
                    "AGI": null,
                    "CI": [],
                    "RLI": [],
                    "RGPI": [],
                    "RCI": [],
                },
                obj_PrevAGI: [],
                obj_Balance: {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "AGIT": null,
                    "BT": 1,
                    "BU": 0.00
                },
                obj_AccountingReport: {
                    "I": 0,
                    "RS": 2
                },
                obj_SMAMaintainInfo: {
                    "RS": 2,
                    "SD": '1900-01-01T00:00:00'
                },
                obj_MaintainInfo: {
                    //"I": 0,
                    "RS": 2,
                    //"QT": 1,
                    //"AGI": "",
                    //"AGIT": null,
                    //"ISOC": null,
                    //"AMT": 0.00,
                    //"IDT": null,
                    //"R": null
                },
                obj_SavedMaintainInfo: [],
                obj_SavedMaintainInfoByA: [],
                obj_MaintainAccountingByA: [],
                obj_MaintainAccountingMainByA: [],

                treeData: [],
                openAll: true,
                openNode: null,
                selectedNode: null,
                treeTypes: [
                    {
                        type: "#",
                        max_children: 99999,
                        max_depth: 20,
                        valid_children: [
                            "A"
                        ]
                    },
                    {
                        type: "SSA",
                        icon: "fas fa-user-shield gg-ico gg-ico-ssa",
                        valid_children: ["SA"]
                    },
                    {
                        type: "SA",
                        icon: "fas fa-user-alt gg-ico gg-ico-sa",
                        valid_children: ["MA"]
                    },
                    {
                        type: "MA",
                        icon: "fas fa-user-friends gg-ico gg-ico-ma",
                        valid_children: ["A"]
                    },
                    {
                        type: "A",
                        icon: "fas fa-users gg-ico gg-ico-a",
                        valid_children: ["SAG"]
                    },
                    {
                        type: "1",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag1",
                        valid_children: ["DN"]
                    },
                    {
                        type: "2",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag2",
                        valid_children: ["DN"]
                    },
                    {
                        type: "3",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag3",
                        valid_children: ["DN"]
                    },
                    {
                        type: "4",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag4",
                        valid_children: ["DN"]
                    },
                    {
                        type: "5",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag5",
                        valid_children: ["DN"]
                    },
                    {
                        type: "6",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag6",
                        valid_children: ["DN"]
                    },
                    {
                        type: "7",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag7",
                        valid_children: ["DN"]
                    },
                    {
                        type: "8",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag8",
                        valid_children: ["DN"]
                    },
                    {
                        type: "9",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag9",
                        valid_children: ["DN"]
                    },
                    {
                        type: "10",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag10",
                        valid_children: ["DN"]
                    },
                    {
                        type: "11",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag11",
                        valid_children: ["DN"]
                    },
                    {
                        type: "12",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag12",
                        valid_children: ["DN"]
                    },
                    {
                        type: "13",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag13",
                        valid_children: ["DN"]
                    },
                    {
                        type: "14",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag14",
                        valid_children: ["DN"]
                    },
                    {
                        type: "15",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag15",
                        valid_children: ["DN"]
                    },
                    {
                        type: "16",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag16",
                        valid_children: ["DN"]
                    },
                    {
                        type: "17",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag17",
                        valid_children: ["DN"]
                    },
                    {
                        type: "18",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag18",
                        valid_children: ["DN"]
                    },
                    {
                        type: "19",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag19",
                        valid_children: ["DN"]
                    },
                    {
                        type: "20",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag20",
                        valid_children: ["DN"]
                    },
                    {
                        type: "1O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet1",
                        valid_children: ["DN"]
                    },
                    {
                        type: "2O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet2",
                        valid_children: ["DN"]
                    },
                    {
                        type: "3O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet3",
                        valid_children: ["DN"]
                    },
                    {
                        type: "4O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet4",
                        valid_children: ["DN"]
                    },
                    {
                        type: "5O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet5",
                        valid_children: ["DN"]
                    },
                    {
                        type: "6O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet6",
                        valid_children: ["DN"]
                    },
                    {
                        type: "7O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet7",
                        valid_children: ["DN"]
                    },
                    {
                        type: "8O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet8",
                        valid_children: ["DN"]
                    },
                    {
                        type: "9O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet9",
                        valid_children: ["DN"]
                    },
                    {
                        type: "10O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet10",
                        valid_children: ["DN"]
                    },
                    {
                        type: "11O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet11",
                        valid_children: ["DN"]
                    },
                    {
                        type: "12O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet12",
                        valid_children: ["DN"]
                    },
                    {
                        type: "13O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet13",
                        valid_children: ["DN"]
                    },
                    {
                        type: "14O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet14",
                        valid_children: ["DN"]
                    },
                    {
                        type: "15O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet15",
                        valid_children: ["DN"]
                    },
                    {
                        type: "16O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet16",
                        valid_children: ["DN"]
                    },
                    {
                        type: "17O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet17",
                        valid_children: ["DN"]
                    },
                    {
                        type: "18O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet18",
                        valid_children: ["DN"]
                    },
                    {
                        type: "19O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet19",
                        valid_children: ["DN"]
                    },
                    {
                        type: "20O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet20",
                        valid_children: ["DN"]
                    },
                    {
                        type: "DN",
                        icon: "fas fa-link",
                        valid_children: []
                    },
                ],

                checkListProgress: 0,
                localSD: '',
                dd_currency: [],
                dd_currencyDF: [],
                dd_currency_wall: [],
                //dd_reportcurrency: [],
                dd_gameprovider: [],
                dd_gameprovider_cat: [],
                //dd_currencyICT: [],
                //dd_currencyNonICT: [],
                dd_language: [],
                dd_language_wall: [],
                dd_currency_h2p: [],
                dd_agentgroup: [],
                dd_domainlist: [],
                isDragDropMainList: false,
                dd_GPDefaultPT: [],
                dd_durationSelection: [],
                constAccessType: constAccessType,
                constHouseBrand: constHouseBrand,
                dec_usedbalance: 0,
                dd_paymentgateway_total:
                {
                    Help2pay: { num: 0, currency: [] }, OOPay: { num: 0, currency: [] }, EZPay: { num: 0, currency: [] },
                    TruePay: { num: 0, currency: [] }, XFuoo: { num: 0, currency: [] }, StarPay: { num: 0, currency: [] },
                    SurePay: { num: 0, currency: [] }, CPay: { num: 0, currency: [] }, FuPay: { num: 0, currency: [] },
                    TrueMoney: { num: 0, currency: [] }, U2Pay: { num: 0, currency: [] }, LuckyPay: { num: 0, currency: [] },
                    BCPay: { num: 0, currency: [] }, SmartPay: { num: 0, currency: [] }, FPG: { num: 0, currency: [] },
                    PGA: { num: 0, currency: [] }, PP: { num: 0, currency: [] }, DN: { num: 0, currency: [] },
                    AGP: { num: 0, currency: [] }, P918: { num: 0, currency: [] }, UP: { num: 0, currency: [] },
                    OKP: { num: 0, currency: [] }, MGP: { num: 0, currency: [] }, VIP: { num: 0, currency: [] },
                    AFP: { num: 0, currency: [] }, ONEP: { num: 0, currency: [] }, BLEUP: { num: 0, currency: [] },
                    E88P: { num: 0, currency: [] }, ECP: { num: 0, currency: [] },
                    ZPAY: { num: 0, currency: [] }, UPAY: { num: 0, currency: [] },
                    DGPCNY: { num: 0, currency: [] }, SUPER7VND: { num: 0, currency: [] },
                    PAYPRO: { num: 0, currency: [] }, PAYLITE: { num: 0, currency: [] }, HUIJUCAI: { num: 0, currency: [] },
                    BestPay: { num: 0, currency: [] }, CLOUDPAY: { num: 0, currency: [] }, LNWPAY: { num: 0, currency: [] }             /*, PAYNGO: { num: 0, currency: [] }, PPYP: { num: 0, currency: [] }*/
                },
                str_invalidAmountMsg: "",
                str_invalidPToPAmountMsg: "",

                series: [{
                    name: 'Available Balance',
                    data: []
                },{
                    name: 'Used Balance',
                    data: []
                }, {
                    name: 'Used  <span style="color: #ff0000">90% - 100%</span>',
                    data: []
                    }],



                series2: [{
                    name: 'Available Balance',
                    data: []
                }, {
                    name: 'Used Balance',
                    data: []
                }, {
                    name: 'Used  <span style="color: #ff0000">90% - 100%</span>',
                    data: []
                    }],
                chartOptions: {
                    colors: ['#00e396', '#feb019', '#ed1c24'],
                    chart: {
                        type: 'bar',
                        stacked: true,
                        stackType: '100%',
                        toolbar: {
                            show: false,
                        },
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        },
                    },
                    stroke: {
                        width: 1,
                        colors: ['#fff']
                    },
                    xaxis: {
                        categories: [''],
                        min: 0,
                        max: 100,
                        tickAmount: 5,
                        labels: {
                            formatter: function (val) {
                                return (100 - val);
                            }
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        reversed:true,
                        formatter: function (val) {
                            if (val > 15) {
                                return Math.floor(val * 100) / 100  + '%';
                            }
                            return '';
                        }
                    },
                    yaxis: {
                        reversed: true
                    },
                    tooltip: {
                        enabled: false,
                    },
                    fill: {
                        opacity: 1,
                        colors: ['#00e396',function ({ value }) {
                            return value >= 90 ? '#ed1c24' : '#feb019';
                        }, '#ed1c24']
                    },
                    markers: {
                        radius: 2,
                        margin: 0
                    },
                    legend: {
                        show: true,
                        position: 'bottom',
                        horizontalAlign: 'left',
                        itemMargin: {
                            vertical: 5
                        }
                    }
                },

                btnGP_checkedAll: [],
                btnLang_checkedAll: false,
                btnCur_checkedAll: false,
                selectedGPCat: '0-2',

                bool_isAgentSuspendV: false,
                bool_suspendCV: false,
                obj_Suspend: {
                    "reason": null,
                    "reason2": ""
                },

                arr_Domain: [],
            }
        },
        mounted() {
            const q = this.$route.query.bool_showInvoiceInfo;
            this.bool_showInvoiceInfo = q === 'true' || q === '1';

            if (this.bool_showInvoiceInfo) {
                this.viewInvoiceHistory(); 
            }
            const query = this.$route.query;

            if (query.agi && query.agi != 0 && query.AT) {
                // Set obj_AGI.AGI as "AT-agi" (e.g. "1-123")
                this.obj_AGI.AGI = `${query.AT}-${query.agi}`;

                // Optionally load agent overview immediately
                this.getAgentOverview();
            }
            
        },
        validations : {
            obj_Balance: {
                AGI: { required },
                BU: { required: requiredIf(function () { return !this.obj_Balance.PTPBU || this.obj_Balance.PTPBU === 0;}), decimal },
                PTPBU: { required: requiredIf(function () { return !this.obj_Balance.BU || this.obj_Balance.BU === 0; }), decimal }
            },
            obj_ad: {
                RURL: { required },
            },
            obj_Suspend: {
                reason2: {
                    required: requiredIf(function (vm) {
                        return !vm.reason || vm.reason == 999;
                    }),
                }
            },
            obj_SavedMaintainInfo: {
                $each: {
                    IDT: { required },
                    AMT: { required},
                    QT: { required, integer, minValue: minValue(0) },
                    ER: {
                        required,
                    },
                }
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
            ...mapGetters('SMBData', ['getCurrencySymbol', 'getSystemBalance', 'getCreditBalance', 'getBalanceStatus', 'getCurrencyCode']),
            totalPositiveAmount() {
                if (!this.obj_SavedMaintainInfo || this.obj_SavedMaintainInfo.length === 0) {
                    return (0).toFixed(2);
                }
                return this.obj_SavedMaintainInfo.reduce((total, data) => {
                    if (data.ISI === 1) {
                        const amount = data.ER * data.QT * data.AMT;
                        return amount >= 0 ? total + amount : total;
                    }
                    return total;
                }, 0).toFixed(2);
            },
            totalNegativeAmount() {
                if (!this.obj_SavedMaintainInfo || this.obj_SavedMaintainInfo.length === 0) {
                    return (0).toFixed(2);
                }
                return this.obj_SavedMaintainInfo.reduce((total, data) => {
                    if (data.ISI === 1) {
                        const amount = data.ER * data.QT * data.AMT;
                        return amount < 0 ? total + Math.abs(amount) : total;
                    }
                    return total;
                }, 0).toFixed(2);
            },
            hasStartDate() {
                return this.obj_SMAMaintainInfo.SD != null;
            },
            totalSumAmount() {
                const totalPositive = parseFloat(this.totalPositiveAmount);
                const totalNegative = parseFloat(this.totalNegativeAmount);
                return totalPositive - totalNegative;
            },
            groupedDataByACID() {
                return this.obj_SavedMaintainInfo.reduce((groups, item) => {
                    const key = item.ACID;
                    if (!groups[key]) {
                        groups[key] = { items: [], ACID: item.ACID };
                    }
                    groups[key].items.push(item);
                    return groups;
                }, {});
            },
            isHouseChecked: {
                get() {
                    return this.obj_SMAMaintainInfo.H === 1;
                },
                set(value) {
                    this.obj_SMAMaintainInfo.H = value ? 1 : 0;
                }
            },
            totalsByACID() {
                let totals = {};
                Object.keys(this.groupedDataByACID).forEach((ACID) => {
                    const group = this.groupedDataByACID[ACID].items;

                    let totalPositiveAmount = 0;
                    let totalNegativeAmount = 0;

                    group.forEach(item => {
                        if (item.ISI === 1) {
                            const amount = item.ER * item.QT * item.AMT;
                            if (amount >= 0) {
                                totalPositiveAmount += amount;
                            } else {
                                totalNegativeAmount += Math.abs(amount);
                            }
                        }
                    });

                    totals[ACID] = {
                        totalPositiveAmount,
                        totalNegativeAmount
                    };
                });
                return totals;
            },
            subtotalsByACID() {
                let subtotals = {};
                Object.keys(this.groupedDataByACID).forEach((ACID) => {
                    const group = this.groupedDataByACID[ACID].items;
                    const subtotal = group.reduce((sum, item) => {
                        if (item.ISI === 1) {
                            return sum + (item.ER * item.QT * item.AMT);
                        }
                        return sum;
                    }, 0);

                    subtotals[ACID] = subtotal;
                });
                return subtotals;
            },
            uncheckedICTBTotalByACID() {
                return this.obj_SavedMaintainInfo.reduce((totals, item) => {
                    const key = item.ACID;

                    if (!totals[key]) {
                        totals[key] = 0;
                    }

                    if (item.ICTB === 0) {
                        totals[key] += (item.ER * item.QT * item.AMT);
                    }

                    return totals;
                }, {});
            },
            maxPAByACID() {
                return Object.keys(this.subtotalsByACID).reduce((maxPA, ACID) => {
                    const subtotalFull = this.subtotalsByACID[ACID] || 0;
                    const subtotalCollectable = this.uncheckedICTBTotalByACID[ACID] || 0;
                    maxPA[ACID] = subtotalFull - subtotalCollectable;

                    return maxPA;
                }, {});
            },
            sortedMaintainAccounting() {
                return this.obj_MaintainAccounting
                    .filter(acc => this.uncheckedICTBTotalByACID.hasOwnProperty(acc.CI.toString()))
                    .sort((a, b) => {
                        const orderA = Object.keys(this.uncheckedICTBTotalByACID).indexOf(a.CI.toString());
                        const orderB = Object.keys(this.uncheckedICTBTotalByACID).indexOf(b.CI.toString());
                        return orderA - orderB;
                    });
            },
            sortedMaintainAccountingPreview() {

                const groupedByACID = this.obj_SavedMaintainInfo.reduce((groups, item) => {
                    const key = item.ACID;
                    if (!groups[key]) {
                        groups[key] = [];
                    }
                    groups[key].push(item);
                    return groups;
                }, {});

                const validACIDs = Object.entries(groupedByACID)
                    .filter(([acid, items]) =>
                        items.some(item => item.ISI !== 0 && item.ICTB !== 0)
                    )
                    .map(([acid]) => acid);

                const filteredICTBTotalByACID = Object.fromEntries(
                    Object.entries(this.uncheckedICTBTotalByACID).filter(([acid]) =>
                        validACIDs.includes(acid)
                    )
                );
                const sortedRecords = this.obj_MaintainAccounting
                    .filter(acc => validACIDs.includes(acc.CI.toString()))
                    .filter(acc => filteredICTBTotalByACID.hasOwnProperty(acc.CI.toString()))
                    .sort((a, b) => {
                        const orderA = Object.keys(filteredICTBTotalByACID).indexOf(a.CI.toString());
                        const orderB = Object.keys(filteredICTBTotalByACID).indexOf(b.CI.toString());
                        return orderA - orderB;
                    });

                return sortedRecords;
            },
            carryForwardByACID() {
                let carryForward = {};

                Object.keys(this.groupedDataByACID).forEach(ACID => {
                    const subtotalFull = this.subtotalsByACID[ACID] || 0;
                    const collectable = this.uncheckedICTBTotalByACID[ACID] || 0;
                    const account = this.obj_MaintainAccounting.find(account => account.CI.toString() === ACID);
                    const paidAmount = account ? account.PA : 0;
                    carryForward[ACID] = subtotalFull - collectable - paidAmount;
                });

                return carryForward;
            },
            carryForwardxpaidAmount() {
                let grandtotal = {};

                Object.keys(this.groupedDataByACID).forEach(ACID => {
                    const subtotalFull = this.subtotalsByACID[ACID] || 0;
                    const collectable = this.uncheckedICTBTotalByACID[ACID] || 0;
                    const account = this.obj_MaintainAccounting.find(account => account.CI.toString() === ACID);
                    grandtotal[ACID] = subtotalFull - collectable;
                });

                return grandtotal;
            },
            allSelected: {
                get() {
                    return this.obj_SavedMaintainInfo != null && this.obj_SavedMaintainInfo.every(item => item.ISI === 1);
                },
                set(value) {
                    this.obj_SavedMaintainInfo.forEach(item => {
                        item.ISI = value ? 1 : 0;
                        item.IsEdit = true;
                    });
                }
            }
            //formattedStartDate: {
            //    get() {
            //        return this.obj_SMAMaintainInfo.SD
            //            ? moment(this.obj_SMAMaintainInfo.SD).format('DD MMM YYYY HH:mm:ss')
            //            : moment('1900-01-01T00:00:00').format('DD MMM YYYY HH:mm:ss');
            //    },
            //    set(value) {
            //        if (value) {
            //            this.obj_SMAMaintainInfo.SD = moment(value, 'DD MMM YYYY HH:mm:ss').toISOString();
            //        } else {
            //            this.obj_SMAMaintainInfo.SD = '1900-01-01T00:00:00';
            //        }
            //    }
            //}
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_groupCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            $route() {

                if (this.$route.query.rst == 1) {
                    this.obj_AGI.AGI = null;
                    this.$router.replace({ path: '/AGS/AGD' })
                }
            },
            'obj_SMAMaintainInfo.SD': function (newVal) {
                this.calculateMaintenanceFeeDate();
            },
            'obj_SMAMaintainInfo.DT': function (newVal) {
                this.calculateMaintenanceFeeDate();
            },
            'obj_SMAMaintainInfo.OM': function (newVal) {
                this.calculateMaintenanceFeeDate();
            },
            'obj_SMAMaintainInfo.SDA': function (newVal) {
                this.calculateCreditLimit();
            },
            'obj_SMAMaintainInfo.SDM': function (newVal) {
                this.calculateCreditLimit();
            },
            'obj_SavedMaintainInfo'() {
                if (this.isDragDropMainList && this.obj_SavedMaintainInfo != null && this.obj_SavedMaintainInfo.length > 0) {
                    this.obj_SavedMaintainInfo.forEach((data, index) => {
                        if (data.SN != index + 1) {
                            data.SN = index + 1;
                            data.IsEdit = true;
                        }
                    });
                } else {
                    this.isDragDropMainList = true;
                }
            },
        },
        methods: {
            ...mapActions('SMBData', [
                'setCurrencySymbol',
                'setSystemBalance',
                'setCreditBalance'
            ]),
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            openSSA(action, type) {
                if (action == 'add') {
                    this.$router.push("/AGS/ASS?pgit=" + this.obj_profile[0].AT + "-" + this.obj_profile[0].AGI + "&agt=" + type);
                } else if (action == 'edit') {
                    this.$router.push("/AGS/ASS?agi=" + this.obj_agentInfo.AT + "-" + this.obj_agentInfo.AGI + "&di=" + (this.obj_agentInfo.DI ? this.obj_agentInfo.DI : 0) + "&acsi=" + this.obj_agentInfo.AGI + "&lci=" + this.obj_agentInfo.LCI + "&bai=" + this.obj_agentInfo.BAI + "&cri=" + this.obj_agentInfo.CRI + "&cdi=" + this.obj_agentInfo.CDI + (type ? "&section=" + type : ""));
                }
            },
            updateStartDate() {
                // Check if the switch is turned on
                if (this.obj_SMAMaintainInfo.SD) {
                    // Store the current date if the switch is turned on
                    this.obj_SMAMaintainInfo.SD = new Date().toISOString();
                    this.obj_SMAMaintainInfo.GLS = 1;
                }
            },
            calculateCreditLimit() {
                const creditLimit = parseFloat(this.obj_SMAMaintainInfo.CLA);
                const multiplier = parseFloat(this.obj_SMAMaintainInfo.SDM);
                const ExchangeRate = parseFloat(this.obj_SMAMaintainInfo.ER);
                const securityDeposit = parseFloat(this.obj_SMAMaintainInfo.SDA)
                if (securityDeposit > 0 && multiplier > 0 && ExchangeRate > 0) {
                    this.obj_SMAMaintainInfo.CLA = (securityDeposit * multiplier * ExchangeRate).toFixed(2);
                } else {
                    this.obj_SMAMaintainInfo.CLA = 0;
                }
            },
            getAgentDefaultExchangeRate(agentgroupid = 0) {
                
                var that = this;
                that.dd_currencyDF = [];
                this.getDataApi('/api/dd/curwr/0',
                    function (d, s) {
                        if (s) {
                            if (d.dropdownlist != null && d.dropdownlist.length > 0) {
                                for (var i = 0; i < d.dropdownlist.length; i++) {
                                    if (d.dropdownlist[i].ICT != true)
                                        that.dd_currencyDF.push(d.dropdownlist[i]);
                                }
                                that.CurrencyChange(that.obj_MaintainInfo.CI);
                            }
                        }
                    });
            },
            toggleVisibility(ACID) {
                this.$set(this.visibleSections, ACID, !this.visibleSections[ACID]);
            },
            generatePDF() {
                const element = this.$refs.capture;

                if (!element) {
                    console.error("Element not found");
                    return;
                }

                html2canvas(element, {
                    scale: 2,
                    useCORS: true,
                    allowTaint: false,
                }).then((canvas) => {
                    try {
                        
                        const image = { type: 'jpeg', quality: 0.98 };
                        const margin = [25, 25];
                       
                        var imgWidth = 595.28; 
                        var pageHeight = 841.89; 
                       
                        var innerPageWidth = imgWidth - margin[0] * 2;
                        var innerPageHeight = pageHeight - margin[1] * 2;

                        // Calculate the number of pages.
                        var pxFullHeight = canvas.height;
                        var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
                        var nPages = Math.ceil(pxFullHeight / pxPageHeight);

                        // Define pageHeight separately so it can be trimmed on the final page.
                        var pageHeight = innerPageHeight;

                        // Create a one-page canvas to split up the full image.
                        var pageCanvas = document.createElement('canvas');
                        var pageCtx = pageCanvas.getContext('2d');
                        pageCanvas.width = canvas.width;
                        pageCanvas.height = pxPageHeight;


                        const pdf = new JsPDF('p', 'pt', 'a4');
                        for (var page = 0; page < nPages; page++) {
                            // Trim the final page to reduce file size.
                            if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
                                pageCanvas.height = pxFullHeight % pxPageHeight;
                                pageHeight = (pageCanvas.height * innerPageWidth) / pageCanvas.width;
                            }

                            var w = pageCanvas.width;
                            var h = pageCanvas.height;
                            pageCtx.fillStyle = 'white';
                            pageCtx.fillRect(0, 0, w, h);
                            pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

                            // Add the page to the PDF.
                            if (page > 0)
                            {
                                pdf.addPage();
                            }
                            var imgData = pageCanvas.toDataURL('image/' + image.type, image.quality);
                            pdf.addImage(imgData, image.type, margin[1], margin[0], innerPageWidth, pageHeight);
                        }
                        pdf.save('Invoice.pdf'); 
                    } catch (error) {
                        console.error('Error generating PDF:', error);
                    }
                }).catch((error) => {
                    console.error('Error capturing the HTML element with html2canvas:', error);
                });
            },
            handleCheckboxChange(index) {
                if (this.obj_SavedMaintainInfo != null && this.obj_SavedMaintainInfo.length > index) {
                    let item = this.obj_SavedMaintainInfo[index];

                    item.IsEdit = true;

                    if (item.ISI == 0) {
                        item.ICTB = 1;
                    }
                }
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            // check if not superadmin / not cross brand will auto populate brand value
                            if (that.getUserInfo.AT != 0 || that.getUserInfo.IHAGIF) {
                                that.obj_AGI.AGI = that.dd_agentgroup[0].id;
                                //that.selectEditAgentOptions()
                            }
                        }
                    });

                this.getDataApi(`/api/dd/lang/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_language = d.dropdownlist;
                            that.dd_language_wall = that.appendSelectAllOption(d.dropdownlist);
                        }
                    });

                this.getDataApi('/api/dd/cur/0',
                    function (d, s) {
                        if (s) {
                            if (d.dropdownlist != null && d.dropdownlist.length > 0) {
                                for (var i = 0; i < d.dropdownlist.length; i++) {
                                    if (d.dropdownlist[i].ICT != true)
                                        that.dd_currency.push(d.dropdownlist[i]);
                                }
                            }
                            that.dd_currency_wall = that.appendSelectAllOption(that.dd_currency);
                        }
                    });


                this.getDataApi('/api/dd/game/prov/0/1/3',
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP'])
                                            d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                    }
                                }
                            }

                            //that.dd_gameprovider = that.appendSelectAllOption(d.dropdownlist);
                            that.dd_gameprovider = d.dropdownlist;
                        }
                        else {
                            that.dd_gameprovider = null;
                        }
                    });

                this.getDataApi('/api/dd/gameCat/',
                    function (d, s) {
                        if (s) {
                            that.dd_gameprovider_cat = d.dropdownlist;
                        }
                    });

                this.getDataApi('/api/dd/cur-pg/1',
                    function (d, s) {
                        if (s) {
                            that.dd_currency_h2p = that.appendSelectAllOption(d.dropdownlist);
                        }
                    });

                const agentId = that.getUserInfo.AID;
                this.getDataApi(`/api/dd/agent-Maintenance-access?agentId=${agentId}`,
                    function (d, s) {
                        if (s) {
                            that.bool_HasAgentMainteneneceAccess = s ? d : false;
                        }
                    });

                this.dd_durationSelection = [{
                    id: 1,
                    label: this.getLanguage["ACT"]["SBN"]
                }, {
                    id: 2,
                    label: '3 ' + this.getLanguage["DB"]["MT"]
                }, {
                    id: 3,
                    label: '6 ' + this.getLanguage["DB"]["MT"]
                }, {
                    id: 10,
                    label: this.getLanguage["DB"]["OMT"]
                }
                ];
            },
            selectEditAgentOptions(value, instanceId) {
                var that = this;
                if (this.obj_AGI.AGI && !this.bool_showInvoiceInfo && !this.bool_showMaintainInfo && !this.bool_showFTSInfo && !this.bool_showCurrencyTable) {
                    if (this.obj_PrevAGI.length >= 5) {
                        this.obj_PrevAGI.shift()
                    }
                    if (this.obj_agentInfo.AGI) {
                        if (!this.obj_PrevAGI.map(user => user.label).includes(this.obj_agentInfo.GN)) {
                            this.obj_PrevAGI.push({ "id": this.obj_agentInfo.AT + "-" + this.obj_agentInfo.AGI, "label": this.obj_agentInfo.GN })
                        }
                    }

                    var agentList = this.obj_AGI.AGI.split("-");
                    switch (agentList[0]) {
                        //Super Admin
                        case "0":
                            that.bool_showSMMAInfo = true;
                            that.bool_showSMInfo = false;
                            that.bool_showMAInfo = false;
                            that.bool_showFTSInfo = false;
                            that.bool_showMaintainInfo = false;
                            that.bool_showInvoiceInfo = false;
                            that.bool_showCurrencyTable = false;
                            that.getReportList();
                            break;
                        case "1":
                            that.bool_showSMMAInfo = true;
                            that.bool_showSMInfo = true;
                            that.bool_showMAInfo = false;
                            that.bool_showAgentInfo = false;
                            that.bool_showMaintainInfo = false;
                            that.bool_showInvoiceInfo = false;
                            that.bool_showFTSInfo = false;
                            that.bool_showCurrencyTable = false;
                            that.getReportList();
                            break;
                        case "2":
                            that.bool_showSMMAInfo = true;
                            that.bool_showSMInfo = false;
                            that.bool_showMAInfo = true;
                            that.bool_showAgentInfo = false;
                            that.bool_showMaintainInfo = false;
                            that.bool_showInvoiceInfo = false;
                            that.bool_showFTSInfo = false;
                            that.bool_showCurrencyTable = false;
                            that.getReportList();
                            break;
                        case "3":
                            that.bool_showSMMAInfo = false;
                            that.bool_showSMInfo = false;
                            that.bool_showMAInfo = false;
                            that.bool_showAgentInfo = true;
                            that.bool_showMaintainInfo = false;
                            that.bool_showInvoiceInfo = false;
                            that.bool_showFTSInfo = false;
                            that.bool_showCurrencyTable = false;
                            //that.getReportList();
                            break;
                        case "4":
                            that.bool_showSMMAInfo = false;
                            that.bool_showSMInfo = false;
                            that.bool_showMAInfo = false;
                            that.bool_showAgentInfo = true;
                            that.bool_showMaintainInfo = false;
                            that.bool_showInvoiceInfo = false;
                            that.bool_showFTSInfo = false;
                            that.bool_showCurrencyTable = false;
                            that.getSubReportList();
                            break;
                        default:
                            that.bool_showSMMAInfo = false;
                            that.bool_showSMInfo = false;
                            that.bool_showMAInfo = false;
                            that.bool_showAgentInfo = false;
                            that.bool_showMaintainInfo = false;
                            that.bool_showInvoiceInfo = false;
                            that.bool_showFTSInfo = false;
                            that.bool_showCurrencyTable = false;
                            that.getReportList();
                            break;
                    }
                    that.getAgentOverview();
                    that.selectedAgentType = value;
                    sessionStorage.setItem('SSA_FilterAGI', this.obj_AGI.AGI);
                } else if (this.obj_AGI.AGI && !this.bool_showInvoiceInfo && !this.bool_showMaintainInfo && this.bool_showFTSInfo && !this.bool_showCurrencyTable) {
                    if (this.obj_AGI.AGI == '0-18')
                    {
                        this.bool_showFTSInfo = false;
                            this.$fire({
                                title: this.getLanguage["ACT"]["BS"],
                                html: this.getLanguage["ACT"]["IALO"],
                                confirmButtonText: 'OK',
                                customClass: {
                                    title: 'afb-alert-title',
                                    content: 'afb-alert-content',
                                    actions: 'afb-alert-action'
                                }
                            });
                            return;
                    }
                    that.viewFirstTimeSetup();
                } else if (this.obj_AGI.AGI && !this.bool_showInvoiceInfo && this.bool_showMaintainInfo && !this.bool_showFTSInfo && !this.bool_showCurrencyTable) {
                    if (this.obj_AGI.AGI == '0-18') {
                        this.bool_showMaintainInfo = false;
                        this.$fire({
                            title: this.getLanguage["ACT"]["BS"],
                            html: this.getLanguage["ACT"]["IALO"],
                            confirmButtonText: 'OK',
                            customClass: {
                                title: 'afb-alert-title',
                                content: 'afb-alert-content',
                                actions: 'afb-alert-action'
                            }
                        });
                        return;
                    }
                    that.viewMaintenanceFee();
                } else if (this.obj_AGI.AGI && this.bool_showInvoiceInfo && !this.bool_showMaintainInfo && !this.bool_showFTSInfo && !this.bool_showCurrencyTable) {
                    that.viewInvoiceHistory();
                } else if (this.obj_AGI.AGI && !this.bool_showInvoiceInfo && !this.bool_showMaintainInfo && !this.bool_showFTSInfo && this.bool_showCurrencyTable) {
                    that.viewCurrencyTable();
                } else {
                    this.selectedAgentType = -1;
                    this.bool_showAgentInfo = false;
                    this.bool_showSMMAInfo = false;
                    this.bool_showMaintainInfo = false;
                    this.bool_showInvoiceInfo = false;
                    this.bool_showFTSInfo = false;
                    this.obj_agentInfo = [];
                    this.objDomainAlternate = [];
                    this.obj_PrevAGI = [];
                }
            },
            viewInvoiceHistory() {
                if (this.obj_AGI.AGI == null) {
                    this.$fire({
                        title: this.getLanguage["ACT"]["BS"],
                        html: this.getLanguage["MEM"]["PSAA"],
                        confirmButtonText: 'OK',
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    });
                    return;
                }
                this.bool_showFTSInfo = false;
                this.bool_showInvoiceInfo = true;
                this.bool_showMaintainInfo = false;
                this.getMaintenanceInfoByAgent();
                this.bool_showAgentInfo = false;
                this.bool_showSMMAInfo = false;
                this.bool_showCurrencyTable = false;
            },
            viewCurrencyTable() {
                this.bool_showFTSInfo = false;
                this.bool_showInvoiceInfo = false;
                this.bool_showMaintainInfo = false;
                this.getMaintenanceInfoByAgent();
                this.bool_showAgentInfo = false;
                this.bool_showSMMAInfo = false;
                this.bool_showCurrencyTable = true;
            },

            getFirstTimeSetup() {
                this.bool_fullLoading = true;
                let agi = 0;
                const that = this;

                if (this.obj_AGI && this.obj_AGI.AGI) {
                    const agentList = this.obj_AGI.AGI.split("-");
                    agi = agentList[agentList.length - 1];
                }
                this.bool_isAddFirstTimeInfo = true;
                this.getDataApi(`/api/agss/gfti?f[AGI]=${agi}&f[ICRA]=0`, function (d, s) {
                    that.bool_fullLoading = false;
                    that.obj_SMAMaintainInfo = [];
                    if (s) {
                        if (d.D.Items && d.D.Items.length > 0) {
                            that.bool_isAddFirstTimeInfo = false;
                            that.obj_SMAMaintainInfo = d.D.Items[0];


                        } else {
                            that.obj_SMAMaintainInfo = that.getDefaultMaintainInfo();
                        }
                    } else {
                        that.obj_SMAMaintainInfo = that.getDefaultMaintainInfo();
                    }
                });
            },
            SaveFirstTimeSetup() {
                this.bool_fullLoading = true;
                var that = this;
                this.postDataApi(`/api/agss/smaintinfofee`, this.obj_SMAMaintainInfo,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            that.getFirstTimeSetup();
                        }
                    });
            },
            getDefaultMaintainInfo() {
                var that = this;

                if (this.obj_AGI.AGI != null) {

                    var exchangerate = 1;
                    var datetype = 1;
                    this.dd_currencyDF.find(function (val, idx) {
                        if (val.id == that.obj_agentInfo.DCI) {
                            that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                            exchangerate = val.ER;
                        }
                    });
                    if (this.obj_agentInfo.AT == 1 || this.obj_agentInfo.AT == 2) {
                        datetype = 1;
                    } else if (this.obj_agentInfo.AT == 3) {
                        datetype = 3;
                    }

                    return {
                        I: 0,
                        RS: 2,
                        AGI: that.obj_AGI.AGI.split("-")[1],
                        SD: "1900-01-01T00:00:00",
                        MT: 25000,
                        OTSA: 0,
                        SDM: 0,
                        AMF: 0,
                        SMMF: 0,
                        DT: datetype,
                        COTSD: "1900-01-01T00:00:00",
                        OM: 0,
                        CLA: that.obj_agentInfo.TB,
                        CLACI: that.obj_agentInfo.DCI,
                        TCSD: 0,
                        TCOTSA: 0,
                        ACTS: that.obj_agentInfo.CTS,
                        ER: exchangerate,
                        GLS: 0,
                        AT: that.obj_agentInfo.AT,
                        ISC: 0
                    };
                }
            },
            viewFirstTimeSetup() {
                if (this.obj_AGI.AGI == null) {
                    this.$fire({
                        title: this.getLanguage["ACT"]["BS"],
                        html: this.getLanguage["MEM"]["PSAA"],
                        confirmButtonText: 'OK',
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    });
                    return;

                }

                if (this.obj_AGI.AGI == '0-18') {
                    this.$fire({
                        title: this.getLanguage["ACT"]["BS"],
                        html: this.getLanguage["ACT"]["IALO"],
                        confirmButtonText: 'OK',
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    });
                    return;
                }


                this.bool_showInvoiceInfo = false;
                this.bool_showMaintainInfo = false;
                this.bool_showFTSInfo = true;
                this.bool_showAgentInfo = false;
                this.bool_showSMMAInfo = false;

                this.getAgentOverview(false, true);

            },

            isLastMonth(date) {
                if (!date) return false;
                var comparisonDate = moment(date, 'YYYY-MM');
                const lastMonth = moment().subtract(1, 'months');
                return comparisonDate.isSame(lastMonth, 'month');
            },
            getAgentDetail() {
                this.bool_fullLoading = true;
                this.obj_profile = [];
                var agt = this.getUserInfo.AT;
                var agi = this.getUserInfo.AGI;
                var that = this;

                this.getDataApi(`/api/agss/l?f[AT]=${agt}&f[AGI]=${agi}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.obj_profile = d.D.Items;
                        }
                    });
            },
            getAgentOverview(isloadmain = false, isloadfirsttime = false) {
                this.bool_fullLoading = true;
                this.bool_showTopUp = false;
                this.bool_showTopUp2 = false;

                this.obj_agentInfo = [];
                var agi = 0;
                var that = this;
                /*var ci = 0;*/

                if (this.obj_AGI.AGI != null) {
                    var agentList = this.obj_AGI.AGI.split("-");
                    var agi = agentList[agentList.length - 1];
                }

                this.getDataApi(`/api/agss/ao?f[AGI]=${agi}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.obj_agentInfo = d.D.Items[0];

                            if (isloadmain) {
                                that.getMaintenanceInfo();
                            } else if (isloadfirsttime) {
                                that.getFirstTimeSetup();
                            }

                            ////if allcheck remove domain maintain

                            //if (that.obj_agentInfo.DSET != 1 || that.obj_agentInfo.DSS != 1 || that.obj_agentInfo.DS != 1 || that.obj_agentInfo.TMP != 1 || that.obj_agentInfo.ACS != 1 || that.obj_agentInfo.LC != 1 || that.obj_agentInfo.MDB != 1) {
                            //    if (that.obj_agentInfo.RS == 2) {
                            //        var obj = {
                            //            i: that.obj_agentInfo.DI,
                            //            rs: 1
                            //        };
                            //        that.postDataApi(`/api/agss/dirs`, obj,
                            //            function (d, s) {
                            //                that.bool_fullLoading = false;
                            //                if (s) {
                            //                    that.getAgentOverview();
                            //                }
                            //            });
                            //    }
                            //}

                            that.objDomainAlternate = that.obj_agentInfo.DomainAlternate;
                            that.obj_agentInfo.Language = that.obj_agentInfo.L != "" ? that.obj_agentInfo.L.split(",") : [];
                            that.obj_agentInfo.CurrencyIds = that.obj_agentInfo.CI != "" ? that.obj_agentInfo.CI.split(",") : [];
                            that.obj_agentInfo.GameProviderIds = that.obj_agentInfo.GPI != "" ? that.obj_agentInfo.GPI.split(",") : [];
                            that.obj_agentInfo.GameCategoryIds = that.obj_agentInfo.GCI != null ? that.obj_agentInfo.GCI.split(",") : [];

                            //find out active lang domain
                            that.obj_agentInfo.DomainSettingsLang = _.map(that.obj_agentInfo.DomainSettings, 'L');
                            //that.dd_reportcurrency = []
                            //$(that.dd_currency).each(function (index, cur) {
                            //    if (that.obj_agentInfo.CurrencyIds.includes(cur.id)) that.dd_reportcurrency.push(this)
                            //});

                            var regtemp = {
                                name: that.getLanguage['AG']['SFU'],
                                data: [(((that.obj_agentInfo.TB - that.obj_agentInfo.CB) / that.obj_agentInfo.TB) * 100)]
                            }
                            Vue.set(that.series, 1, regtemp)

                            var regtemp1 = {
                                name: that.getLanguage['AG']['SFA'],
                                data: [((that.obj_agentInfo.CB / that.obj_agentInfo.TB) * 100)]
                            }
                            Vue.set(that.series, 0, regtemp1)

                            var regtemp2 = {
                                name: (that.getLanguage['AG']['SFU'] + '<span style = "color: #ff0000"> 90% - 100%</span>'),
                                data: [0.00 + "%"]
                            }
                            Vue.set(that.series, 2, regtemp2)

                            var regtemp = {
                                name: that.getLanguage['AG']['SFU'],
                                data: [(((that.obj_agentInfo.PTPTB - that.obj_agentInfo.CPTPB) / that.obj_agentInfo.PTPTB) * 100)]
                            }
                            Vue.set(that.series2, 1, regtemp)

                            var regtemp1 = {
                                name: that.getLanguage['AG']['SFA'],
                                data: [((that.obj_agentInfo.CPTPB / that.obj_agentInfo.PTPTB) * 100)]
                            }
                            Vue.set(that.series2, 0, regtemp1)

                            var regtemp2 = {
                                name: (that.getLanguage['AG']['SFU'] + '<span style = "color: #ff0000"> 90% - 100%</span>'),
                                data: [0.00 + "%"]
                            }
                            Vue.set(that.series2, 2, regtemp2)

                            that.dd_paymentgateway_total =
                            {
                                Help2pay: { num: 0, currency: [] }, OOPay: { num: 0, currency: [] },
                                EZPay: { num: 0, currency: [] }, TruePay: { num: 0, currency: [] },
                                XFuoo: { num: 0, currency: [] }, StarPay: { num: 0, currency: [] },
                                SurePay: { num: 0, currency: [] }, CPay: { num: 0, currency: [] },
                                FuPay: { num: 0, currency: [] }, TrueMoney: { num: 0, currency: [] },
                                U2Pay: { num: 0, currency: [] }, LuckyPay: { num: 0, currency: [] },
                                BCPay: { num: 0, currency: [] }, SmartPay: { num: 0, currency: [] },
                                FPG: { num: 0, currency: [] }, PGA: { num: 0, currency: [] },
                                PP: { num: 0, currency: [] }, DN: { num: 0, currency: [] }, AGP: { num: 0, currency: [] },
                                P918: { num: 0, currency: [] }, UP: { num: 0, currency: [] }, OKP: { num: 0, currency: [] },
                                MGP: { num: 0, currency: [] }, VIP: { num: 0, currency: [] }, AFP: { num: 0, currency: [] },
                                ONEP: { num: 0, currency: [] }, BLEUP: { num: 0, currency: [] }, E88P: { num: 0, currency: [] },
                                ECP: { num: 0, currency: [] }, ZPAY: { num: 0, currency: [] },
                                UPAY: { num: 0, currency: [] },
                                DGPCNY: { num: 0, currency: [] }, SUPER7VND: { num: 0, currency: [] },
                                PAYPRO: { num: 0, currency: [] }, PAYLITE: { num: 0, currency: [] }, HUIJUCAI: { num: 0, currency: [] },
                                BestPay: { num: 0, currency: [] }, CLOUDPAY: { num: 0, currency: [] }, LNWPAY: { num: 0, currency: [] }/*, PAYNGO: { num: 0, currency: [] }, PPYP: { num: 0, currency: [] }*/
                            };
                            if (that.obj_agentInfo.H2PU && that.obj_agentInfo.H2PCC && that.obj_agentInfo.H2PMC && that.obj_agentInfo.H2PSC) {
                                that.dd_paymentgateway_total.Help2pay.num += 1;
                            }

                            if (that.obj_agentInfo.EZPUSDMN && that.obj_agentInfo.EZPUSDAS) {
                                that.dd_paymentgateway_total.EZPay.num += 1;
                                that.dd_paymentgateway_total.EZPay.currency.push('USD');
                            }
                            if (that.obj_agentInfo.EZPIDRMN && that.obj_agentInfo.EZPIDRAS) {
                                that.dd_paymentgateway_total.EZPay.num += 1;
                                that.dd_paymentgateway_total.EZPay.currency.push('IDR');
                            }
                            if (that.obj_agentInfo.EZPMYRMN && that.obj_agentInfo.EZPMYRAS) {
                                that.dd_paymentgateway_total.EZPay.num += 1;
                                that.dd_paymentgateway_total.EZPay.currency.push('MYR');
                            }

                            if (that.obj_agentInfo.EZPTHBMN && that.obj_agentInfo.EZPTHBAS) {
                                that.dd_paymentgateway_total.EZPay.num += 1;
                                that.dd_paymentgateway_total.EZPay.currency.push('THB');
                            }
                            if (that.obj_agentInfo.EZPVNDMN && that.obj_agentInfo.EZPVNDAS) {
                                that.dd_paymentgateway_total.EZPay.num += 1;
                                that.dd_paymentgateway_total.EZPay.currency.push('VND');
                            }
                            if (that.obj_agentInfo.OOPTHMN && that.obj_agentInfo.OOPTHAS && that.obj_agentInfo.OOPTHSK) {
                                that.dd_paymentgateway_total.OOPay.num += 1;
                                that.dd_paymentgateway_total.OOPay.currency.push('TH');
                            }
                            if (that.obj_agentInfo.OOPVIMN && that.obj_agentInfo.OOPVIAS && that.obj_agentInfo.OOPVISK) {
                                that.dd_paymentgateway_total.OOPay.num += 1;
                                that.dd_paymentgateway_total.OOPay.currency.push('VI');
                            }
                            if (that.obj_agentInfo.OOPIDMN && that.obj_agentInfo.OOPIDAS && that.obj_agentInfo.OOPIDSK) {
                                that.dd_paymentgateway_total.OOPay.num += 1;
                                that.dd_paymentgateway_total.OOPay.currency.push('ID');
                            }
                            if (that.obj_agentInfo.TUPVNDMN && that.obj_agentInfo.TUPVNDAS) {
                                that.dd_paymentgateway_total.TruePay.num += 1;
                                that.dd_paymentgateway_total.TruePay.currency.push('VND');

                            }
                            if (that.obj_agentInfo.TUPMYRMN && that.obj_agentInfo.TUPMYRAS) {
                                that.dd_paymentgateway_total.TruePay.num += 1;
                                that.dd_paymentgateway_total.TruePay.currency.push('MYR');

                            }
                            if (that.obj_agentInfo.XFTHN && that.obj_agentInfo.XFTHK) {
                                that.dd_paymentgateway_total.XFuoo.num += 1;
                                that.dd_paymentgateway_total.XFuoo.currency.push('TH');
                            }
                            if (that.obj_agentInfo.XFVIN && that.obj_agentInfo.XFVIK) {
                                that.dd_paymentgateway_total.XFuoo.num += 1;
                                that.dd_paymentgateway_total.XFuoo.currency.push('VI');
                            }
                            if (that.obj_agentInfo.XFMYRN && that.obj_agentInfo.XFMYRK) {
                                that.dd_paymentgateway_total.XFuoo.num += 1;
                                that.dd_paymentgateway_total.XFuoo.currency.push('MYR');
                            }
                            if (that.obj_agentInfo.XFUSDTN && that.obj_agentInfo.XFUSDTK) {
                                that.dd_paymentgateway_total.XFuoo.num += 1;
                                that.dd_paymentgateway_total.XFuoo.currency.push('USDT');
                            }
                            if (that.obj_agentInfo.XFIDRN && that.obj_agentInfo.XFIDRK) {
                                that.dd_paymentgateway_total.XFuoo.num += 1;
                                that.dd_paymentgateway_total.XFuoo.currency.push('IDR');
                            }
                            if (that.obj_agentInfo.SPMN && that.obj_agentInfo.SPAK) {
                                that.dd_paymentgateway_total.StarPay.num += 1;
                            }
                            if (that.obj_agentInfo.SUMYRCN && that.obj_agentInfo.SUMYRMN && that.obj_agentInfo.SUMYRAK) {
                                that.dd_paymentgateway_total.SurePay.num += 1;
                                that.dd_paymentgateway_total.SurePay.currency.push('MYR');
                            }
                            if (that.obj_agentInfo.SUTHBCN && that.obj_agentInfo.SUTHBMN && that.obj_agentInfo.SUTHBAK) {
                                that.dd_paymentgateway_total.SurePay.num += 1;
                                that.dd_paymentgateway_total.SurePay.currency.push('THB');
                            }
                            if (that.obj_agentInfo.SUSGDCN && that.obj_agentInfo.SUSGDMN && that.obj_agentInfo.SUSGDAK) {
                                that.dd_paymentgateway_total.SurePay.num += 1;
                                that.dd_paymentgateway_total.SurePay.currency.push('USGD');
                            }
                            if (that.obj_agentInfo.SUIDRCN && that.obj_agentInfo.SUIDRMN && that.obj_agentInfo.SUIDRAK) {
                                that.dd_paymentgateway_total.SurePay.num += 1;
                                that.dd_paymentgateway_total.SurePay.currency.push('IDR');
                            }
                            if (that.obj_agentInfo.CPSV1 && that.obj_agentInfo.CPSV2 && that.obj_agentInfo.CPAPIU) {
                                that.dd_paymentgateway_total.CPay.num += 1;
                            }
                            if (that.obj_agentInfo.FUPSV1 && that.obj_agentInfo.FUPSV2 && that.obj_agentInfo.FUPAPIU) {
                                that.dd_paymentgateway_total.FuPay.num += 1;
                            }
                            if (that.obj_agentInfo.TMSV1 && that.obj_agentInfo.TMSV2 && that.obj_agentInfo.TMAPIU) {
                                that.dd_paymentgateway_total.TrueMoney.num += 1;
                            }
                            if (that.obj_agentInfo.LPSV1 && that.obj_agentInfo.LPSV2 && that.obj_agentInfo.LPAPIU) {
                                that.dd_paymentgateway_total.LuckyPay.num += 1;
                            }
                            if (that.obj_agentInfo.BCPSV1 && that.obj_agentInfo.BCPSV2 && that.obj_agentInfo.BCPAPIU) {
                                that.dd_paymentgateway_total.BCPay.num += 1;
                            }
                            if (that.obj_agentInfo.U2PIDRSV1 && that.obj_agentInfo.U2PIDRSV2 && that.obj_agentInfo.U2PIDRAPIU) {
                                that.dd_paymentgateway_total.U2Pay.num += 1;
                            }
                            if (that.obj_agentInfo.SPSV1 && that.obj_agentInfo.SPSV2 && that.obj_agentInfo.SPAPIU) {
                                that.dd_paymentgateway_total.SmartPay.num += 1;
                            }
                            if (that.obj_agentInfo.SPIDRSV1 && that.obj_agentInfo.SPIDRSV2 && that.obj_agentInfo.SPIDRAPIU) {
                                that.dd_paymentgateway_total.SmartPay.num += 1;
                                that.dd_paymentgateway_total.SmartPay.currency.push('IDR');
                            }
                            if (that.obj_agentInfo.FPGSV1 && that.obj_agentInfo.FPGSV2) {
                                that.dd_paymentgateway_total.FPG.num += 1;
                            }
                            if (that.obj_agentInfo.PGASV1 && that.obj_agentInfo.PGASV2) {
                                that.dd_paymentgateway_total.PGA.num += 1;
                            }
                            if (that.obj_agentInfo.PPSV1 && that.obj_agentInfo.PPSV2) {
                                that.dd_paymentgateway_total.PP.num += 1;
                            }
                            if (that.obj_agentInfo.DNSV1 && that.obj_agentInfo.DNSV2) {
                                that.dd_paymentgateway_total.DN.num += 1;
                            }
                            if (that.obj_agentInfo.AGPSV1 && that.obj_agentInfo.AGPSV2) {
                                that.dd_paymentgateway_total.AGP.num += 1;
                            }
                            if (that.obj_agentInfo.P918SV1 && that.obj_agentInfo.P918SV2 && that.obj_agentInfo.P918SV3 && that.obj_agentInfo.P918SV4) {
                                that.dd_paymentgateway_total.P918.num += 1;
                                that.dd_paymentgateway_total.P918.currency.push('VND');
                            }
                            if (that.obj_agentInfo.UPSV1 && that.obj_agentInfo.UPSV2) {
                                that.dd_paymentgateway_total.UP.num += 1;
                            }
                            if (that.obj_agentInfo.OPTHBSV1 && that.obj_agentInfo.OPTHBSV2) {
                                that.dd_paymentgateway_total.OKP.num += 1;
                                that.dd_paymentgateway_total.OKP.currency.push('THB');
                            }
                            if (that.obj_agentInfo.OPVNDSV1 && that.obj_agentInfo.OPVNDSV2) {
                                that.dd_paymentgateway_total.OKP.num += 1;
                                that.dd_paymentgateway_total.OKP.currency.push('VND');
                            }
                            if (that.obj_agentInfo.OPIDRSV1 && that.obj_agentInfo.OPIDRSV2) {
                                that.dd_paymentgateway_total.OKP.num += 1;
                                that.dd_paymentgateway_total.OKP.currency.push('IDR');
                            }
                            if (that.obj_agentInfo.MPMYRSV1 && that.obj_agentInfo.MPMYRSV2) {
                                that.dd_paymentgateway_total.MGP.num += 1;
                                that.dd_paymentgateway_total.MGP.currency.push('MYR');
                            }
                            if (that.obj_agentInfo.VIPSV1 && that.obj_agentInfo.VIPSV2 && that.obj_agentInfo.VIPSV3) {
                                that.dd_paymentgateway_total.VIP.num += 1;
                            }
                            if ((that.obj_agentInfo.AFPSV1 && that.obj_agentInfo.AFPSV2) || (that.obj_agentInfo.AFPSV3 && that.obj_agentInfo.AFPSV4)) {
                                that.dd_paymentgateway_total.AFP.num += 1;
                            }
                            if (that.obj_agentInfo.ONEPSV1 && that.obj_agentInfo.ONEPSV2) {
                                that.dd_paymentgateway_total.ONEP.num += 1;
                            }
                            if (that.obj_agentInfo.BLEUPSV1 && that.obj_agentInfo.BLEUPSV2) {
                                that.dd_paymentgateway_total.BLEUP.num += 1;
                            }
                            if (that.obj_agentInfo.E88PSV1 && that.obj_agentInfo.E88PSV2) {
                                that.dd_paymentgateway_total.E88P.num += 1;
                            }
                            //if (that.obj_agentInfo.PPYPSV1 && that.obj_agentInfo.PPYPSV2) {
                            //    that.dd_paymentgateway_total.PPYP.num += 1;
                            //}
                            if (that.obj_agentInfo.ECPSV1 && that.obj_agentInfo.ECPSV2 && that.obj_agentInfo.ECPSV3) {
                                that.dd_paymentgateway_total.ECP.num += 1;
                            }
                            if ((that.obj_agentInfo.ZPAYTHBSV1 && that.obj_agentInfo.ZPAYTHBSV2) || (that.obj_agentInfo.ZPAYINRSV1 && that.obj_agentInfo.ZPAYINRSV2) || (that.obj_agentInfo.ZPAYBRLSV1 && that.obj_agentInfo.ZPAYBRLSV2) || (that.obj_agentInfo.ZPAYVNDSV1 && that.obj_agentInfo.ZPAYVNDSV2) || (that.obj_agentInfo.ZPAYMYRSV1 && that.obj_agentInfo.ZPAYMYRSV2)) {
                                that.dd_paymentgateway_total.ZPAY.num += 1;
                            }
                            if (that.obj_agentInfo.UPAYSV1) {
                                that.dd_paymentgateway_total.UPAY.num += 1;
                            }
                            if ((that.obj_agentInfo.LNWPAYUSDSV1) || (that.obj_agentInfo.LNWPAYHKDSV1)) {
                                that.dd_paymentgateway_total.LNWPAY.num += 1;
                            }
                            if ((that.obj_agentInfo.PAYPROUSDSV1 && that.obj_agentInfo.PAYPROUSDSV2 && that.obj_agentInfo.PAYPROUSDSV3 && that.obj_agentInfo.PAYPROUSDSV4) ||
                                (that.obj_agentInfo.PAYPROMYRSV1 && that.obj_agentInfo.PAYPROMYRSV2 && that.obj_agentInfo.PAYPROMYRSV3 && that.obj_agentInfo.PAYPROMYRSV4) ||
                                (that.obj_agentInfo.PAYPROTHBSV1 && that.obj_agentInfo.PAYPROTHBSV2 && that.obj_agentInfo.PAYPROTHBSV3 && that.obj_agentInfo.PAYPROTHBSV4) ||
                                (that.obj_agentInfo.PAYPROIDRSV1 && that.obj_agentInfo.PAYPROIDRSV2 && that.obj_agentInfo.PAYPROIDRSV3 && that.obj_agentInfo.PAYPROIDRSV4) ||
                                (that.obj_agentInfo.PAYPROVNDSV1 && that.obj_agentInfo.PAYPROVNDSV2 && that.obj_agentInfo.PAYPROVNDSV3 && that.obj_agentInfo.PAYPROVNDSV4) ||
                                (that.obj_agentInfo.PAYPROHKDSV1 && that.obj_agentInfo.PAYPROHKDSV2 && that.obj_agentInfo.PAYPROHKDSV3 && that.obj_agentInfo.PAYPROHKDSV4) ||
                                (that.obj_agentInfo.PAYPROBDTSV1 && that.obj_agentInfo.PAYPROBDTSV2 && that.obj_agentInfo.PAYPROBDTSV3 && that.obj_agentInfo.PAYPROBDTSV4) ||
                                (that.obj_agentInfo.PAYPROBRLSV1 && that.obj_agentInfo.PAYPROBRLSV2 && that.obj_agentInfo.PAYPROBRLSV3 && that.obj_agentInfo.PAYPROBRLSV4) ||
                                (that.obj_agentInfo.PAYPROPHPSV1 && that.obj_agentInfo.PAYPROPHPSV2 && that.obj_agentInfo.PAYPROPHPSV3 && that.obj_agentInfo.PAYPROPHPSV4)) {
                                that.dd_paymentgateway_total.PAYPRO.num += 1;
                            }
                            if (that.obj_agentInfo.DGPCNYSV1 && that.obj_agentInfo.DGPCNYSV2) {
                                that.dd_paymentgateway_total.DGPCNY.num += 1;
                            }
                            if ((that.obj_agentInfo.S7PVNDSV1 && that.obj_agentInfo.S7PVNDSV2) || (that.obj_agentInfo.S7PVNDSV3 && that.obj_agentInfo.S7PVNDSV4) || (that.obj_agentInfo.S7PVNDSV5 && that.obj_agentInfo.S7PVNDSV6) || (that.obj_agentInfo.S7PVNDSV7 && that.obj_agentInfo.S7PVNDSV8) || (that.obj_agentInfo.S7PVNDSV9 && that.obj_agentInfo.S7PVNDSV10)) {
                                that.dd_paymentgateway_total.SUPER7VND.num += 1;
                            }
                            if (that.obj_agentInfo.PLSV1 && that.obj_agentInfo.PLSV2) {
                                that.dd_paymentgateway_total.PAYLITE.num += 1;
                            }
                            if (that.obj_agentInfo.HUIJUCAISV1 && that.obj_agentInfo.HUIJUCAISV2) {
                                that.dd_paymentgateway_total.HUIJUCAI.num += 1;
                            }
                            if (that.obj_agentInfo.BestPaySV1 && that.obj_agentInfo.BestPaySV2) {
                                that.dd_paymentgateway_total.BestPay.num += 1;
                            }
                            if (that.obj_agentInfo.CLPSV1 && that.obj_agentInfo.CLPSV2 && that.obj_agentInfo.CLPSV3 && that.obj_agentInfo.CLPSV4 && that.obj_agentInfo.CLPSV5) {
                                that.dd_paymentgateway_total.CLOUDPAY.num += 1;
                            }
                            //if (that.obj_agentInfo.PNGSV1 && that.obj_agentInfo.PNGSV2 && that.obj_agentInfo.PNGSV3 && that.obj_agentInfo.PNGSV4) {
                            //    that.dd_paymentgateway_total.PAYNGO.num += 1;
                            //}
                            //if (that.obj_agentInfo.U2PIDRGMN && that.obj_agentInfo.U2PIDRGAS && that.obj_agentInfo.U2PIDRGK && that.obj_agentInfo.U2PIDRDMN && that.obj_agentInfo.U2PIDRDAS && that.obj_agentInfo.U2PIDRDK && that.obj_agentInfo.U2PIDROMN && that.obj_agentInfo.U2PIDROAS && that.obj_agentInfo.U2PIDROK) {
                            //    that.dd_paymentgateway_total.U2Pay.num += 1;
                            //    that.dd_paymentgateway_total.U2Pay.currency.push('IDR');
                            //}
                            //if (that.obj_agentInfo.LPTHBCC && that.obj_agentInfo.LPTHBPK) {
                            //    that.dd_paymentgateway_total.LuckyPay.num += 1;
                            //}
                            //if (that.obj_agentInfo.BCPDA && that.obj_agentInfo.BCPDK && that.obj_agentInfo.BCPWA && that.obj_agentInfo.BCPWK) {
                            //    that.dd_paymentgateway_total.BCPay.num += 1;
                            //}

                            that.selectSupportedCurrency();
                        }
                    });

                var path = this.getListingParamQuery(1, 999, "CTS", true);
                path += "&f.ATAGI=3-" + agi;
                this.getDataApi(`/api/dm/l?${path}`,
                    function (d, s) {
                        //that.bool_fullLoading = false;

                        if (s) {
                            that.arr_Domain = d.D.Items;
                        }
                    });

                if (this.bool_showAgentInfo) {
                    this.getDataApi(`/api/ag/gpt`,
                        function (d, s) {
                            //that.bool_fullLoading = false;
                            if (s) {
                                that.dd_GPDefaultPT = d.D.Items;
                            }
                        });
                }
            },
            selectSupportedCurrency() {
                var that = this;
                this.getDataApi('/api/dd/game/provbycur/0/1/' + this.obj_agentInfo.AGI + '/' + this.obj_agentInfo.CurrencyIds.join(','),
                    function (d, s) {
                        if (s) {
                            that.dd_gameprovider = [];
                            that.dd_gameprovider_cat = [];
                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP'])
                                            d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                    }

                                    that.dd_gameprovider_cat.push({
                                        id: d.dropdownlist[j].id.split("-")[1],
                                        label: d.dropdownlist[j].label,
                                    });
                                }
                            }

                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    d.dropdownlist[j].children = _.sortBy(d.dropdownlist[j].children, ['label']);
                                }
                            }

                            that.dd_gameprovider = d.dropdownlist;
                            that.dd_gameprovider_cat.sort((a, b) => (parseInt(a.id) > parseInt(b.id)) ? 1 : -1)
                            that.selectedGPCat = '0-' + that.dd_gameprovider_cat[0].id;
                        }
                    });
            },
            handleFileUpload(event) {
                const file = event.target.files[0];
            },
            getMaintenanceInfo() {
                this.bool_isMTNEdit = false;
                this.bool_fullLoading = true;
                this.YearMonthForCSharp = this.YearMonth.format("YYYY-MM-DDTHH:mm:ss");
                var nextmonth = moment(this.YearMonth).add(1, 'months').format("YYYY-MM-DDTHH:mm:ss");
                this.obj_SavedMaintainInfo = [];
                var agi = 0;
                var that = this;

                if (this.obj_AGI.AGI != null) {
                    var agentList = this.obj_AGI.AGI.split("-");
                    var agi = agentList[agentList.length - 1];
                }
                this.bool_canEdit = true;
                this.getDataApi(`/api/agss/gmi?f[AGI]=${agi}&f[ICTGR]=1&f[MY]=${that.YearMonthForCSharp}
                &f[CI]=${that.obj_agentInfo.DCI}&f[AGI_csv]=${agi}&f[STS_from]=${that.YearMonthForCSharp}&f[STS_to]=${nextmonth}
                &f[DPT]=${that.obj_agentInfo.DPT}&f[ISOC]=${that.obj_agentInfo.ISOC}&f[CS]=${that.obj_agentInfo.CS}&f[BN]=${that.obj_agentInfo.GN}
                &f[AT]=${that.obj_agentInfo.AT}&f[PC]=${that.obj_agentInfo.PC}&f[IPL]=${that.obj_agentInfo.IPL}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.obj_SavedMaintainInfo = [];
                            that.obj_MaintainAccounting = [];
                            that.obj_MaintainAccountingMain = [];
                            that.obj_SavedMaintainInfo = d.AGSelfServiceMaintenanceInfos;

                            that.obj_MaintainAccounting = d.AGSelfServiceAccountingReports;
                            that.obj_MaintainAccountingMain = d.AGSelfServiceAccountingReportMains;
                           

                            that.bool_canEdit = true;

                            if (that.obj_MaintainAccountingMain != null && that.obj_MaintainAccountingMain.RS == 4) {
                                that.bool_canEdit = false;
                            }


                        }
                    });
            },
            getMaintenanceInfoByAgent() {
                this.bool_fullLoading = true;
                this.YearMonthForCSharpByA = this.YearMonthByA.format("YYYY-MM-DDTHH:mm:ss");
                var agi = 0;
                var that = this;

                if (this.obj_AGI.AGI != null) {
                    var agentList = this.obj_AGI.AGI.split("-");
                    var agi = agentList[agentList.length - 1];
                }

                this.getDataApi(`/api/agss/gmiba?f[AGI]=${agi}&f[ICTGR]=2&f[MY]=${that.YearMonthForCSharpByA}
                 &f[CI]=${that.obj_agentInfo.DCI}&f[AGI_csv]=${agi}&f[STS_to]=${that.YearMonthForCSharpByA}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.obj_SavedMaintainInfoByA = [];
                            that.obj_MaintainAccountingByA = [];
                            that.obj_MaintainAccountingMainByA = [];
                            that.obj_SavedMaintainInfoByA = d.AGSelfServiceMaintenanceInfos;


                            that.obj_MaintainAccountingByA = d.AGSelfServiceAccountingReports;
                            that.obj_MaintainAccountingMainByA = d.AGSelfServiceAccountingReportMains;
                        }
                    });

            },
            ChangeToMonth() {
                this.str_yearmonth = moment(this.YearMonth).format('MMM YYYY');
                var x = this.YearMonth._d;
                if (x.getTime() > new Date().getTime()) {
                    this.$fire({
                        title: this.getLanguage["FR"]["DOR"],
                        width: '30em',
                        showCancelButton: false,
                        confirmButtonText: "OK",
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    });
                    this.YearMonth = moment(new Date(new Date().getFullYear(), new Date().getMonth()));
                    this.bool_fullLoading = false;
                } else {
                    this.getMaintenanceInfo();
                }

            },

            ChangeToMonthByAgent() {
                this.str_yearmonthByA = moment(this.YearMonthByA).format('MMM YYYY');
                var x = this.YearMonthByA._d;
                if (x.getTime() > new Date().getTime()) {
                    this.$fire({
                        title: this.getLanguage["FR"]["DOR"],
                        width: '30em',
                        showCancelButton: false,
                        confirmButtonText: "OK",
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    });
                    this.YearMonthByA = moment(new Date(new Date().getFullYear(), new Date().getMonth()));
                    this.bool_fullLoading = false;
                } else {
                    this.getMaintenanceInfoByAgent();
                }


            },
            handlePAChange(event, account) {
                account.PA = this.ThousandSeparatorWithNegative(event, 2);
                this.bool_isEditTaxrate = true;
                this.bool_isMTNEdit = true;

            },
            formatDate(date) {
                return moment(date).format('DD MMM YYYY HH:mm:ss');
            },

            CurrencyChange(value) {

                if (value != undefined) {
                    var that = this;
                    this.dd_currencyDF.find(function (val, idx) {
                        if (val.id == value) {
                            that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);

                            /*that.obj_MaintainInfo.ER = val.ER;*/
                        }
                    });
                }
            },
            isCurrentOrLastMonth(yearMonth) {
                const currentDate = new Date();
                const currentMonth = currentDate.getMonth() + 1;
                const currentYear = currentDate.getFullYear();

                const lastMonthDate = new Date(currentDate);
                lastMonthDate.setMonth(currentMonth - 2);
                const lastMonth = lastMonthDate.getMonth() + 1;
                const lastMonthYear = lastMonthDate.getFullYear();

                const [year, month] = yearMonth.split('-').map(Number);

                return (year === currentYear && month === currentMonth) ||
                    (year === lastMonthYear && month === lastMonth);
            },
            CurrencyChangeIndex(value, data) {

                var convertrate = 0;
                var convertto = 0;
                var currencyratio = 0;
                var convertCarryForward = 0;
                if (value !== undefined) {
                    var that = this;
                    this.dd_currencyDF.find(function (val) {
                        if (val.id === value) {
                            data.ISOC = val.label;
                            convertrate = val.ER;
                            convertCarryForward = val.CR;
                        }
                    });

                    // Find and set the default currency conversion rate
                    this.dd_currencyDF.find(function (val) {
                        //console.log('that.obj_agentInfo.DCI', that.obj_agentInfo.DCI);
                        if (val.id === data.ACID.toString()) {
                            //console.log('that.defaultCurrencyConvertRate', that.defaultCurrencyConvertRate);
                            convertto = val.ER;
                            currencyratio = val.CR;
                        }
                    });

                    if (data.IT != 4) {
                        data.ER = convertto / convertrate * currencyratio;
                    } else {
                        data.ER = convertto / convertrate * currencyratio / convertCarryForward;
                    }
                    //console.log('data.ER', data.ER);
                }
            },
            UnderCurrencyChangeIndex(value, data) {

                var convertrate = 0;
                var convertto = 0;
                var currencyratio = 0;
                var convertCarryForward = 0;

                if (value !== undefined) {
                    var that = this;
                    this.dd_currencyDF.find(function (val) {
                        if (val.id === value) {
                            data.ACID = val.id;
                            convertto = val.ER;
                            currencyratio = val.CR;
                            var matchingAccount = that.obj_MaintainAccounting.find(
                                (account) => account.CI === data.ACID
                            );
                            if (matchingAccount) {
                                data.ARI = matchingAccount.I;
                            } else {
                                data.ARI = 0;
                            }
                        }
                        if (val.id === data.CI.toString()) {
                            convertrate = val.ER;
                            convertCarryForward = val.CR;
                        }
                        if (data.IT == 4) {
                            data.ER = convertto / convertrate * currencyratio / convertCarryForward;
                        } else if (data.IT ==9) {
                            data.ER = convertto / convertrate;
                        } else  {
                            data.ER = convertto / convertrate * currencyratio;
                        } 
                        

                    });
                }
            },
            getReportList() {
                this.bool_fullLoading = true;
                var that = this;

                if (this.getUserInfo.AT === 4) {
                    this.parentGroupId = '0-0'
                }

                var agi = 0;

                if (this.obj_AGI.AGI != null) {
                    var agentList = this.obj_AGI.AGI.split("-");
                    var agi = agentList[agentList.length - 1];
                }

                this.getDataApi(`/api/dd/agp-h/${agi}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (d && d.D) {
                                that.treeData = d.D;

                                if (that.getUserInfo.AT < 2) {
                                    that.openAll = false;
                                    that.openNode = d.D[0].id;
                                } else {
                                    that.openAll = true;
                                    that.openNode = null;
                                }
                            }
                            else {
                                that.treeData = [];
                            }
                        }
                        else {
                            that.treeData = [];
                        }
                    });
            },
            getSubReportList() {
                this.bool_fullLoading = true;
                var that = this;

                if (this.getUserInfo.AT === 4) {
                    this.parentGroupId = '0-0'
                }

                //var agi = tempAgi[1];
                //var agi = 10;
                var agi = 0;

                if (this.obj_AGI.AGI != null) {
                    var agentList = this.obj_AGI.AGI.split("-");
                    var agi = agentList[agentList.length - 1];
                }

                this.getDataApi(`/api/dd/sag-h/${agi}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (d && d.D) {
                                that.treeData = d.D;

                                if (that.getUserInfo.AT < 2) {
                                    that.openAll = false;
                                    that.openNode = d.D[0].id;
                                } else {
                                    that.openAll = true;
                                    that.openNode = null;
                                }
                            }
                            else {
                                that.treeData = [];
                            }
                        }
                        else {
                            that.treeData = [];
                        }
                    });
            },
            updateIsPaymentOutstanding(agi, ipo) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CA"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var obj = {
                            i: agi,
                            ipo: ipo
                        };
                        var that = this;

                        this.postDataApi(`/api/agss/ipo`, obj,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getAgentOverview();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    } else {
                        this.getAgentOverview();
                    }
                });
            },
            updateIsPendingLaunch(agi, ipl) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CA"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var obj = {
                            i: agi,
                            ipl: ipl
                        };
                        var that = this;

                        this.postDataApi(`/api/agss/ipl`, obj,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getAgentOverview();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    } else {
                        this.getAgentOverview();
                    }
                });
            },
            updateItemData() {
                var that = this;
                this.obj_MaintainAccountingMain.INRD = 1;

                this.postDataApi(`/api/agss/upmaintinfo`, this.obj_MaintainAccountingMain,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.getMaintenanceInfo();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                        }
                    });
            },

            clearDateFilterIndex(data) {
                data.SD = '1900-01-01T00:00:00';
            },
            clearDateFilter() {
                this.obj_SMAMaintainInfo.SD = '1900-01-01T00:00:00';
            },
            confirmGenerateInvoice(RS) {
                if (RS == 3) {
                    var titletext = this.getLanguage["ACT"]["AUSWGI"];
                } else if (RS == 4) {
                    var titletext = this.getLanguage["ACT"]["AUSWSI"];
                } else if (RS == 2) {
                    var titletext = this.getLanguage["ACT"]["AUSWAI"];
                }
                this.$fire({
                    title: titletext,
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value === true) {
                        this.GenerateInvoiceBill(RS);
                    }
                });
            },
            updateMaintainAccounting() {
                const {
                    subtotalsByACID = {},
                    uncheckedICTBTotalByACID = {},
                    carryForwardByACID = {},
                    obj_MaintainAccounting
                } = this;

                obj_MaintainAccounting.forEach((account) => {
                    const ACID = account.CI.toString();

                    const subtotal = subtotalsByACID[ACID] || 0;
                    const uncheckedTotal = uncheckedICTBTotalByACID[ACID] || 0;
                    const carryForward = carryForwardByACID[ACID] || 0;

                    account.TA = subtotal - uncheckedTotal;
                    account.CLTBA = uncheckedTotal;
                    account.CFA = carryForward;
                });
            },
            GenerateInvoiceBill(value) {
                this.updateMaintainAccounting();
                var that = this;
                this.obj_MaintainAccountingMain.RS = value;

                if (value == 4) {
                    this.obj_MaintainAccountingMain.ID = moment().format('YYYY-MM-DDTHH:mm:ss');
                    this.obj_MaintainAccountingMain.SOD = moment().format('YYYY-MM-DDTHH:mm:ss');

                } else if (value == 3) {
                    this.obj_MaintainAccountingMain.ID = moment().format('YYYY-MM-DDTHH:mm:ss');
                }
                this.bool_fullLoading = true;

                this.postDataApi(
                    `/api/agss/signoffmaintinfo`,
                    {
                        AGSelfServiceAccountingReports: this.obj_MaintainAccounting,
                        AGSelfServiceAccountingReportMains: this.obj_MaintainAccountingMain,
                        AGSelfServiceMaintenanceInfos: this.obj_SavedMaintainInfo
                    },
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (d.ERR && d.ERR.length > 0) {
                                if (d.ERR[0].ERRC == 16001) {
                                    const errorMessage = d.ERR.map(err => err.CL).join('<br />');
                                    that.showErrorMessage(that.getLanguage["ACT"]["PMSOI"], that.utilGetErrorLanguage("ERR.16001") + '<br />' + errorMessage);
                                    that.getMaintenanceInfo();
                                } else if (d.ERR[0].ERRC == 1001) {
                                    that.showErrorMessage(that.getLanguage["ACT"]["IAR"], that.getLanguage["ACT"]["TSMSBSO"]);
                                    that.getMaintenanceInfo();
                                }  else if (d.ERR[0].ERRC == 16003) {
                                    that.showErrorMessage('Sign off Error', that.utilGetErrorLanguage("ERR.16003"));
                                    that.getMaintenanceInfo();
                                }
                            } else {
                                that.bool_canEdit = false;
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                that.getMaintenanceInfo();
                            }
                        }
                    }
                );

                this.bool_Preview = false;
            },
            closeAdd() {
                this.bool_isReceipt = false;
                this.bool_CV = false;
            },
            DateRangePickerUpdateEvent(dt, data) {
                if (dt && dt.startDate) {
                    dt.startDate.setHours(0, 0, 0, 0);

                    const formattedDate = moment(dt.startDate).format('YYYY-MM-DDTHH:mm:ss');

                    data.SD = formattedDate;


                }
            },
            updatePrivacySetting(agi, ip) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CA"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var obj = {
                            i: agi,
                            ip: ip
                        };
                        var that = this;

                        this.postDataApi(`/api/agss/ssa`, obj,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getAgentOverview();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    } else {
                        this.getAgentOverview();
                    }
                });
            },
            updateDomainStatusSetting(di, rs) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CA"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var obj = {
                            i: di,
                            rs: rs
                        };
                        var that = this;

                        this.postDataApi(`/api/agss/dirs`, obj,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getAgentOverview();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    } else {
                        this.getAgentOverview();
                    }
                });
            },
            UploadReceipt(data) {

                this.bool_isReceipt = true;
                this.bool_CV = false;
                this.obj_ad = Object.assign({}, data);
                this.obj_ad['RURL'] = null;
                this.obj_ad.PA = 0;
                this.obj_ad.CI = 8;
                this.obj_ad.RMK = '';
            },
            SaveReceipt() {
                this.bool_CV = true;
                this.$v.obj_ad.$touch();
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;

                if (!this.$v.obj_ad.$error) {
                    var that = this;
                    if (this.obj_MaintainAccountingMain && this.obj_MaintainAccountingMain.I) {
                        this.obj_ad.II = this.obj_MaintainAccountingMain.I;
                    }
                    if (this.obj_AGI && this.obj_AGI.AGI) {
                        this.obj_ad.AGI = this.obj_AGI.AGI;
                    }
                    this.obj_ad.PA = parseFloat(this.obj_pamt.AMT);  
                    this.obj_ad.CI = parseFloat(this.obj_pamt.CI);
                    this.obj_ad.RMK = String(this.obj_pamt.RMK);
                    this.postDataApiWithAttach(`/api/agss/uirf`, this.obj_ad,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isReceipt = false;
                                that.selectedFile = null;
                                that.obj_ad = null;
                                that.obj_pamt.AMT = 0;
                                that.getInvoiceReceipts();
                            }
                        });
                } else {
                    this.bool_fullLoading = false;
                    this.bool_fullScreen = false;
                    const validation = this.$v["obj_ad"];
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["MTA"]["RURL"]), 1000);
                    if (!validation || !this.$refs) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["MTA"]["RURL"]), 1000);
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["MTA"]["RURL"]), 1000);
                        return;
                    }

                    input.focus();
                }
            },
            calculateAndInsertTotals() {
                const totalsByCurrency = {};

                if (this.receipts && this.receipts.length > 0) {
                    this.receipts.forEach((receipt) => {
                        const currencyId = receipt.CI;
                        if (!totalsByCurrency[currencyId]) {
                            totalsByCurrency[currencyId] = 0;
                        }
                        totalsByCurrency[currencyId] += parseFloat(receipt.PA || 0); 
                    });
                }


                this.sortedMaintainAccounting.forEach((account) => {
                    const accountCurrencyId = account.CI; 
                    if (totalsByCurrency[accountCurrencyId]) {
                        account.PA = totalsByCurrency[accountCurrencyId];
                    } else {
                        account.PA = 0; 
                    }
                });
                this.bool_isEditTaxrate = true;
                this.bool_isMTNEdit = true;
                this.handlePAChange();
            },
            onFileSelected(event) {
                this.selectedFile = this.validateFile(event, 6, [".jpg", ".jpeg", ".png"]);
                this.obj_ad["RURL"] = this.selectedFile;
            },
            getInvoiceReceipts() {
                this.bool_fullLoading = true;
                this.receipts = [];
                this.bool_canEdit = true;
                var invoiceId = this.obj_MaintainAccountingMain.I;
                var that = this;


                this.getDataApi(`/api/agss/gir?invoiceId=${invoiceId}`, function (response, success) {
                    that.bool_fullLoading = false;

                    if (success) {
                        that.bool_canEdit = true;
                        that.receipts = response.D.Items;
                    }

                });
            },
            toggleInvoiceReceiptsVisibility() {
                this.bool_showInvoiceReceipts = !this.bool_showInvoiceReceipts;
                if (this.bool_showInvoiceReceipts || this.$route.query.showInvoiceReceipts === 'true') {
                    this.getInvoiceReceipts();
                }
            },
            toggleCurrencyTableVisibility() {
                this.bool_showCurrencyTable = !this.bool_CurrencyTable;
            },
            updateDefaultLang(lang) {
                this.bool_fullLoading = false;
                var title = this.getLanguage["DM"]["COMDL"] + " " + this.obj_agentInfo.DL + " > " + lang + "?";
                this.$fire({
                    title: title,
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["CONFIRM"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var obj = {
                            I: this.obj_agentInfo.DI,
                            DL: lang,
                            AGIT: this.obj_agentInfo.AT + '-' + this.obj_agentInfo.AGI,
                            AGI: this.obj_agentInfo.AGI,
                            DN: this.obj_agentInfo.DN,
                            L: this.obj_agentInfo.DomainSettingsLang.join(","),
                            DS: this.obj_agentInfo.DomainSettings,
                            CC: this.obj_agentInfo.CC,
                            UTS: this.obj_agentInfo.DUTS,
                        };
                        var that = this;

                        this.postDataApi(`/api/dm/sdl`, obj,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getAgentOverview();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    } else {
                        this.getAgentOverview();
                    }
                });
            },
            getProviderCatUrl(category) {
                if (category) {
                    category = category.replace(" ", "")
                    return "https://d2lcoivv20vty7.cloudfront.net/Content/img/icons/" + category + ".svg";
                }
                //return "https://d2lcoivv20vty7.cloudfront.net/Content/media/provider/provider_icon_light/" + gameprovider + ".webp";
            },
            openAgentInfo(item) {
                if (item.type == 'SA') {
                    this.obj_AGI.AGI = '1-' + item.id;
                } else if (item.type == 'MA') {
                    this.obj_AGI.AGI = '2-' + item.id;
                } else if (item.type == 'A') {
                    this.obj_AGI.AGI = '3-' + item.id;
                }
                this.selectEditAgentOptions()
            },

            selectGameProvider(value, instanceId) {

            },
            selected(node) {
                this.selectedNode = node;
            },
            viewMaintenanceFee() {
                if (this.obj_AGI.AGI == null) {
                    this.$fire({
                        title: this.getLanguage["ACT"]["BS"],
                        html: this.getLanguage["MEM"]["PSAA"],
                        confirmButtonText: 'OK',
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    });
                    return;
                }
                
                if (this.obj_AGI.AGI == '0-18') {
                    this.$fire({
                        title: this.getLanguage["ACT"]["BS"],
                        html: this.getLanguage["ACT"]["SACGI"],
                        confirmButtonText: 'OK',
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    });
                    return;
                }

                //if (this.obj_agentInfo.AT == 2) {
                //    this.$fire({
                //        title: this.getLanguage["ACT"]["BS"],
                //        html: 'MA level cannot generate the invoice',
                //        confirmButtonText: 'OK',
                //        customClass: {
                //            title: 'afb-alert-title',
                //            content: 'afb-alert-content',
                //            actions: 'afb-alert-action'
                //        }
                //    });
                //    return;
                //}


                this.bool_showMaintainInfo = true;
                this.getAgentOverview(true);

                this.bool_showAgentInfo = false;
                this.bool_showSMMAInfo = false;
                this.bool_showInvoiceInfo = false;
                this.bool_showFTSInfo = false;
                this.bool_showCurrencyTable = false;
            },
            showPreview() {
                this.bool_Preview = true;

            },
            addMaintenanceFeeData() {
                if (this.obj_AGI.AGI != null) {
                    //var agentList = this.obj_AGI.AGI.split("-");
                    //var agi = agentList[agentList.length - 1];

                    this.obj_MaintainInfo = {
                        I: 0,
                        RS: 2,
                        AGI: [],
                        AGIT: this.obj_AGI.AGI,
                        QT: 1,
                        CI: this.obj_agentInfo.DCI,
                        CS: null,
                        ISOC: null,
                        ER: 0,
                        ISI: 1,
                        ICTB: 1,
                        ICTGR: 1,
                        AMT: 1.0,
                        CTS: "1900-01-01T00:00:00",
                        CBI: 0,
                        CB: null,
                        UTS: "1900-01-01T00:00:00",
                        SD: "1900-01-01T00:00:00",
                        UBI: 0,
                        UB: null,
                        IDT: null,
                        R: null,
                        MY: this.YearMonthForCSharp,
                        IETB: 1,
                        IETBD: 1,
                        IT: 0,
                    };
                    this.getAgentDefaultExchangeRate(this.obj_AGI.AGI.split("-")[1]);
                }
                else {
                    this.obj_MaintainInfo = {
                        I: 0,
                        RS: 2,
                        AGI: [],
                        AGIT: null,
                        QT: 1,
                        CI: null,
                        CS: null,
                        ISOC: null,
                        AMT: 0.0,
                        CTS: "1900-01-01T00:00:00",
                        CBI: 0,
                        ER: 0,
                        CB: null,
                        ISI: 1,
                        ICTB: 1,
                        ICTGR: 1,
                        UTS: "1900-01-01T00:00:00",
                        SD: "1900-01-01T00:00:00",
                        UBI: 0,
                        UB: null,
                        IDT: null,
                        R: null,
                        MY: this.YearMonthForCSharp,
                        IETB: 1,
                        IETBD: 1,
                        IT: 0,
                    };
                    this.getAgentDefaultExchangeRate();
                }

                this.bool_addMaintainInfo = true;
            },
            addnewMaintainInfo() {
                var that = this;
                if (this.obj_AGI.AGI != null) {
                    this.obj_MaintainInfo = {
                        I: 0,
                        RS: 2,
                        AGI: this.obj_AGI.AGI.split("-")[1],
                        AGIT: this.obj_AGI.AGI,
                        QT: 1,
                        CI: this.obj_agentInfo.DCI,
                        CS: this.obj_agentInfo.ISOC,
                        ISOC: this.obj_agentInfo.ISOC,
                        ER: 1,
                        ISI: 1,
                        ICTB: 1,
                        ICTGR: 1,
                        AMT: 0.0,
                        CTS: "1900-01-01T00:00:00",
                        CBI: 0,
                        CB: null,
                        UTS: "1900-01-01T00:00:00",
                        SD: "1900-01-01T00:00:00",
                        UBI: 0,
                        UB: null,
                        IDT: null,
                        R: null,
                        MY: this.YearMonthForCSharp,
                        IETB: 1,
                        IETBD: 1,
                        IT: 0,
                        ACID: this.obj_agentInfo.DCI,
                        ARI: 0,
                        isEditing: true,
                        ISCC: 1,
                        SN: null,
                    };

                    this.obj_SavedMaintainInfo.unshift({ ...this.obj_MaintainInfo });

                    this.obj_SavedMaintainInfo.forEach((item, index) => {
                        item.SN = index + 1;
                        item.IsEdit = true;
                    });
                }

            },

            cancelSaveMaintenanceFeeData() {
                this.bool_addNewMaintainInfo = false;
                this.obj_MaintainInfo = [];
                this.bool_isMTNEdit = false;
                this.getMaintenanceInfo();
                this.selectedCurrencyForBilling = null;
            },
            CancelSaveFirstTime()
            {
                this.obj_SMAMaintainInfo = [];
                this.getFirstTimeSetup();
            },
            validateSavedMaintainInfo(value, langKey = "", index = -1) {
                if (this.bool_savedMaintainInfoCV) {
                    if (langKey == "") {
                        langKey = value;
                    }

                    if (this.$v.obj_SavedMaintainInfo.$each[index][value] != null && this.$v.obj_SavedMaintainInfo.$each[index][value].required != undefined && !this.$v.obj_SavedMaintainInfo.$each[index][value].required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACT"][langKey]);
                    } else if (this.$v.obj_SavedMaintainInfo.$each[index][value] != null && this.$v.obj_SavedMaintainInfo.$each[index][value].decimal != undefined && !this.$v.obj_SavedMaintainInfo.$each[index][value].decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["ACT"][langKey]);
                    } else if (this.$v.obj_SavedMaintainInfo.$each[index][value] != null && this.$v.obj_SavedMaintainInfo.$each[index][value].minValue != undefined && !this.$v.obj_SavedMaintainInfo.$each[index][value].minValue) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["ACT"][langKey]);
                    } else if (this.$v.obj_SavedMaintainInfo.$each[index][value] != null && this.$v.obj_SavedMaintainInfo.$each[index][value].DateValidation != undefined && !this.$v.obj_SavedMaintainInfo.$each[index][value].DateValidation) {
                        return String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACT"][langKey]);
                    }

                }
            },
            saveMaintenanceIsSelected() {
                var obj_saveMaintainInfoED = this.obj_SavedMaintainInfo
                    .filter(item => item.IsEdit === true || item.isEditing === true)
                    .map(item => toRaw(item));

                var that = this;
                var agi = 0;
                if (this.obj_AGI.AGI != null) {
                    var agentList = this.obj_AGI.AGI.split("-");
                    var agi = agentList[agentList.length - 1];
                }

                this.bool_savedMaintainInfoCV = true;
                this.$v.obj_SavedMaintainInfo.$touch();
                if (!this.$v.obj_SavedMaintainInfo.$error) {
                    this.bool_savedMaintainInfoCV = false;

                    this.updateMaintainAccounting();

                    if (obj_saveMaintainInfoED != null && obj_saveMaintainInfoED.length > 0) {
                        this.bool_fullLoading = true;
                        this.postDataApi(`/api/agss/smaintinfosld?f[AGI]=${agi}&f[CI]=${that.obj_agentInfo.DCI}&f[ICTGR]=1&f[MY]=${that.YearMonthForCSharp}`, obj_saveMaintainInfoED,
                            function (d, s) {
                                if (s) {
                                    that.saveMaintenanceTaxOthers();
                                    that.selectedCurrencyForBilling = null;
                                }
                            });
                    } else {
                        that.saveMaintenanceTaxOthers();
                    }
                }
            },
            saveMaintenanceTaxOthers() {
                var that = this;
                this.bool_fullLoading = true;
                this.postDataApi(`/api/agss/smaintinfoaccountlist`, this.obj_MaintainAccounting,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            that.getMaintenanceInfo();
                            that.bool_isMTNEdit = false;
                        }
                    });
            },
            addNewSupportType(type, catId) {
                if (this.obj_AGI.AGI != null) {
                    this.obj_AGI.RCI = this.obj_agentInfo.CurrencyIds;
                    this.obj_AGI.RGPI = this.obj_agentInfo.GameProviderIds;
                    this.obj_AGI.RLI = this.obj_agentInfo.Language;

                    if (type == 1) {
                        this.requestSupportType = 1;
                    } else if (type == 2) {
                        this.requestSupportType = 2;
                    } else if (type == 3) {
                        this.requestSupportType = 3;
                        this.selectedGPCat = "0-" + (catId ? catId : '2');
                    } else if (type == 4) {
                        this.requestSupportType = 4;
                    }
                    this.bool_showNewSupport = true;
                }
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.obj_SMAMaintainInfo.SD = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.obj_SMAMaintainInfo.SD = "";
                    }
                }
            },
            DateTimeChangeIndex(type, event, data) {
                if (type === "SD") {

                    const dateString = event;
                    const momentObj = moment(dateString, 'YYYY-MM-DDTHH:mm:ss', true);
                    if (momentObj.isValid()) {
                        data.SD = momentObj.toDate();
                    } else if (dateString.trim() !== "") {
                        this.showErrorMessage(
                            null,
                            String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]),
                            1000
                        );
                        data.SD = new Date('1900-01-01T00:00:00');
                    } else {
                        data.SD = new Date('1900-01-01T00:00:00');
                    }
                }
            },
            saveNewSupportCurrency() {
                this.bool_fullLoading = true;
                var that = this;

                var agi = this.obj_agentInfo.AGI;
                var gn = this.obj_agentInfo.GN;
                var cis = this.obj_AGI.RCI;
                var curArray = Array.isArray(this.obj_agentInfo.CurrencyIds) ? this.obj_agentInfo.CurrencyIds : this.obj_agentInfo.CurrencyIds.split(',');
                var newCurIds = cis.filter(ci => !curArray.includes(ci));
                var newCurLabels = [];

                // Get the labels for the new currency IDs
                newCurIds.forEach(curId => {
                    var currency = this.dd_currency_wall[0].children.find(cur => cur.id == curId);
                    if (currency) {
                        newCurLabels.push(currency.label);
                    }
                });

                if (newCurLabels.length <= 0) {
                    this.showSuccessMessage(that.utilGetErrorLanguage("ERR.11"));
                    this.bool_fullLoading = false;
                } else {
                    var obj = {
                        AGI: agi,
                        GN: gn,
                        C_csv: newCurLabels.join(',')
                    };
                    this.postDataApi(`/api/agss/sruac`, obj, function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.bool_showNewSupport = false;
                            that.getAgentOverview();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("ERR.NSC"));
                        }
                    });
                }
            },
            saveNewSupportLanguage() {
                var that = this;
                var agi = this.obj_agentInfo.AGI;
                var gn = this.obj_agentInfo.GN;
                var langs = this.obj_AGI.RLI;
                var langArray = Array.isArray(this.obj_agentInfo.L) ? this.obj_agentInfo.L : this.obj_agentInfo.L.split(',');
                var newLangs = langs.filter(lang => !langArray.includes(lang));

                if (newLangs.length <= 0) {
                    this.showSuccessMessage(that.utilGetErrorLanguage("ERR.11"));
                    this.bool_fullLoading = false;
                } else {
                    var obj = {
                        AGI: agi,
                        GN: gn,
                        L_csv: newLangs.join(', ')
                    };

                    this.postDataApi(`/api/agss/srual`, obj, function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.bool_showNewSupport = false;
                            that.getAgentOverview();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("ERR.NSL"));
                        }
                    });
                }
            },
            saveNewSupportGP() {
                this.bool_fullLoading = true;
                var that = this;

                var agi = this.obj_agentInfo.AGI;
                var gn = this.obj_agentInfo.GN;
                var gp = this.obj_AGI.RGPI;
                var gpArray = Array.isArray(this.obj_agentInfo.GameProviderIds) ? this.obj_agentInfo.GameProviderIds : this.obj_agentInfo.GameProviderIds.split(',');
                var newGPIds = gp.filter(gpid => !gpArray.includes(gpid));
                var newGPLabels = [];

                // Get the labels for the new gameprovider IDs
                this.dd_gameprovider.forEach(gp => {
                    if (gp.id == that.selectedGPCat) {
                        gp.children.forEach(child => {
                            if (newGPIds.includes(child.id) && !newGPLabels.includes(child.label)) {
                                newGPLabels.push(child.label);
                            }
                        });
                    }
                });

                if (newGPLabels.length <= 0) {
                    this.showSuccessMessage(that.utilGetErrorLanguage("ERR.11"));
                    this.bool_fullLoading = false;
                } else {
                    var obj = {
                        AGI: agi,
                        GN: gn,
                        GP_csv: newGPLabels.join(',')
                    };

                    this.postDataApi(`/api/agss/sruagp`, obj, function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.bool_showNewSupport = false;
                            that.getAgentOverview();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("ERR.NSGP"));
                        }
                    });
                }
            },
            getCurrencyLabel(ACID) {
                const currency = this.dd_currency.find(item => item.id === ACID);
                return currency ? currency.label : 'Unknown Currency';
            },

            isValidDate(date) {
                return !moment(date).isSame('1900-01-01T00:00:00', 'second');
            },
            saveNewSupportType() {
                //if (!this.$v.obj_MaintainInfo.$error && isValid) {
                //    this.bool_fullLoading = true;
                //    var that = this;

                //    this.postDataApi(`/api/agss/smaintinfo`, this.obj_MaintainInfo,
                //        function (d, s) {
                //            that.bool_fullLoading = false;
                //            if (s) {
                //                that.bool_isAMV = false;
                //                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                //                that.bool_addMaintainInfo = false;
                //                that.getMaintenanceInfo();
                //            }
                //        });
                //}
            },
            editData(id) {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/agss/g/${id}`,
                    function (d, s) {
                        if (s) {
                            that.setdata(d.D);
                            that.bool_addMaintainInfo = true;
                            if (that.obj_MaintainInfo.AGI != 0) {
                                that.obj_MaintainInfo.AGIT = "3-" + that.obj_MaintainInfo.AGI;
                                that.DomainAgentGroupChange(that.obj_MaintainInfo.AGIT);
                            }
                        }
                        that.bool_fullLoading = false;
                    });
            },
            editDataIndex(id) {
                this.getAgentDefaultExchangeRate(this.obj_AGI.AGI.split("-")[1]);
                this.obj_SavedMaintainInfo = this.obj_SavedMaintainInfo.map(item => {
                    if (item.I === id) {
                        item.isEditing = true;
                    }
                    return item;
                });
            },
            DateRangePickerUpdateEvent1(dt) {
                if (dt && dt.startDate) {
                    dt.startDate.setHours(0, 0, 0, 0);
                    const formattedDate = moment(dt.startDate).format('YYYY-MM-DDTHH:mm:ss');
                    this.obj_SMAMaintainInfo.SD = formattedDate;
                }
            },
            setdata(data) {
                this.obj_MaintainInfo = Object.assign(this.obj_MaintainInfo, data);
                this.bool_addMaintainInfo = true;

                if (this.obj_MaintainInfo.R != "") {
                    this.obj_MaintainInfo.R = this.obj_MaintainInfo.R;
                }
                else {
                    this.obj_MaintainInfo.R = "";
                }
            },
            removeData(d, index) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;

                        if (d.I == 0) {
                            this.obj_SavedMaintainInfo.splice(index, 1);

                            this.bool_fullLoading = false;
                        } else {
                            var dt = {
                                i: d.I
                            };
                            this.postDataApi(`/api/agss/md`, dt, function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getMaintenanceInfo();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                        }
                    }
                });
            },
            TextValueChange(type, event) {
                if (type == "R") {
                    this.obj_MaintainInfo.R = event.target.value;
                } else if (type == "AMT") {
                    this.obj_MaintainInfo.AMT = event.target.value;
                } else if (type == "IDT") {
                    this.obj_MaintainInfo.IDT = event.target.value;
                } else if (type == "QUANT") {
                    this.obj_MaintainInfo.QT = event.target.value;
                } else if (type == "RMK") {
                    this.obj_pamt.RMK = event.target.value;
                }
            },
            TextValueChangeIndex(type, event, data) {
                if (type === "R") {
                    data.R = event.target.value;
                } else if (type === "AMT") {
                    data.AMT = event.target.value;
                } else if (type === "IDT") {
                    data.IDT = event.target.value;
                } else if (type === "QUANT") {
                    data.QT = event.target.value;
                }
            },
            deleteReceipt(Id) {

                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value === true) {
                        this.bool_fullLoading = true;
                        var that = this;

                        const receiptData = { I: Id };

                        this.postDataApi(`/api/agss/dr`, receiptData, function (d, s) {

                            that.bool_fullLoading = false;
                            if (s) {

                                that.getInvoiceReceipts();
                                that.showSuccessMessage(
                                    that.utilGetErrorLanguage("ERR.SS"),
                                    that.utilGetErrorLanguage("GL.AS")
                                );
                            } else {

                            }
                        });
                    }
                });
            },

            formatEstimatePT(gameProviderId, AgentMaxPT) {
                var estimatePT = "";
                if (gameProviderId != 55 && this.dd_GPDefaultPT != null && this.dd_GPDefaultPT.length > 0) {
                    for (var d of this.dd_GPDefaultPT) {
                        if (d.GPI == gameProviderId) {
                            AgentMaxPT = parseFloat(AgentMaxPT);
                            estimatePT = 100 - d.DPT;
                            if (estimatePT > AgentMaxPT) {
                                estimatePT = AgentMaxPT;
                            } else {
                                estimatePT = estimatePT - 2;
                            }
                            estimatePT = " (" + estimatePT.toFixed(2) + " %) ";
                        }
                    }
                }
                else {
                    estimatePT = " (TBC) ";
                }
                return estimatePT;
            },
            clearCache() {
                this.bool_fullLoading = true;
                var that = this;
                var dt = {
                    i: this.obj_agentInfo.DI,
                    agi: this.obj_agentInfo.AGI
                };

                this.postDataApi(`/api/dm/cc`, dt,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                        }
                    });
            },

            // system balance
            AvailableBalanceAmount() {
                return this.obj_agentInfo.TB - this.obj_agentInfo.CB;
            },
            AvailablePToPBalanceAmount() {
                return this.obj_agentInfo.PTPTB - this.obj_agentInfo.CPTPB;
            },
            updateBalance() {
                this.obj_Balance.AGI = this.obj_agentInfo.AGI;

                if (this.obj_Balance.BU == null) {
                    this.obj_Balance.BU = 0;
                }

                //// check the require field
                this.bool_balanceCV = true;
                this.$v.obj_Balance.$touch();
                let isValid = true;

                if (this.obj_Balance.BT == 1) {
                    //if (this.obj_Balance.BU <= 0) {
                    //    this.str_invalidAmountMsg = String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"]["BTUA"]);
                    //    isValid = false;
                    //}
                    if (this.obj_Balance.BU < -this.dec_availablesystembalance) {
                        this.str_invalidAmountMsg = String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"]["TUDSB"]);
                        isValid = false;
                    }
                    else if (this.obj_Balance.BU > (this.obj_agentInfo.TB - this.obj_agentInfo.CB)) {
                        this.str_invalidAmountMsg = this.getLanguage["ERR"]["IVTA"];
                        isValid = false;
                    }
                }

                if (!this.$v.obj_Balance.$error && isValid) {
                    this.bool_fullLoading = true;
                    var that = this;

                    this.postDataApi(`/api/ag/ssbh`, this.obj_Balance,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.getAgentOverview();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                        });
                }
            },

            updatePToPBalance() {
                this.obj_Balance.AGI = this.obj_agentInfo.AGI;

                if (this.obj_Balance.PTPBU == null) {
                    this.obj_Balance.PTPBU = 0;
                }

                //// check the require field
                this.bool_balanceCV = true;
                this.$v.obj_Balance.$touch();
                let isValid = true;

                if (this.obj_Balance.BT == 1) {
                    if (this.obj_Balance.PTPBU < -this.dec_availableptopbalance || this.obj_Balance.PTPBU < -this.obj_agentInfo.CPTPB) {
                        this.str_invalidPToPAmountMsg = String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"]["TUDSB"]);
                        isValid = false;
                    }
                    else if (this.obj_Balance.PTPBU > (this.obj_agentInfo.PTPTB - this.obj_agentInfo.CPTPB)) {
                        this.str_invalidPToPAmountMsg = this.getLanguage["ERR"]["IVTA2"];
                        isValid = false;
                    }
                }

                if (!this.$v.obj_Balance.$error && isValid) {
                    this.bool_fullLoading = true;
                    var that = this;

                    this.postDataApi(`/api/ag/psbh`, this.obj_Balance,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.getAgentOverview();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                        });
                }
            },
            ValidationSystemBalanceErrMsg(value, langKey = "") {
                if (langKey == "") {
                    langKey = value;
                }

                var validateObj = this.$v.obj_Balance[value];

                if (validateObj.required != undefined && !validateObj.required) {
                    return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"][langKey]);
                }
                else if (validateObj.minValue != undefined && !validateObj.minValue) {
                    return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                }
                else if (validateObj.decimal != undefined && !validateObj.decimal) {
                    return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["AG"][langKey]);
                }

                if (this.str_invalidAmountMsg != "" && value == "BU") {
                    return this.str_invalidAmountMsg;
                }
            },
            ValidationPToPBalanceErrMsg(value, langKey = "") {
                if (langKey == "") {
                    langKey = value;
                }

                var validateObj = this.$v.obj_Balance[value];

                if (validateObj.required != undefined && !validateObj.required) {
                    return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"][langKey]);
                }
                else if (validateObj.minValue != undefined && !validateObj.minValue) {
                    return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                }
                else if (validateObj.decimal != undefined && !validateObj.decimal) {
                    return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["AG"][langKey]);
                }

                if (this.str_invalidPToPAmountMsg != "" && value == "PTPBU") {
                    return this.str_invalidPToPAmountMsg;
                }
            },
            DomainAgentGroupChange(value) {
                var that = this;
                var agi = 0;
                if (value != "") {
                    agi = value.split("-")[1];
                    this.getAgentDefaultExchangeRate(agi);
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_domainlist = d.dropdownlist;
                            }
                        });
                }
                else {
                    this.getAgentDefaultExchangeRate();
                    that.dd_domainlist = [];
                }
            },
            // for suspend acc + balance history
            suspendAgent(d) {
                this.bool_suspendCV = false;
                this.dd_suspendreason = constSuspendReasonBL;
                this.obj_suspend = {
                    RM: null,
                    _d: d
                };
                this.obj_Suspend = {
                    "reason": null,
                    "reason2": ""
                },
                    this.bool_isAgentSuspendV = true;
            },
            getDisplayIndex(currentIndex) {
                let count = 0;
                for (let i = 0; i <= currentIndex; i++) {
                    if (this.obj_SavedMaintainInfo[i].ISI === 1) {
                        count++;
                    }
                }
                return count;
            },

            getDisplayIndexByA(currentIndex) {
                let count = 0;
                for (let i = 0; i <= currentIndex; i++) {
                    if (this.obj_SavedMaintainInfoByA[i].ISI === 1) {
                        count++;
                    }
                }
                return count;
            },
            calculateMaintenanceFeeDate() {
                const startDate = this.obj_SMAMaintainInfo.SD;
                const durationType = this.obj_SMAMaintainInfo.DT;
                const manualMonths = this.obj_SMAMaintainInfo.OM;

                if (this.isValidDate(startDate)) {
                    let date = moment(startDate, moment.ISO_8601, true);

                    if (!date.isValid()) {

                        this.obj_SMAMaintainInfo.COTSD = '1900-01-01T00:00:00';
                        return;
                    }

                    if (durationType === 10 && manualMonths > 0) {
                        date.add(manualMonths, 'months');
                    } else if (durationType === 1) {
                        date = moment(startDate);
                    } else if (durationType === 2) {
                        date.add(3, 'months');
                    } else if (durationType === 3) {
                        date.add(6, 'months');
                    } else {
                        this.obj_SMAMaintainInfo.COTSD = '1900-01-01T00:00:00';
                        return;
                    }
                    this.obj_SMAMaintainInfo.COTSD = date.format('YYYY-MM-DDTHH:mm:ss');
                } else {

                    this.obj_SMAMaintainInfo.COTSD = '1900-01-01T00:00:00';
                }
            },
            saveSuspend() {
                this.bool_suspendCV = true;

                var suspendreason = this.obj_Suspend.reason == 999 ? this.obj_Suspend.reason2 : this.obj_Suspend.reason;

                if (suspendreason != "" && suspendreason != null) {
                    this.bool_fullLoading = true;
                    var that = this;
                    var dt = {
                        I: this.obj_suspend._d.AGI,
                        UTS: this.obj_suspend._d.UTS,
                        SSR: suspendreason,
                        AGI: this.obj_suspend._d.AGI,
                        ICI: 0
                    };
                    this.postDataApi(`/api/ag/spa`, dt,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                    that.$fire({
                                        title: that.getLanguage["MEM"]["CA"],
                                        html: that.getLanguage["MEM"]["CICI"],
                                        width: '30em',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ok',
                                        cancelButtonText: 'Cancel',
                                        reverseButtons: true,
                                        customClass: {
                                            title: 'afb-alert-title',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        }
                                    }).then((result) => {
                                        if (result.value == true) {
                                            that.bool_fullLoading = true;
                                            dt['ICI'] = 1;
                                            that.postDataApi(`/api/ag/spa`, dt,
                                                function (d, s) {
                                                    that.bool_fullLoading = false;
                                                    if (s) {
                                                        that.bool_isAgentSuspendV = false;
                                                        that.getAgentOverview();
                                                    }
                                                });
                                        }
                                    });
                                }
                                else {
                                    that.bool_isAgentSuspendV = false;
                                    that.getAgentOverview();
                                }
                            }
                        });
                }
            },
            getFormattedInvoiceDate() {
                if (this.obj_MaintainAccountingMain.RS >= 3) {
                    return this.$moment(this.obj_MaintainAccountingMain.ID).format('D MMM YYYY');
                } else {
                    return this.$moment().format('D MMM YYYY');
                }
            },


            unSuspendAgent(d) {
                this.$fire({
                    title: this.getLanguage["AG"]["CUSS"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.AGI,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/ag/uspa`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getAgentOverview();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            ValidationBlackListErrMsg(value) {
                if (this.bool_suspendCV) {
                    var validateObj = this.$v.obj_Suspend[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage["AG"]["SSR"]);
                    }
                }
            },
            balanceHistoryList(id, agentType,bv) {
                this.$router.push("/AGS/BalanceHistory?agi=" + agentType + "-" + id +"&bv=" + bv);
            },
            domainList(id, agentType) {
                this.$router.push("/AGS/CRD2?agi=" + agentType + "-" + id);
            },
            close3() {
                this.bool_isAgentSuspendV = !this.bool_isAgentSuspendV;
                this.bool_suspendCV = false;
            },
            getTooltipInfo(inactive, suspend) {
                return this.getLanguage["BTN"]["V"] + inactive + this.getLanguage["BTN"]["V"] + suspend;
            },
            getLiveChatfromDomain() {
                if (this.getUserInfo.AT >= 3) {
                    var that = this;
                    this.getDataApi(`/api/livechat/l?p=1&n=100&s=CTS&d=true&f[AGI]=${this.obj_agentInfo.AGI}&f[DI]=${this.obj_agentInfo.DI}&f[RS]=2`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s && d.D.Items.length == 0) {
                                that.obj_agentInfo.LC = 0;
                                that.obj_agentInfo.LCI = 0;
                            } else {
                                that.obj_agentInfo.LC = 1;
                                that.obj_agentInfo.LCI = d.D.Items[0].I;
                            }
                        });
                }
            },
            updateAllCurrencies(newCurrency) {
                this.obj_SavedMaintainInfo.forEach(data => {
                    data.ACID = newCurrency;
                    data.isEditing = true;
                    this.UnderCurrencyChangeIndex(newCurrency, data);
                });
            },
            disabledPointer() {
                return (!this.checkModuleAccess('ASS', 'AGS', constAccessType.edit)) ? "cursor:not-allowed; filter:none" : "";
            },
        },
        created() {
            this.$parent.showSubMenu = 'AGS';
            this.$parent.showActiveMenu = 'AGS.ASS';
            this.YearMonth = moment(new Date(new Date().getFullYear(), new Date().getMonth()-1));
            this.YearMonthByA = moment(new Date(new Date().getFullYear(), new Date().getMonth()-1));
            this.getAgentDetail();
            this.getAgentGroup();
            this.getAgentDefaultExchangeRate();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            const today = new Date();
            this.formattedTodayDate = this.$moment(today).format('D MMM YYYY');
            var FilterAGI = sessionStorage.getItem('SSA_FilterAGI');
            if (FilterAGI) {
                this.obj_AGI.AGI = FilterAGI;
                this.selectEditAgentOptions();
            }
        }
    }
</script>
<style>

    .image-container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 6px solid #106c34;
        padding-bottom: 10px;
    }

    .image-left {
        float: left;
        height: 100px;
        width: auto;
    }

    .image-right {
        float: right;
        height: 100px;
        width: auto;
    }


    .payment-section {
        width: 100%;
        margin-top: 30px;
    }

    .payment-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .payment-header-left {
        flex: 1;
        text-align: left;
    }

    .payment-header-right {
        flex: 1;
        text-align: center;
    }

    .payment-header h4 {
        color: #106c34;
        font-weight: bold;
        margin: 0;
        font-size: 12px;
    }


    .payment-method p, .payment-thanks p {
        font-weight: bold;
        font-size: 14px;
        margin-top: -5px;
        color: #2e7d32;
        margin-bottom: 0;
    }
    .account-manager p {
        font-weight: bold;
        font-size: 14px;
        margin-top: -5px;
        color: #999;
        margin-bottom: 0;
    }


    .remittance-info {
        margin-top: 40px;
        font-size: 11px;
        color: #333;
        font-weight: bold;
    }

    .separator {
        margin-top: 10px;
        border-bottom: 6px solid #106c34;
    }

    .green-header {
        background-color: #106c34 !important;
        color: white !important;
    }

    .invoice-table {
        margin-top: 3%;
        width: 100%;
        font-family: sans-serif;
        border-collapse: collapse;
        margin-bottom:2%;
    }

    /*    .total-due-cell {
        width: 50%;
        vertical-align: bottom;
        white-space: nowrap;
        padding: 10px;
    }*/

    .right-section {
        width: 50%;
        vertical-align: middle;
        text-align: right;
    }

    .details-table {
        width: 100%;
        text-align: right;
        border-collapse: collapse;
        font-family: "IBM Plex Sans", "Inconsolata Monospace", Calibri, "Open Sans", sans-serif;
    }

    .label {
        font-size: 14px;
        color: #888888;
        font-weight: bold;
        width:100px;
    }

    .details-label {
        color: black;
        text-align: left;
        font-size: 14px;
        width: 203px;
    }
    .details-label::after{
            content: ":";
            float: right;
    }
    .details-value {
        font-size: 14px;
    }

    .amount {
        color: black;
        font-size: 14px;
        padding-left: 25%;
    }

    .negative {
        color: red;
    }

    .spacer-row {
        height: 15px;
    }

    .total-due-cell {
        text-align: right;
    }
    .total-due-label {
        color: #888888;
        float: left;
        vertical-align: middle;
        line-height: 20px;
        font-size: 14px;
        font-weight: bold;
        width: 200px;
        text-align: left;
    }

        .total-due-label::after {
            content: ":";
            float: right;
        }

    .grand-total-cell {
        border: 2px solid black;
        padding: 5px;
        text-align: right;
    }



    .grand-total-label {
        color: black;
        float: left;
        vertical-align: middle;
        line-height: 20px;
        font-size: 14px;
        font-weight: bold;
        width: 200px;
        text-align: left;
    }
        .grand-total-label::after {
            content: ":";
            float: right;
        }


    .total-due-row {
        margin-bottom: 10px;
        vertical-align: middle;
    }

    .invoice-container {
        display: flex;
        justify-content: space-between;
        padding: 40px 0px 20px 0px;
        align-items: flex-start;
        width: 100%;
        color:#000;
    }

    .left-section {
        width: 30%;
    }

        .left-section h5,
        .left-section p:not(.recipient-name) {
            /*    color: black;
            font-size: 12px;*/
            margin-bottom: 0;
        }

    .recipient-name {
        font-weight: bold;
        font-size: 11px;
        margin-top: -5px;
        color: #2e7d32;
    }

    .empty-line {
        height: 50px;
        margin: 10px 0;
    }

    .input-right-align input {
        text-align: right !important;
    }

    .input-middle-align input {
        text-align: center !important;
    }

    .right-section {
        text-align: right;
        width: 65%;
        position: relative;
    }

        .right-section h1 {
            font-size: 36px;
            letter-spacing: 5px;
            color: #2e7d32;
            margin-bottom: 10px;
            margin-top: 0;
            font-weight: bold;
        }

    .invoice-details {
        margin-top: 15px;
        text-align: left;
        margin-left: auto;
        width: 200px;
        margin-right: 30px;
    }

        .invoice-details p {
            display: grid;
            grid-template-columns: 100px auto;
            margin-bottom:0;
        }

            .invoice-details p strong::after {
                content: ":";
                float: right;
            }

    /* .invoice-details p strong {
                text-align: left;
            }

            .invoice-details p span {
                text-align: right;
            }*/



    .domaincheckList.custom-table td {
        white-space: initial;
        vertical-align: middle;
    }

        .domaincheckList.custom-table td i {
            width: 12px;
            height: 12px;
            padding-top: 1px;
        }

    .agentDetail-Bg {
        background: #6f6bd6;
        border-radius: 10px;
    }

    .agentDetail {
        background: #d4d4f5;
        padding: 10px;
        border-radius: 10px;
        margin-bottom: 10px;
        font-size: 12px;
        justify-content: start;
        vertical-align: middle;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        position: relative;
    }


        .agentDetail .badge-primary {
            background: rgb(111, 107, 214);
            /*position: absolute;
            right: 5px;*/
            margin-left: auto;
        }

    .agentDetail-Bg .balance {
        color: #1bcff3;
    }

    .agentDetail-Bg .warningbalance {
        color: yellow;
        font-weight: 600;
    }

    .agentDetail-Bg .balanceflash {
        color: #ff4343 !important;
        -webkit-animation: ocBlinker 3s linear infinite;
        animation: ocBlinker 2s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;
        font-weight: 600;
    }

    .progressbar-text {
        position: absolute;
        left: 50%;
        top: 50%;
        padding: 0px;
        margin: 0px;
        transform: translate(-50%, -50%);
        color: rgb(0, 0, 0);
        font-size: .6rem;
        font-weight: bold;
    }



    .apexchart1 {
        min-height: 100px !important;
        padding: 0px;
        margin-left: -15px;
    }

    .apexcharts-canvas {
        float: left !important;
    }

    .apexcharts-inner, .apexcharts-legend {
        translate: 0px -20px;
    }

    .one-line {
        white-space: nowrap;
    }

    @media (max-width: 768px) {
        .apexcharts-canvas {
            float: none !important
        }

        .apexchart1 {
            margin-top: 0px;
            min-height: 100px !important;
        }
    }

    .total-due-grand-total-table {
        width: 100%;
        margin-top: 20px;
        font-family: "IBM Plex Sans", "Inconsolata Monospace", Calibri, "Open Sans", sans-serif;
        font-size:14px;
    }

    .draggable-row {
        display: table-row;
        width: 100%;
    }

    .wide-input {
        width: 150px;
    }
    .wide-input1 {
        width: 100%;
    }

    .wide-input1 {
        width:100%;
    }

    .input-with-clear {
        width: 100%;

        box-sizing: border-box;
    }

    .clear-button {
        background: transparent;
        border: none;
        cursor: pointer;
    }

    .statement-table.custom-table td {
        vertical-align: middle;
    }
    /*
    .prevFilterRecord > a + a:before {
        content: ", ";
    }*/



</style>



// WEBPACK FOOTER //
// src/components/SideMenu/AgentSetting/AgentDashboard.vue